// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"50\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wp-block-archives {
  box-sizing: border-box;
}

.wp-block-archives-dropdown label {
  display: block;
}

.wp-block-avatar {
  line-height: 0;
}

.wp-block-avatar,
.wp-block-avatar img {
  box-sizing: border-box;
}

.wp-block-avatar.aligncenter {
  text-align: center;
}

.wp-block-audio {
  box-sizing: border-box;
}

.wp-block-audio figcaption {
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.wp-block-audio audio {
  min-width: 300px;
  width: 100%;
}

.wp-block-button__link {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  word-break: break-word;
}

.wp-block-button__link.aligncenter {
  text-align: center;
}

.wp-block-button__link.alignright {
  text-align: right;
}

:where(.wp-block-button__link) {
  border-radius: 9999px;
  box-shadow: none;
  padding: calc(0.667em + 2px) calc(1.333em + 2px);
  text-decoration: none;
}

.wp-block-button[style*="text-decoration"] .wp-block-button__link {
  text-decoration: inherit;
}

.wp-block-buttons > .wp-block-button.has-custom-width {
  max-width: none;
}

.wp-block-buttons > .wp-block-button.has-custom-width .wp-block-button__link {
  width: 100%;
}

.wp-block-buttons
  > .wp-block-button.has-custom-font-size
  .wp-block-button__link {
  font-size: inherit;
}

.wp-block-buttons > .wp-block-button.wp-block-button__width-25 {
  width: calc(25% - var(--wp--style--block-gap, 0.5em) * 0.75);
}

.wp-block-buttons > .wp-block-button.wp-block-button__width-50 {
  width: calc(50% - var(--wp--style--block-gap, 0.5em) * 0.5);
}

.wp-block-buttons > .wp-block-button.wp-block-button__width-75 {
  width: calc(75% - var(--wp--style--block-gap, 0.5em) * 0.25);
}

.wp-block-buttons > .wp-block-button.wp-block-button__width-100 {
  flex-basis: 100%;
  width: 100%;
}

.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-25 {
  width: 25%;
}

.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-50 {
  width: 50%;
}

.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-75 {
  width: 75%;
}

.wp-block-button.is-style-squared,
.wp-block-button__link.wp-block-button.is-style-squared {
  border-radius: 0;
}

.wp-block-button.no-border-radius,
.wp-block-button__link.no-border-radius {
  border-radius: 0 !important;
}

.wp-block-button .wp-block-button__link:where(.is-style-outline),
.wp-block-button:where(.is-style-outline) > .wp-block-button__link {
  border: 2px solid;
  padding: 0.667em 1.333em;
}

.wp-block-button
  .wp-block-button__link:where(.is-style-outline):not(.has-text-color),
.wp-block-button:where(.is-style-outline)
  > .wp-block-button__link:not(.has-text-color) {
  color: currentColor;
}

.wp-block-button
  .wp-block-button__link:where(.is-style-outline):not(.has-background),
.wp-block-button:where(.is-style-outline)
  > .wp-block-button__link:not(.has-background) {
  background-color: initial;
  background-image: none;
}

.wp-block-button .wp-block-button__link:where(.has-border-color) {
  border-width: initial;
}

.wp-block-button .wp-block-button__link:where([style*="border-top-color"]) {
  border-top-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-right-color"]) {
  border-right-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-bottom-color"]) {
  border-bottom-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-left-color"]) {
  border-left-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-style"]) {
  border-width: initial;
}

.wp-block-button .wp-block-button__link:where([style*="border-top-style"]) {
  border-top-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-right-style"]) {
  border-right-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-bottom-style"]) {
  border-bottom-width: medium;
}

.wp-block-button .wp-block-button__link:where([style*="border-left-style"]) {
  border-left-width: medium;
}

.wp-block-buttons.is-vertical {
  flex-direction: column;
}

.wp-block-buttons.is-vertical > .wp-block-button:last-child {
  margin-bottom: 0;
}

.wp-block-buttons > .wp-block-button {
  display: inline-block;
  margin: 0;
}

.wp-block-buttons.is-content-justification-left {
  justify-content: flex-start;
}

.wp-block-buttons.is-content-justification-left.is-vertical {
  align-items: flex-start;
}

.wp-block-buttons.is-content-justification-center {
  justify-content: center;
}

.wp-block-buttons.is-content-justification-center.is-vertical {
  align-items: center;
}

.wp-block-buttons.is-content-justification-right {
  justify-content: flex-end;
}

.wp-block-buttons.is-content-justification-right.is-vertical {
  align-items: flex-end;
}

.wp-block-buttons.is-content-justification-space-between {
  justify-content: space-between;
}

.wp-block-buttons.aligncenter {
  text-align: center;
}

.wp-block-buttons:not(
    .is-content-justification-space-between,
    .is-content-justification-right,
    .is-content-justification-left,
    .is-content-justification-center
  )
  .wp-block-button.aligncenter {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.wp-block-buttons[style*="text-decoration"] .wp-block-button,
.wp-block-buttons[style*="text-decoration"] .wp-block-button__link {
  text-decoration: inherit;
}

.wp-block-buttons.has-custom-font-size .wp-block-button__link {
  font-size: inherit;
}

.wp-block-button.aligncenter,
.wp-block-calendar {
  text-align: center;
}

.wp-block-calendar td,
.wp-block-calendar th {
  border: 1px solid;
  padding: 0.25em;
}

.wp-block-calendar th {
  font-weight: 400;
}

.wp-block-calendar caption {
  background-color: inherit;
}

.wp-block-calendar table {
  border-collapse: collapse;
  width: 100%;
}

.wp-block-calendar table:where(:not(.has-text-color)) {
  color: #40464d;
}

.wp-block-calendar table:where(:not(.has-text-color)) td,
.wp-block-calendar table:where(:not(.has-text-color)) th {
  border-color: #ddd;
}

.wp-block-calendar table.has-background th {
  background-color: inherit;
}

.wp-block-calendar table.has-text-color th {
  color: inherit;
}

:where(.wp-block-calendar table:not(.has-background) th) {
  background: #ddd;
}

.wp-block-categories {
  box-sizing: border-box;
}

.wp-block-categories.alignleft {
  margin-right: 2em;
}

.wp-block-categories.alignright {
  margin-left: 2em;
}

.wp-block-categories.wp-block-categories-dropdown.aligncenter {
  text-align: center;
}

.wp-block-code {
  box-sizing: border-box;
}

.wp-block-code code {
  display: block;
  font-family: inherit;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.wp-block-columns {
  align-items: normal !important;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap !important;
}

@media (min-width: 782px) {
  .wp-block-columns {
    flex-wrap: nowrap !important;
  }
}

.wp-block-columns.are-vertically-aligned-top {
  align-items: flex-start;
}

.wp-block-columns.are-vertically-aligned-center {
  align-items: center;
}

.wp-block-columns.are-vertically-aligned-bottom {
  align-items: flex-end;
}

@media (max-width: 781px) {
  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {
    flex-basis: 100% !important;
  }
}

@media (min-width: 782px) {
  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {
    flex-basis: 0;
    flex-grow: 1;
  }

  .wp-block-columns:not(.is-not-stacked-on-mobile)
    > .wp-block-column[style*="flex-basis"] {
    flex-grow: 0;
  }
}

.wp-block-columns.is-not-stacked-on-mobile {
  flex-wrap: nowrap !important;
}

.wp-block-columns.is-not-stacked-on-mobile > .wp-block-column {
  flex-basis: 0;
  flex-grow: 1;
}

.wp-block-columns.is-not-stacked-on-mobile
  > .wp-block-column[style*="flex-basis"] {
  flex-grow: 0;
}

:where(.wp-block-columns) {
  margin-bottom: 1.75em;
}

:where(.wp-block-columns.has-background) {
  padding: 1.25em 2.375em;
}

.wp-block-column {
  flex-grow: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.wp-block-column.is-vertically-aligned-top {
  align-self: flex-start;
}

.wp-block-column.is-vertically-aligned-center {
  align-self: center;
}

.wp-block-column.is-vertically-aligned-bottom {
  align-self: flex-end;
}

.wp-block-column.is-vertically-aligned-stretch {
  align-self: stretch;
}

.wp-block-column.is-vertically-aligned-bottom,
.wp-block-column.is-vertically-aligned-center,
.wp-block-column.is-vertically-aligned-top {
  width: 100%;
}

.wp-block-post-comments {
  box-sizing: border-box;
}

.wp-block-post-comments .alignleft {
  float: left;
}

.wp-block-post-comments .alignright {
  float: right;
}

.wp-block-post-comments .navigation:after {
  clear: both;
  content: "";
  display: table;
}

.wp-block-post-comments .commentlist {
  clear: both;
  list-style: none;
  margin: 0;
  padding: 0;
}

.wp-block-post-comments .commentlist .comment {
  min-height: 2.25em;
  padding-left: 3.25em;
}

.wp-block-post-comments .commentlist .comment p {
  font-size: 1em;
  line-height: 1.8;
  margin: 1em 0;
}

.wp-block-post-comments .commentlist .children {
  list-style: none;
  margin: 0;
  padding: 0;
}

.wp-block-post-comments .comment-author {
  line-height: 1.5;
}

.wp-block-post-comments .comment-author .avatar {
  border-radius: 1.5em;
  display: block;
  float: left;
  height: 2.5em;
  margin-right: 0.75em;
  margin-top: 0.5em;
  width: 2.5em;
}

.wp-block-post-comments .comment-author cite {
  font-style: normal;
}

.wp-block-post-comments .comment-meta {
  font-size: 0.875em;
  line-height: 1.5;
}

.wp-block-post-comments .comment-meta b {
  font-weight: 400;
}

.wp-block-post-comments .comment-meta .comment-awaiting-moderation {
  display: block;
  margin-bottom: 1em;
  margin-top: 1em;
}

.wp-block-post-comments .comment-body .commentmetadata {
  font-size: 0.875em;
}

.wp-block-post-comments .comment-form-author label,
.wp-block-post-comments .comment-form-comment label,
.wp-block-post-comments .comment-form-email label,
.wp-block-post-comments .comment-form-url label {
  display: block;
  margin-bottom: 0.25em;
}

.wp-block-post-comments
  .comment-form
  input:not([type="submit"]):not([type="checkbox"]),
.wp-block-post-comments .comment-form textarea {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

.wp-block-post-comments .comment-form-cookies-consent {
  display: flex;
  gap: 0.25em;
}

.wp-block-post-comments
  .comment-form-cookies-consent
  #wp-comment-cookies-consent {
  margin-top: 0.35em;
}

.wp-block-post-comments .comment-reply-title {
  margin-bottom: 0;
}

.wp-block-post-comments .comment-reply-title :where(small) {
  font-size: var(--wp--preset--font-size--medium, smaller);
  margin-left: 0.5em;
}

.wp-block-post-comments .reply {
  font-size: 0.875em;
  margin-bottom: 1.4em;
}

.wp-block-post-comments input:not([type="submit"]),
.wp-block-post-comments textarea {
  border: 1px solid #949494;
  font-family: inherit;
  font-size: 1em;
}

.wp-block-post-comments input:not([type="submit"]):not([type="checkbox"]),
.wp-block-post-comments textarea {
  padding: calc(0.667em + 2px);
}

:where(.wp-block-post-comments input[type="submit"]) {
  border: none;
}

.wp-block-comments-pagination > .wp-block-comments-pagination-next,
.wp-block-comments-pagination > .wp-block-comments-pagination-numbers,
.wp-block-comments-pagination > .wp-block-comments-pagination-previous {
  margin-bottom: 0.5em;
  margin-right: 0.5em;
}

.wp-block-comments-pagination > .wp-block-comments-pagination-next:last-child,
.wp-block-comments-pagination
  > .wp-block-comments-pagination-numbers:last-child,
.wp-block-comments-pagination
  > .wp-block-comments-pagination-previous:last-child {
  margin-right: 0;
}

.wp-block-comments-pagination .wp-block-comments-pagination-previous-arrow {
  display: inline-block;
  margin-right: 1ch;
}

.wp-block-comments-pagination
  .wp-block-comments-pagination-previous-arrow:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-comments-pagination .wp-block-comments-pagination-next-arrow {
  display: inline-block;
  margin-left: 1ch;
}

.wp-block-comments-pagination
  .wp-block-comments-pagination-next-arrow:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-comments-pagination.aligncenter {
  justify-content: center;
}

.wp-block-comment-template {
  box-sizing: border-box;
  list-style: none;
  margin-bottom: 0;
  max-width: 100%;
  padding: 0;
}

.wp-block-comment-template li {
  clear: both;
}

.wp-block-comment-template ol {
  list-style: none;
  margin-bottom: 0;
  max-width: 100%;
  padding-left: 2rem;
}

.wp-block-comment-template.alignleft {
  float: left;
}

.wp-block-comment-template.aligncenter {
  margin-left: auto;
  margin-right: auto;
  width: -moz-fit-content;
  width: fit-content;
}

.wp-block-comment-template.alignright {
  float: right;
}

.wp-block-cover,
.wp-block-cover-image {
  align-items: center;
  background-position: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-height: 430px;
  overflow: hidden;
  overflow: clip;
  padding: 1em;
  position: relative;
}

.wp-block-cover .has-background-dim:not([class*="-background-color"]),
.wp-block-cover-image .has-background-dim:not([class*="-background-color"]),
.wp-block-cover-image.has-background-dim:not([class*="-background-color"]),
.wp-block-cover.has-background-dim:not([class*="-background-color"]) {
  background-color: #000;
}

.wp-block-cover .has-background-dim.has-background-gradient,
.wp-block-cover-image .has-background-dim.has-background-gradient {
  background-color: initial;
}

.wp-block-cover-image.has-background-dim:before,
.wp-block-cover.has-background-dim:before {
  background-color: inherit;
  content: "";
}

.wp-block-cover .wp-block-cover__background,
.wp-block-cover .wp-block-cover__gradient-background,
.wp-block-cover-image .wp-block-cover__background,
.wp-block-cover-image .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim:not(.has-background-gradient):before,
.wp-block-cover.has-background-dim:not(.has-background-gradient):before {
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.wp-block-cover-image.has-background-dim.has-background-dim-10
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-10
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-10:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-10
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-10
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-10:not(
    .has-background-gradient
  ):before {
  opacity: 0.1;
}

.wp-block-cover-image.has-background-dim.has-background-dim-20
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-20
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-20:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-20
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-20
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-20:not(
    .has-background-gradient
  ):before {
  opacity: 0.2;
}

.wp-block-cover-image.has-background-dim.has-background-dim-30
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-30
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-30:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-30
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-30
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-30:not(
    .has-background-gradient
  ):before {
  opacity: 0.3;
}

.wp-block-cover-image.has-background-dim.has-background-dim-40
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-40
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-40:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-40
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-40
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-40:not(
    .has-background-gradient
  ):before {
  opacity: 0.4;
}

.wp-block-cover-image.has-background-dim.has-background-dim-50
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-50
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-50:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-50
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-50
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-50:not(
    .has-background-gradient
  ):before {
  opacity: 0.5;
}

.wp-block-cover-image.has-background-dim.has-background-dim-60
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-60
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-60:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-60
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-60
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-60:not(
    .has-background-gradient
  ):before {
  opacity: 0.6;
}

.wp-block-cover-image.has-background-dim.has-background-dim-70
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-70
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-70:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-70
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-70
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-70:not(
    .has-background-gradient
  ):before {
  opacity: 0.7;
}

.wp-block-cover-image.has-background-dim.has-background-dim-80
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-80
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-80:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-80
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-80
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-80:not(
    .has-background-gradient
  ):before {
  opacity: 0.8;
}

.wp-block-cover-image.has-background-dim.has-background-dim-90
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-90
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-90:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-90
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-90
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-90:not(
    .has-background-gradient
  ):before {
  opacity: 0.9;
}

.wp-block-cover-image.has-background-dim.has-background-dim-100
  .wp-block-cover__background,
.wp-block-cover-image.has-background-dim.has-background-dim-100
  .wp-block-cover__gradient-background,
.wp-block-cover-image.has-background-dim.has-background-dim-100:not(
    .has-background-gradient
  ):before,
.wp-block-cover.has-background-dim.has-background-dim-100
  .wp-block-cover__background,
.wp-block-cover.has-background-dim.has-background-dim-100
  .wp-block-cover__gradient-background,
.wp-block-cover.has-background-dim.has-background-dim-100:not(
    .has-background-gradient
  ):before {
  opacity: 1;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-0,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-0,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-0,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-0 {
  opacity: 0;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-10,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-10,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-10,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-10 {
  opacity: 0.1;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-20,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-20,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-20,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-20 {
  opacity: 0.2;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-30,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-30,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-30,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-30 {
  opacity: 0.3;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-40,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-40,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-40,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-40 {
  opacity: 0.4;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-50,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-50,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-50,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-50 {
  opacity: 0.5;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-60,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-60,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-60,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-60 {
  opacity: 0.6;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-70,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-70,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-70,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-70 {
  opacity: 0.7;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-80,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-80,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-80,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-80 {
  opacity: 0.8;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-90,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-90,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-90,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-90 {
  opacity: 0.9;
}

.wp-block-cover
  .wp-block-cover__background.has-background-dim.has-background-dim-100,
.wp-block-cover
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-100,
.wp-block-cover-image
  .wp-block-cover__background.has-background-dim.has-background-dim-100,
.wp-block-cover-image
  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-100 {
  opacity: 1;
}

.wp-block-cover-image.alignleft,
.wp-block-cover-image.alignright,
.wp-block-cover.alignleft,
.wp-block-cover.alignright {
  max-width: 420px;
  width: 100%;
}

.wp-block-cover-image:after,
.wp-block-cover:after {
  content: "";
  display: block;
  font-size: 0;
  min-height: inherit;
}

@supports (position: sticky) {
  .wp-block-cover-image:after,
  .wp-block-cover:after {
    content: none;
  }
}

.wp-block-cover-image.aligncenter,
.wp-block-cover-image.alignleft,
.wp-block-cover-image.alignright,
.wp-block-cover.aligncenter,
.wp-block-cover.alignleft,
.wp-block-cover.alignright {
  display: flex;
}

.wp-block-cover .wp-block-cover__inner-container,
.wp-block-cover-image .wp-block-cover__inner-container {
  color: inherit;
  width: 100%;
  z-index: 1;
}

.wp-block-cover h1:where(:not(.has-text-color)),
.wp-block-cover h2:where(:not(.has-text-color)),
.wp-block-cover h3:where(:not(.has-text-color)),
.wp-block-cover h4:where(:not(.has-text-color)),
.wp-block-cover h5:where(:not(.has-text-color)),
.wp-block-cover h6:where(:not(.has-text-color)),
.wp-block-cover p:where(:not(.has-text-color)),
.wp-block-cover-image h1:where(:not(.has-text-color)),
.wp-block-cover-image h2:where(:not(.has-text-color)),
.wp-block-cover-image h3:where(:not(.has-text-color)),
.wp-block-cover-image h4:where(:not(.has-text-color)),
.wp-block-cover-image h5:where(:not(.has-text-color)),
.wp-block-cover-image h6:where(:not(.has-text-color)),
.wp-block-cover-image p:where(:not(.has-text-color)) {
  color: inherit;
}

.wp-block-cover-image.is-position-top-left,
.wp-block-cover.is-position-top-left {
  align-items: flex-start;
  justify-content: flex-start;
}

.wp-block-cover-image.is-position-top-center,
.wp-block-cover.is-position-top-center {
  align-items: flex-start;
  justify-content: center;
}

.wp-block-cover-image.is-position-top-right,
.wp-block-cover.is-position-top-right {
  align-items: flex-start;
  justify-content: flex-end;
}

.wp-block-cover-image.is-position-center-left,
.wp-block-cover.is-position-center-left {
  align-items: center;
  justify-content: flex-start;
}

.wp-block-cover-image.is-position-center-center,
.wp-block-cover.is-position-center-center {
  align-items: center;
  justify-content: center;
}

.wp-block-cover-image.is-position-center-right,
.wp-block-cover.is-position-center-right {
  align-items: center;
  justify-content: flex-end;
}

.wp-block-cover-image.is-position-bottom-left,
.wp-block-cover.is-position-bottom-left {
  align-items: flex-end;
  justify-content: flex-start;
}

.wp-block-cover-image.is-position-bottom-center,
.wp-block-cover.is-position-bottom-center {
  align-items: flex-end;
  justify-content: center;
}

.wp-block-cover-image.is-position-bottom-right,
.wp-block-cover.is-position-bottom-right {
  align-items: flex-end;
  justify-content: flex-end;
}

.wp-block-cover-image.has-custom-content-position.has-custom-content-position
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position
  .wp-block-cover__inner-container {
  margin: 0;
}

.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-bottom-left
  .wp-block-cover__inner-container,
.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-bottom-right
  .wp-block-cover__inner-container,
.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-center-left
  .wp-block-cover__inner-container,
.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-center-right
  .wp-block-cover__inner-container,
.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-top-left
  .wp-block-cover__inner-container,
.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-top-right
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-bottom-left
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-bottom-right
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-center-left
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-center-right
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-top-left
  .wp-block-cover__inner-container,
.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-top-right
  .wp-block-cover__inner-container {
  margin: 0;
  width: auto;
}

.wp-block-cover .wp-block-cover__image-background,
.wp-block-cover video.wp-block-cover__video-background,
.wp-block-cover-image .wp-block-cover__image-background,
.wp-block-cover-image video.wp-block-cover__video-background {
  border: none;
  bottom: 0;
  box-shadow: none;
  height: 100%;
  left: 0;
  margin: 0;
  max-height: none;
  max-width: none;
  object-fit: cover;
  outline: none;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

.wp-block-cover-image.has-parallax,
.wp-block-cover.has-parallax,
.wp-block-cover__image-background.has-parallax,
video.wp-block-cover__video-background.has-parallax {
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

@supports (-webkit-touch-callout: inherit) {
  .wp-block-cover-image.has-parallax,
  .wp-block-cover.has-parallax,
  .wp-block-cover__image-background.has-parallax,
  video.wp-block-cover__video-background.has-parallax {
    background-attachment: scroll;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wp-block-cover-image.has-parallax,
  .wp-block-cover.has-parallax,
  .wp-block-cover__image-background.has-parallax,
  video.wp-block-cover__video-background.has-parallax {
    background-attachment: scroll;
  }
}

.wp-block-cover-image.is-repeated,
.wp-block-cover.is-repeated,
.wp-block-cover__image-background.is-repeated,
video.wp-block-cover__video-background.is-repeated {
  background-repeat: repeat;
  background-size: auto;
}

.wp-block-cover__image-background,
.wp-block-cover__video-background {
  z-index: 0;
}

.wp-block-cover-image-text,
.wp-block-cover-image-text a,
.wp-block-cover-image-text a:active,
.wp-block-cover-image-text a:focus,
.wp-block-cover-image-text a:hover,
.wp-block-cover-text,
.wp-block-cover-text a,
.wp-block-cover-text a:active,
.wp-block-cover-text a:focus,
.wp-block-cover-text a:hover,
section.wp-block-cover-image h2,
section.wp-block-cover-image h2 a,
section.wp-block-cover-image h2 a:active,
section.wp-block-cover-image h2 a:focus,
section.wp-block-cover-image h2 a:hover {
  color: #fff;
}

.wp-block-cover-image .wp-block-cover.has-left-content {
  justify-content: flex-start;
}

.wp-block-cover-image .wp-block-cover.has-right-content {
  justify-content: flex-end;
}

.wp-block-cover-image.has-left-content .wp-block-cover-image-text,
.wp-block-cover.has-left-content .wp-block-cover-text,
section.wp-block-cover-image.has-left-content > h2 {
  margin-left: 0;
  text-align: left;
}

.wp-block-cover-image.has-right-content .wp-block-cover-image-text,
.wp-block-cover.has-right-content .wp-block-cover-text,
section.wp-block-cover-image.has-right-content > h2 {
  margin-right: 0;
  text-align: right;
}

.wp-block-cover .wp-block-cover-text,
.wp-block-cover-image .wp-block-cover-image-text,
section.wp-block-cover-image > h2 {
  font-size: 2em;
  line-height: 1.25;
  margin-bottom: 0;
  max-width: 840px;
  padding: 0.44em;
  text-align: center;
  z-index: 1;
}

:where(.wp-block-cover-image:not(.has-text-color)),
:where(.wp-block-cover:not(.has-text-color)) {
  color: #fff;
}

:where(.wp-block-cover-image.is-light:not(.has-text-color)),
:where(.wp-block-cover.is-light:not(.has-text-color)) {
  color: #000;
}

.wp-block-details {
  box-sizing: border-box;
  overflow: hidden;
}

.wp-block-details summary {
  cursor: pointer;
}

.wp-block-embed.alignleft,
.wp-block-embed.alignright,
.wp-block[data-align="left"] > [data-type="core/embed"],
.wp-block[data-align="right"] > [data-type="core/embed"] {
  max-width: 360px;
  width: 100%;
}

.wp-block-embed.alignleft .wp-block-embed__wrapper,
.wp-block-embed.alignright .wp-block-embed__wrapper,
.wp-block[data-align="left"]
  > [data-type="core/embed"]
  .wp-block-embed__wrapper,
.wp-block[data-align="right"]
  > [data-type="core/embed"]
  .wp-block-embed__wrapper {
  min-width: 280px;
}

.wp-block-cover .wp-block-embed {
  min-height: 240px;
  min-width: 320px;
}

.wp-block-embed {
  overflow-wrap: break-word;
}

.wp-block-embed figcaption {
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.wp-block-embed iframe {
  max-width: 100%;
}

.wp-block-embed__wrapper {
  position: relative;
}

.wp-embed-responsive .wp-has-aspect-ratio .wp-block-embed__wrapper:before {
  content: "";
  display: block;
  padding-top: 50%;
}

.wp-embed-responsive .wp-has-aspect-ratio iframe {
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

.wp-embed-responsive .wp-embed-aspect-21-9 .wp-block-embed__wrapper:before {
  padding-top: 42.85%;
}

.wp-embed-responsive .wp-embed-aspect-18-9 .wp-block-embed__wrapper:before {
  padding-top: 50%;
}

.wp-embed-responsive .wp-embed-aspect-16-9 .wp-block-embed__wrapper:before {
  padding-top: 56.25%;
}

.wp-embed-responsive .wp-embed-aspect-4-3 .wp-block-embed__wrapper:before {
  padding-top: 75%;
}

.wp-embed-responsive .wp-embed-aspect-1-1 .wp-block-embed__wrapper:before {
  padding-top: 100%;
}

.wp-embed-responsive .wp-embed-aspect-9-16 .wp-block-embed__wrapper:before {
  padding-top: 177.77%;
}

.wp-embed-responsive .wp-embed-aspect-1-2 .wp-block-embed__wrapper:before {
  padding-top: 200%;
}

.wp-block-file {
  box-sizing: border-box;
}

.wp-block-file:not(.wp-element-button) {
  font-size: 0.8em;
}

.wp-block-file.aligncenter {
  text-align: center;
}

.wp-block-file.alignright {
  text-align: right;
}

.wp-block-file * + .wp-block-file__button {
  margin-left: 0.75em;
}

:where(.wp-block-file) {
  margin-bottom: 1.5em;
}

.wp-block-file__embed {
  margin-bottom: 1em;
}

:where(.wp-block-file__button) {
  border-radius: 2em;
  display: inline-block;
  padding: 0.5em 1em;
}

:where(.wp-block-file__button):is(a):active,
:where(.wp-block-file__button):is(a):focus,
:where(.wp-block-file__button):is(a):hover,
:where(.wp-block-file__button):is(a):visited {
  box-shadow: none;
  color: #fff;
  opacity: 0.85;
  text-decoration: none;
}

.wp-block-form-input__label {
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  margin-bottom: 0.5em;
  width: 100%;
}

.wp-block-form-input__label.is-label-inline {
  align-items: center;
  flex-direction: row;
  gap: 0.5em;
}

.wp-block-form-input__label.is-label-inline
  .wp-block-form-input__label-content {
  margin-bottom: 0.5em;
}

.wp-block-form-input__label:has(input[type="checkbox"]) {
  flex-direction: row-reverse;
  width: -moz-fit-content;
  width: fit-content;
}

.wp-block-form-input__label-content {
  width: -moz-fit-content;
  width: fit-content;
}

.wp-block-form-input__input {
  font-size: 1em;
  margin-bottom: 0.5em;
  padding: 0 0.5em;
}

.wp-block-form-input__input[type="date"],
.wp-block-form-input__input[type="datetime-local"],
.wp-block-form-input__input[type="datetime"],
.wp-block-form-input__input[type="email"],
.wp-block-form-input__input[type="month"],
.wp-block-form-input__input[type="number"],
.wp-block-form-input__input[type="password"],
.wp-block-form-input__input[type="search"],
.wp-block-form-input__input[type="tel"],
.wp-block-form-input__input[type="text"],
.wp-block-form-input__input[type="time"],
.wp-block-form-input__input[type="url"],
.wp-block-form-input__input[type="week"] {
  border: 1px solid;
  line-height: 2;
  min-height: 2em;
}

textarea.wp-block-form-input__input {
  min-height: 10em;
}

.blocks-gallery-grid:not(.has-nested-images),
.wp-block-gallery:not(.has-nested-images) {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image,
.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin: 0 1em 1em 0;
  position: relative;
  width: calc(50% - 1em);
}

.blocks-gallery-grid:not(.has-nested-images)
  .blocks-gallery-image:nth-of-type(2n),
.blocks-gallery-grid:not(.has-nested-images)
  .blocks-gallery-item:nth-of-type(2n),
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image:nth-of-type(2n),
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item:nth-of-type(2n) {
  margin-right: 0;
}

.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image figure,
.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item figure,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figure,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figure {
  align-items: flex-end;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  margin: 0;
}

.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image img,
.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item img,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image img,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item img {
  display: block;
  height: auto;
  max-width: 100%;
  width: auto;
}

.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image figcaption,
.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item figcaption,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figcaption,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figcaption {
  background: linear-gradient(0deg, #000000b3, #0000004d 70%, #0000);
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  font-size: 0.8em;
  margin: 0;
  max-height: 100%;
  overflow: auto;
  padding: 3em 0.77em 0.7em;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 2;
}

.blocks-gallery-grid:not(.has-nested-images)
  .blocks-gallery-image
  figcaption
  img,
.blocks-gallery-grid:not(.has-nested-images)
  .blocks-gallery-item
  figcaption
  img,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figcaption img,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figcaption img {
  display: inline;
}

.blocks-gallery-grid:not(.has-nested-images) figcaption,
.wp-block-gallery:not(.has-nested-images) figcaption {
  flex-grow: 1;
}

.blocks-gallery-grid:not(.has-nested-images).is-cropped .blocks-gallery-image a,
.blocks-gallery-grid:not(.has-nested-images).is-cropped
  .blocks-gallery-image
  img,
.blocks-gallery-grid:not(.has-nested-images).is-cropped .blocks-gallery-item a,
.blocks-gallery-grid:not(.has-nested-images).is-cropped
  .blocks-gallery-item
  img,
.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-image a,
.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-image img,
.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-item a,
.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-item img {
  flex: 1;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.blocks-gallery-grid:not(.has-nested-images).columns-1 .blocks-gallery-image,
.blocks-gallery-grid:not(.has-nested-images).columns-1 .blocks-gallery-item,
.wp-block-gallery:not(.has-nested-images).columns-1 .blocks-gallery-image,
.wp-block-gallery:not(.has-nested-images).columns-1 .blocks-gallery-item {
  margin-right: 0;
  width: 100%;
}

@media (min-width: 600px) {
  .blocks-gallery-grid:not(.has-nested-images).columns-3 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-3 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-3 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-3 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(33.33333% - 0.66667em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-4 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-4 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-4 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-4 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(25% - 0.75em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-5 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-5 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-5 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-5 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(20% - 0.8em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-6 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-6 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-6 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-6 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(16.66667% - 0.83333em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-7 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-7 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-7 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-7 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(14.28571% - 0.85714em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-8 .blocks-gallery-image,
  .blocks-gallery-grid:not(.has-nested-images).columns-8 .blocks-gallery-item,
  .wp-block-gallery:not(.has-nested-images).columns-8 .blocks-gallery-image,
  .wp-block-gallery:not(.has-nested-images).columns-8 .blocks-gallery-item {
    margin-right: 1em;
    width: calc(12.5% - 0.875em);
  }

  .blocks-gallery-grid:not(.has-nested-images).columns-1
    .blocks-gallery-image:nth-of-type(1n),
  .blocks-gallery-grid:not(.has-nested-images).columns-1
    .blocks-gallery-item:nth-of-type(1n),
  .blocks-gallery-grid:not(.has-nested-images).columns-2
    .blocks-gallery-image:nth-of-type(2n),
  .blocks-gallery-grid:not(.has-nested-images).columns-2
    .blocks-gallery-item:nth-of-type(2n),
  .blocks-gallery-grid:not(.has-nested-images).columns-3
    .blocks-gallery-image:nth-of-type(3n),
  .blocks-gallery-grid:not(.has-nested-images).columns-3
    .blocks-gallery-item:nth-of-type(3n),
  .blocks-gallery-grid:not(.has-nested-images).columns-4
    .blocks-gallery-image:nth-of-type(4n),
  .blocks-gallery-grid:not(.has-nested-images).columns-4
    .blocks-gallery-item:nth-of-type(4n),
  .blocks-gallery-grid:not(.has-nested-images).columns-5
    .blocks-gallery-image:nth-of-type(5n),
  .blocks-gallery-grid:not(.has-nested-images).columns-5
    .blocks-gallery-item:nth-of-type(5n),
  .blocks-gallery-grid:not(.has-nested-images).columns-6
    .blocks-gallery-image:nth-of-type(6n),
  .blocks-gallery-grid:not(.has-nested-images).columns-6
    .blocks-gallery-item:nth-of-type(6n),
  .blocks-gallery-grid:not(.has-nested-images).columns-7
    .blocks-gallery-image:nth-of-type(7n),
  .blocks-gallery-grid:not(.has-nested-images).columns-7
    .blocks-gallery-item:nth-of-type(7n),
  .blocks-gallery-grid:not(.has-nested-images).columns-8
    .blocks-gallery-image:nth-of-type(8n),
  .blocks-gallery-grid:not(.has-nested-images).columns-8
    .blocks-gallery-item:nth-of-type(8n),
  .wp-block-gallery:not(.has-nested-images).columns-1
    .blocks-gallery-image:nth-of-type(1n),
  .wp-block-gallery:not(.has-nested-images).columns-1
    .blocks-gallery-item:nth-of-type(1n),
  .wp-block-gallery:not(.has-nested-images).columns-2
    .blocks-gallery-image:nth-of-type(2n),
  .wp-block-gallery:not(.has-nested-images).columns-2
    .blocks-gallery-item:nth-of-type(2n),
  .wp-block-gallery:not(.has-nested-images).columns-3
    .blocks-gallery-image:nth-of-type(3n),
  .wp-block-gallery:not(.has-nested-images).columns-3
    .blocks-gallery-item:nth-of-type(3n),
  .wp-block-gallery:not(.has-nested-images).columns-4
    .blocks-gallery-image:nth-of-type(4n),
  .wp-block-gallery:not(.has-nested-images).columns-4
    .blocks-gallery-item:nth-of-type(4n),
  .wp-block-gallery:not(.has-nested-images).columns-5
    .blocks-gallery-image:nth-of-type(5n),
  .wp-block-gallery:not(.has-nested-images).columns-5
    .blocks-gallery-item:nth-of-type(5n),
  .wp-block-gallery:not(.has-nested-images).columns-6
    .blocks-gallery-image:nth-of-type(6n),
  .wp-block-gallery:not(.has-nested-images).columns-6
    .blocks-gallery-item:nth-of-type(6n),
  .wp-block-gallery:not(.has-nested-images).columns-7
    .blocks-gallery-image:nth-of-type(7n),
  .wp-block-gallery:not(.has-nested-images).columns-7
    .blocks-gallery-item:nth-of-type(7n),
  .wp-block-gallery:not(.has-nested-images).columns-8
    .blocks-gallery-image:nth-of-type(8n),
  .wp-block-gallery:not(.has-nested-images).columns-8
    .blocks-gallery-item:nth-of-type(8n) {
    margin-right: 0;
  }
}

.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image:last-child,
.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item:last-child,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image:last-child,
.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item:last-child {
  margin-right: 0;
}

.blocks-gallery-grid:not(.has-nested-images).alignleft,
.blocks-gallery-grid:not(.has-nested-images).alignright,
.wp-block-gallery:not(.has-nested-images).alignleft,
.wp-block-gallery:not(.has-nested-images).alignright {
  max-width: 420px;
  width: 100%;
}

.blocks-gallery-grid:not(.has-nested-images).aligncenter
  .blocks-gallery-item
  figure,
.wp-block-gallery:not(.has-nested-images).aligncenter
  .blocks-gallery-item
  figure {
  justify-content: center;
}

.wp-block-gallery:not(.is-cropped) .blocks-gallery-item {
  align-self: flex-start;
}

figure.wp-block-gallery.has-nested-images {
  align-items: normal;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image:not(#individual-image) {
  margin: 0;
  width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) / 2);
}

.wp-block-gallery.has-nested-images figure.wp-block-image {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  max-width: 100%;
  position: relative;
}

.wp-block-gallery.has-nested-images figure.wp-block-image > a,
.wp-block-gallery.has-nested-images figure.wp-block-image > div {
  flex-direction: column;
  flex-grow: 1;
  margin: 0;
}

.wp-block-gallery.has-nested-images figure.wp-block-image img {
  display: block;
  height: auto;
  max-width: 100% !important;
  width: auto;
}

.wp-block-gallery.has-nested-images figure.wp-block-image figcaption {
  background: linear-gradient(0deg, #000000b3, #0000004d 70%, #0000);
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  font-size: 13px;
  left: 0;
  margin-bottom: 0;
  max-height: 60%;
  overflow: auto;
  padding: 0 8px 8px;
  position: absolute;
  scrollbar-color: #0000 #0000;
  scrollbar-gutter: stable both-edges;
  scrollbar-width: thin;
  text-align: center;
  width: 100%;
  will-change: transform;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption::-webkit-scrollbar-track {
  background-color: initial;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: initial;
  border: 3px solid #0000;
  border-radius: 8px;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption:focus-within::-webkit-scrollbar-thumb,
.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption:focus::-webkit-scrollbar-thumb,
.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption:hover::-webkit-scrollbar-thumb {
  background-color: #fffc;
}

.wp-block-gallery.has-nested-images figure.wp-block-image figcaption:focus,
.wp-block-gallery.has-nested-images
  figure.wp-block-image
  figcaption:focus-within,
.wp-block-gallery.has-nested-images figure.wp-block-image figcaption:hover {
  scrollbar-color: #fffc #0000;
}

@media (hover: none) {
  .wp-block-gallery.has-nested-images figure.wp-block-image figcaption {
    scrollbar-color: #fffc #0000;
  }
}

.wp-block-gallery.has-nested-images figure.wp-block-image figcaption img {
  display: inline;
}

.wp-block-gallery.has-nested-images figure.wp-block-image figcaption a {
  color: inherit;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image.has-custom-border
  img {
  box-sizing: border-box;
}

.wp-block-gallery.has-nested-images figure.wp-block-image.has-custom-border > a,
.wp-block-gallery.has-nested-images
  figure.wp-block-image.has-custom-border
  > div,
.wp-block-gallery.has-nested-images figure.wp-block-image.is-style-rounded > a,
.wp-block-gallery.has-nested-images
  figure.wp-block-image.is-style-rounded
  > div {
  flex: 1 1 auto;
}

.wp-block-gallery.has-nested-images
  figure.wp-block-image.has-custom-border
  figcaption,
.wp-block-gallery.has-nested-images
  figure.wp-block-image.is-style-rounded
  figcaption {
  background: none;
  color: inherit;
  flex: initial;
  margin: 0;
  padding: 10px 10px 9px;
  position: relative;
}

.wp-block-gallery.has-nested-images figcaption {
  flex-basis: 100%;
  flex-grow: 1;
  text-align: center;
}

.wp-block-gallery.has-nested-images:not(.is-cropped)
  figure.wp-block-image:not(#individual-image) {
  margin-bottom: auto;
  margin-top: 0;
}

.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image) {
  align-self: inherit;
}

.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  > a,
.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  > div:not(.components-drop-zone) {
  display: flex;
}

.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  a,
.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  img {
  flex: 1 0 0%;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.wp-block-gallery.has-nested-images.columns-1
  figure.wp-block-image:not(#individual-image) {
  width: 100%;
}

@media (min-width: 600px) {
  .wp-block-gallery.has-nested-images.columns-3
    figure.wp-block-image:not(#individual-image) {
    width: calc(
      33.33333% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667
    );
  }

  .wp-block-gallery.has-nested-images.columns-4
    figure.wp-block-image:not(#individual-image) {
    width: calc(25% - var(--wp--style--unstable-gallery-gap, 16px) * 0.75);
  }

  .wp-block-gallery.has-nested-images.columns-5
    figure.wp-block-image:not(#individual-image) {
    width: calc(20% - var(--wp--style--unstable-gallery-gap, 16px) * 0.8);
  }

  .wp-block-gallery.has-nested-images.columns-6
    figure.wp-block-image:not(#individual-image) {
    width: calc(
      16.66667% - var(--wp--style--unstable-gallery-gap, 16px) * 0.83333
    );
  }

  .wp-block-gallery.has-nested-images.columns-7
    figure.wp-block-image:not(#individual-image) {
    width: calc(
      14.28571% - var(--wp--style--unstable-gallery-gap, 16px) * 0.85714
    );
  }

  .wp-block-gallery.has-nested-images.columns-8
    figure.wp-block-image:not(#individual-image) {
    width: calc(12.5% - var(--wp--style--unstable-gallery-gap, 16px) * 0.875);
  }

  .wp-block-gallery.has-nested-images.columns-default
    figure.wp-block-image:not(#individual-image) {
    width: calc(
      33.33% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667
    );
  }

  .wp-block-gallery.has-nested-images.columns-default
    figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2),
  .wp-block-gallery.has-nested-images.columns-default
    figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2)
    ~ figure.wp-block-image:not(#individual-image) {
    width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) * 0.5);
  }

  .wp-block-gallery.has-nested-images.columns-default
    figure.wp-block-image:not(#individual-image):first-child:last-child {
    width: 100%;
  }
}

.wp-block-gallery.has-nested-images.alignleft,
.wp-block-gallery.has-nested-images.alignright {
  max-width: 420px;
  width: 100%;
}

.wp-block-gallery.has-nested-images.aligncenter {
  justify-content: center;
}

.wp-block-group {
  box-sizing: border-box;
}

h1.has-background,
h2.has-background,
h3.has-background,
h4.has-background,
h5.has-background,
h6.has-background {
  padding: 1.25em 2.375em;
}

h1.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h1.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]),
h2.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h2.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]),
h3.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h3.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]),
h4.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h4.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]),
h5.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h5.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]),
h6.has-text-align-left[style*="writing-mode"]:where([style*="vertical-lr"]),
h6.has-text-align-right[style*="writing-mode"]:where([style*="vertical-rl"]) {
  rotate: 180deg;
}

.wp-block-image img {
  box-sizing: border-box;
  height: auto;
  max-width: 100%;
  vertical-align: bottom;
}

.wp-block-image[style*="border-radius"] img,
.wp-block-image[style*="border-radius"] > a {
  border-radius: inherit;
}

.wp-block-image.has-custom-border img {
  box-sizing: border-box;
}

.wp-block-image.aligncenter {
  text-align: center;
}

.wp-block-image.alignfull img,
.wp-block-image.alignwide img {
  height: auto;
  width: 100%;
}

.wp-block-image .aligncenter,
.wp-block-image .alignleft,
.wp-block-image .alignright,
.wp-block-image.aligncenter,
.wp-block-image.alignleft,
.wp-block-image.alignright {
  display: table;
}

.wp-block-image .aligncenter > figcaption,
.wp-block-image .alignleft > figcaption,
.wp-block-image .alignright > figcaption,
.wp-block-image.aligncenter > figcaption,
.wp-block-image.alignleft > figcaption,
.wp-block-image.alignright > figcaption {
  caption-side: bottom;
  display: table-caption;
}

.wp-block-image .alignleft {
  float: left;
  margin: 0.5em 1em 0.5em 0;
}

.wp-block-image .alignright {
  float: right;
  margin: 0.5em 0 0.5em 1em;
}

.wp-block-image .aligncenter {
  margin-left: auto;
  margin-right: auto;
}

.wp-block-image figcaption {
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.wp-block-image .is-style-rounded img,
.wp-block-image.is-style-circle-mask img,
.wp-block-image.is-style-rounded img {
  border-radius: 9999px;
}

@supports ((-webkit-mask-image: none) or (mask-image: none)) or
  (-webkit-mask-image: none) {
  .wp-block-image.is-style-circle-mask img {
    border-radius: 0;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask-mode: alpha;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
  }
}

.wp-block-image :where(.has-border-color) {
  border-style: solid;
}

.wp-block-image :where([style*="border-top-color"]) {
  border-top-style: solid;
}

.wp-block-image :where([style*="border-right-color"]) {
  border-right-style: solid;
}

.wp-block-image :where([style*="border-bottom-color"]) {
  border-bottom-style: solid;
}

.wp-block-image :where([style*="border-left-color"]) {
  border-left-style: solid;
}

.wp-block-image :where([style*="border-width"]) {
  border-style: solid;
}

.wp-block-image :where([style*="border-top-width"]) {
  border-top-style: solid;
}

.wp-block-image :where([style*="border-right-width"]) {
  border-right-style: solid;
}

.wp-block-image :where([style*="border-bottom-width"]) {
  border-bottom-style: solid;
}

.wp-block-image :where([style*="border-left-width"]) {
  border-left-style: solid;
}

.wp-block-image figure {
  margin: 0;
}

.wp-lightbox-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.wp-lightbox-container img {
  cursor: zoom-in;
}

.wp-lightbox-container img:hover + button {
  opacity: 1;
}

.wp-lightbox-container button {
  align-items: center;
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  backdrop-filter: blur(16px) saturate(180%);
  background-color: #5a5a5a40;
  border: none;
  border-radius: 4px;
  cursor: zoom-in;
  display: flex;
  height: 20px;
  justify-content: center;
  opacity: 0;
  padding: 0;
  position: absolute;
  right: 16px;
  text-align: center;
  top: 16px;
  transition: opacity 0.2s ease;
  width: 20px;
  z-index: 100;
}

.wp-lightbox-container button:focus-visible {
  outline: 3px auto #5a5a5a40;
  outline: 3px auto -webkit-focus-ring-color;
  outline-offset: 3px;
}

.wp-lightbox-container button:hover {
  cursor: pointer;
  opacity: 1;
}

.wp-lightbox-container button:focus {
  opacity: 1;
}

.wp-lightbox-container button:focus,
.wp-lightbox-container button:hover,
.wp-lightbox-container button:not(:hover):not(:active):not(.has-background) {
  background-color: #5a5a5a40;
  border: none;
}

.wp-lightbox-overlay {
  box-sizing: border-box;
  cursor: zoom-out;
  height: 100vh;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  visibility: hidden;
  width: 100%;
  z-index: 100000;
}

.wp-lightbox-overlay .close-button {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 40px;
  min-width: 40px;
  padding: 0;
  position: absolute;
  right: calc(env(safe-area-inset-right) + 16px);
  top: calc(env(safe-area-inset-top) + 16px);
  z-index: 5000000;
}

.wp-lightbox-overlay .close-button:focus,
.wp-lightbox-overlay .close-button:hover,
.wp-lightbox-overlay
  .close-button:not(:hover):not(:active):not(.has-background) {
  background: none;
  border: none;
}

.wp-lightbox-overlay .lightbox-image-container {
  height: var(--wp--lightbox-container-height);
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: top left;
  width: var(--wp--lightbox-container-width);
  z-index: 9999999999;
}

.wp-lightbox-overlay .wp-block-image {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 0;
  position: relative;
  transform-origin: 0 0;
  width: 100%;
  z-index: 3000000;
}

.wp-lightbox-overlay .wp-block-image img {
  height: var(--wp--lightbox-image-height);
  min-height: var(--wp--lightbox-image-height);
  min-width: var(--wp--lightbox-image-width);
  width: var(--wp--lightbox-image-width);
}

.wp-lightbox-overlay .wp-block-image figcaption {
  display: none;
}

.wp-lightbox-overlay button {
  background: none;
  border: none;
}

.wp-lightbox-overlay .scrim {
  background-color: #fff;
  height: 100%;
  opacity: 0.9;
  position: absolute;
  width: 100%;
  z-index: 2000000;
}

.wp-lightbox-overlay.active {
  animation: turn-on-visibility 0.25s both;
  visibility: visible;
}

.wp-lightbox-overlay.active img {
  animation: turn-on-visibility 0.35s both;
}

.wp-lightbox-overlay.show-closing-animation:not(.active) {
  animation: turn-off-visibility 0.35s both;
}

.wp-lightbox-overlay.show-closing-animation:not(.active) img {
  animation: turn-off-visibility 0.25s both;
}

@media (prefers-reduced-motion: no-preference) {
  .wp-lightbox-overlay.zoom.active {
    animation: none;
    opacity: 1;
    visibility: visible;
  }

  .wp-lightbox-overlay.zoom.active .lightbox-image-container {
    animation: lightbox-zoom-in 0.4s;
  }

  .wp-lightbox-overlay.zoom.active .lightbox-image-container img {
    animation: none;
  }

  .wp-lightbox-overlay.zoom.active .scrim {
    animation: turn-on-visibility 0.4s forwards;
  }

  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active) {
    animation: none;
  }

  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active)
    .lightbox-image-container {
    animation: lightbox-zoom-out 0.4s;
  }

  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active)
    .lightbox-image-container
    img {
    animation: none;
  }

  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active) .scrim {
    animation: turn-off-visibility 0.4s forwards;
  }
}

@keyframes turn-on-visibility {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes turn-off-visibility {
  0% {
    opacity: 1;
    visibility: visible;
  }

  99% {
    opacity: 0;
    visibility: visible;
  }

  to {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes lightbox-zoom-in {
  0% {
    transform: translate(
        calc(
          (-100vw + var(--wp--lightbox-scrollbar-width)) / 2 +
            var(--wp--lightbox-initial-left-position)
        ),
        calc(-50vh + var(--wp--lightbox-initial-top-position))
      )
      scale(var(--wp--lightbox-scale));
  }

  to {
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes lightbox-zoom-out {
  0% {
    transform: translate(-50%, -50%) scale(1);
    visibility: visible;
  }

  99% {
    visibility: visible;
  }

  to {
    transform: translate(
        calc(
          (-100vw + var(--wp--lightbox-scrollbar-width)) / 2 +
            var(--wp--lightbox-initial-left-position)
        ),
        calc(-50vh + var(--wp--lightbox-initial-top-position))
      )
      scale(var(--wp--lightbox-scale));
    visibility: hidden;
  }
}

ol.wp-block-latest-comments {
  box-sizing: border-box;
  margin-left: 0;
}

:where(
    .wp-block-latest-comments:not(
        [style*="line-height"] .wp-block-latest-comments__comment
      )
  ) {
  line-height: 1.1;
}

:where(
    .wp-block-latest-comments:not(
        [style*="line-height"] .wp-block-latest-comments__comment-excerpt p
      )
  ) {
  line-height: 1.8;
}

.has-dates :where(.wp-block-latest-comments:not([style*="line-height"])),
.has-excerpts :where(.wp-block-latest-comments:not([style*="line-height"])) {
  line-height: 1.5;
}

.wp-block-latest-comments .wp-block-latest-comments {
  padding-left: 0;
}

.wp-block-latest-comments__comment {
  list-style: none;
  margin-bottom: 1em;
}

.has-avatars .wp-block-latest-comments__comment {
  list-style: none;
  min-height: 2.25em;
}

.has-avatars
  .wp-block-latest-comments__comment
  .wp-block-latest-comments__comment-excerpt,
.has-avatars
  .wp-block-latest-comments__comment
  .wp-block-latest-comments__comment-meta {
  margin-left: 3.25em;
}

.wp-block-latest-comments__comment-excerpt p {
  font-size: 0.875em;
  margin: 0.36em 0 1.4em;
}

.wp-block-latest-comments__comment-date {
  display: block;
  font-size: 0.75em;
}

.wp-block-latest-comments .avatar,
.wp-block-latest-comments__comment-avatar {
  border-radius: 1.5em;
  display: block;
  float: left;
  height: 2.5em;
  margin-right: 0.75em;
  width: 2.5em;
}

.wp-block-latest-comments[class*="-font-size"] a,
.wp-block-latest-comments[style*="font-size"] a {
  font-size: inherit;
}

.wp-block-latest-posts {
  box-sizing: border-box;
}

.wp-block-latest-posts.alignleft {
  margin-right: 2em;
}

.wp-block-latest-posts.alignright {
  margin-left: 2em;
}

.wp-block-latest-posts.wp-block-latest-posts__list {
  list-style: none;
  padding-left: 0;
}

.wp-block-latest-posts.wp-block-latest-posts__list li {
  clear: both;
}

.wp-block-latest-posts.is-grid {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

.wp-block-latest-posts.is-grid li {
  margin: 0 1.25em 1.25em 0;
  width: 100%;
}

@media (min-width: 600px) {
  .wp-block-latest-posts.columns-2 li {
    width: calc(50% - 0.625em);
  }

  .wp-block-latest-posts.columns-2 li:nth-child(2n) {
    margin-right: 0;
  }

  .wp-block-latest-posts.columns-3 li {
    width: calc(33.33333% - 0.83333em);
  }

  .wp-block-latest-posts.columns-3 li:nth-child(3n) {
    margin-right: 0;
  }

  .wp-block-latest-posts.columns-4 li {
    width: calc(25% - 0.9375em);
  }

  .wp-block-latest-posts.columns-4 li:nth-child(4n) {
    margin-right: 0;
  }

  .wp-block-latest-posts.columns-5 li {
    width: calc(20% - 1em);
  }

  .wp-block-latest-posts.columns-5 li:nth-child(5n) {
    margin-right: 0;
  }

  .wp-block-latest-posts.columns-6 li {
    width: calc(16.66667% - 1.04167em);
  }

  .wp-block-latest-posts.columns-6 li:nth-child(6n) {
    margin-right: 0;
  }
}

.wp-block-latest-posts__post-author,
.wp-block-latest-posts__post-date {
  display: block;
  font-size: 0.8125em;
}

.wp-block-latest-posts__post-excerpt {
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.wp-block-latest-posts__featured-image a {
  display: inline-block;
}

.wp-block-latest-posts__featured-image img {
  height: auto;
  max-width: 100%;
  width: auto;
}

.wp-block-latest-posts__featured-image.alignleft {
  float: left;
  margin-right: 1em;
}

.wp-block-latest-posts__featured-image.alignright {
  float: right;
  margin-left: 1em;
}

.wp-block-latest-posts__featured-image.aligncenter {
  margin-bottom: 1em;
  text-align: center;
}

ol,
ul {
  box-sizing: border-box;
}

ol.has-background,
ul.has-background {
  padding: 1.25em 2.375em;
}

.wp-block-media-text {
  box-sizing: border-box;
  /*!rtl:begin:ignore*/
  direction: ltr;
  /*!rtl:end:ignore*/
  display: grid;
  grid-template-columns: 50% 1fr;
  grid-template-rows: auto;
}

.wp-block-media-text.has-media-on-the-right {
  grid-template-columns: 1fr 50%;
}

.wp-block-media-text.is-vertically-aligned-top .wp-block-media-text__content,
.wp-block-media-text.is-vertically-aligned-top .wp-block-media-text__media {
  align-self: start;
}

.wp-block-media-text .wp-block-media-text__content,
.wp-block-media-text .wp-block-media-text__media,
.wp-block-media-text.is-vertically-aligned-center .wp-block-media-text__content,
.wp-block-media-text.is-vertically-aligned-center .wp-block-media-text__media {
  align-self: center;
}

.wp-block-media-text.is-vertically-aligned-bottom .wp-block-media-text__content,
.wp-block-media-text.is-vertically-aligned-bottom .wp-block-media-text__media {
  align-self: end;
}

.wp-block-media-text .wp-block-media-text__media {
  /*!rtl:begin:ignore*/
  grid-column: 1;
  grid-row: 1;
  /*!rtl:end:ignore*/
  margin: 0;
}

.wp-block-media-text .wp-block-media-text__content {
  direction: ltr;
  /*!rtl:begin:ignore*/
  grid-column: 2;
  grid-row: 1;
  /*!rtl:end:ignore*/
  padding: 0 8%;
  word-break: break-word;
}

.wp-block-media-text.has-media-on-the-right .wp-block-media-text__media {
  /*!rtl:begin:ignore*/
  grid-column: 2;
  grid-row: 1; /*!rtl:end:ignore*/
}

.wp-block-media-text.has-media-on-the-right .wp-block-media-text__content {
  /*!rtl:begin:ignore*/
  grid-column: 1;
  grid-row: 1; /*!rtl:end:ignore*/
}

.wp-block-media-text__media img,
.wp-block-media-text__media video {
  height: auto;
  max-width: unset;
  vertical-align: middle;
  width: 100%;
}

.wp-block-media-text.is-image-fill .wp-block-media-text__media {
  background-size: cover;
  height: 100%;
  min-height: 250px;
}

.wp-block-media-text.is-image-fill .wp-block-media-text__media > a {
  display: block;
  height: 100%;
}

.wp-block-media-text.is-image-fill .wp-block-media-text__media img {
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@media (max-width: 600px) {
  .wp-block-media-text.is-stacked-on-mobile {
    grid-template-columns: 100% !important;
  }

  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__media {
    grid-column: 1;
    grid-row: 1;
  }

  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content {
    grid-column: 1;
    grid-row: 2;
  }
}

.wp-block-navigation {
  position: relative;
  --navigation-layout-justification-setting: flex-start;
  --navigation-layout-direction: row;
  --navigation-layout-wrap: wrap;
  --navigation-layout-justify: flex-start;
  --navigation-layout-align: center;
}

.wp-block-navigation ul {
  margin-bottom: 0;
  margin-left: 0;
  margin-top: 0;
  padding-left: 0;
}

.wp-block-navigation ul,
.wp-block-navigation ul li {
  list-style: none;
  padding: 0;
}

.wp-block-navigation .wp-block-navigation-item {
  align-items: center;
  display: flex;
  position: relative;
}

.wp-block-navigation
  .wp-block-navigation-item
  .wp-block-navigation__submenu-container:empty {
  display: none;
}

.wp-block-navigation .wp-block-navigation-item__content {
  display: block;
}

.wp-block-navigation
  .wp-block-navigation-item__content.wp-block-navigation-item__content {
  color: inherit;
}

.wp-block-navigation.has-text-decoration-underline
  .wp-block-navigation-item__content,
.wp-block-navigation.has-text-decoration-underline
  .wp-block-navigation-item__content:active,
.wp-block-navigation.has-text-decoration-underline
  .wp-block-navigation-item__content:focus {
  text-decoration: underline;
}

.wp-block-navigation.has-text-decoration-line-through
  .wp-block-navigation-item__content,
.wp-block-navigation.has-text-decoration-line-through
  .wp-block-navigation-item__content:active,
.wp-block-navigation.has-text-decoration-line-through
  .wp-block-navigation-item__content:focus {
  text-decoration: line-through;
}

.wp-block-navigation:where(:not([class*="has-text-decoration"])) a {
  text-decoration: none;
}

.wp-block-navigation:where(:not([class*="has-text-decoration"])) a:active,
.wp-block-navigation:where(:not([class*="has-text-decoration"])) a:focus {
  text-decoration: none;
}

.wp-block-navigation .wp-block-navigation__submenu-icon {
  align-self: center;
  background-color: inherit;
  border: none;
  color: currentColor;
  display: inline-block;
  font-size: inherit;
  height: 0.6em;
  line-height: 0;
  margin-left: 0.25em;
  padding: 0;
  width: 0.6em;
}

.wp-block-navigation .wp-block-navigation__submenu-icon svg {
  display: inline-block;
  stroke: currentColor;
  height: inherit;
  margin-top: 0.075em;
  width: inherit;
}

.wp-block-navigation.is-vertical {
  --navigation-layout-direction: column;
  --navigation-layout-justify: initial;
  --navigation-layout-align: flex-start;
}

.wp-block-navigation.no-wrap {
  --navigation-layout-wrap: nowrap;
}

.wp-block-navigation.items-justified-center {
  --navigation-layout-justification-setting: center;
  --navigation-layout-justify: center;
}

.wp-block-navigation.items-justified-center.is-vertical {
  --navigation-layout-align: center;
}

.wp-block-navigation.items-justified-right {
  --navigation-layout-justification-setting: flex-end;
  --navigation-layout-justify: flex-end;
}

.wp-block-navigation.items-justified-right.is-vertical {
  --navigation-layout-align: flex-end;
}

.wp-block-navigation.items-justified-space-between {
  --navigation-layout-justification-setting: space-between;
  --navigation-layout-justify: space-between;
}

.wp-block-navigation .has-child .wp-block-navigation__submenu-container {
  align-items: normal;
  background-color: inherit;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 0;
  left: -1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  top: 100%;
  transition: opacity 0.1s linear;
  visibility: hidden;
  width: 0;
  z-index: 2;
}

.wp-block-navigation
  .has-child
  .wp-block-navigation__submenu-container
  > .wp-block-navigation-item
  > .wp-block-navigation-item__content {
  display: flex;
  flex-grow: 1;
}

.wp-block-navigation
  .has-child
  .wp-block-navigation__submenu-container
  > .wp-block-navigation-item
  > .wp-block-navigation-item__content
  .wp-block-navigation__submenu-icon {
  margin-left: auto;
  margin-right: 0;
}

.wp-block-navigation
  .has-child
  .wp-block-navigation__submenu-container
  .wp-block-navigation-item__content {
  margin: 0;
}

@media (min-width: 782px) {
  .wp-block-navigation
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container {
    left: 100%;
    top: -1px;
  }

  .wp-block-navigation
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container:before {
    background: #0000;
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    right: 100%;
    width: 0.5em;
  }

  .wp-block-navigation
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-icon {
    margin-right: 0.25em;
  }

  .wp-block-navigation
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-icon
    svg {
    transform: rotate(-90deg);
  }
}

.wp-block-navigation
  .has-child
  .wp-block-navigation-submenu__toggle[aria-expanded="true"]
  ~ .wp-block-navigation__submenu-container,
.wp-block-navigation
  .has-child:not(.open-on-click):hover
  > .wp-block-navigation__submenu-container,
.wp-block-navigation
  .has-child:not(.open-on-click):not(.open-on-hover-click):focus-within
  > .wp-block-navigation__submenu-container {
  height: auto;
  min-width: 200px;
  opacity: 1;
  overflow: visible;
  visibility: visible;
  width: auto;
}

.wp-block-navigation.has-background
  .has-child
  .wp-block-navigation__submenu-container {
  left: 0;
  top: 100%;
}

@media (min-width: 782px) {
  .wp-block-navigation.has-background
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container {
    left: 100%;
    top: 0;
  }
}

.wp-block-navigation-submenu {
  display: flex;
  position: relative;
}

.wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg {
  stroke: currentColor;
}

button.wp-block-navigation-item__content {
  background-color: initial;
  border: none;
  color: currentColor;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: left;
  text-transform: inherit;
}

.wp-block-navigation-submenu__toggle {
  cursor: pointer;
}

.wp-block-navigation-item.open-on-click .wp-block-navigation-submenu__toggle {
  padding-left: 0;
  padding-right: 0.85em;
}

.wp-block-navigation-item.open-on-click
  .wp-block-navigation-submenu__toggle
  + .wp-block-navigation__submenu-icon {
  margin-left: -0.6em;
  pointer-events: none;
}

.wp-block-navigation-item.open-on-click
  button.wp-block-navigation-item__content:not(
    .wp-block-navigation-submenu__toggle
  ) {
  padding: 0;
}

.wp-block-navigation .wp-block-page-list,
.wp-block-navigation__container,
.wp-block-navigation__responsive-close,
.wp-block-navigation__responsive-container,
.wp-block-navigation__responsive-container-content,
.wp-block-navigation__responsive-dialog {
  gap: inherit;
}

:where(
    .wp-block-navigation.has-background
      .wp-block-navigation-item
      a:not(.wp-element-button)
  ),
:where(
    .wp-block-navigation.has-background
      .wp-block-navigation-submenu
      a:not(.wp-element-button)
  ) {
  padding: 0.5em 1em;
}

:where(
    .wp-block-navigation
      .wp-block-navigation__submenu-container
      .wp-block-navigation-item
      a:not(.wp-element-button)
  ),
:where(
    .wp-block-navigation
      .wp-block-navigation__submenu-container
      .wp-block-navigation-submenu
      a:not(.wp-element-button)
  ),
:where(
    .wp-block-navigation
      .wp-block-navigation__submenu-container
      .wp-block-navigation-submenu
      button.wp-block-navigation-item__content
  ),
:where(
    .wp-block-navigation
      .wp-block-navigation__submenu-container
      .wp-block-pages-list__item
      button.wp-block-navigation-item__content
  ) {
  padding: 0.5em 1em;
}

.wp-block-navigation.items-justified-right
  .wp-block-navigation__container
  .has-child
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-right
  .wp-block-page-list
  > .has-child
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-space-between
  .wp-block-page-list
  > .has-child:last-child
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-space-between
  > .wp-block-navigation__container
  > .has-child:last-child
  .wp-block-navigation__submenu-container {
  left: auto;
  right: 0;
}

.wp-block-navigation.items-justified-right
  .wp-block-navigation__container
  .has-child
  .wp-block-navigation__submenu-container
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-right
  .wp-block-page-list
  > .has-child
  .wp-block-navigation__submenu-container
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-space-between
  .wp-block-page-list
  > .has-child:last-child
  .wp-block-navigation__submenu-container
  .wp-block-navigation__submenu-container,
.wp-block-navigation.items-justified-space-between
  > .wp-block-navigation__container
  > .has-child:last-child
  .wp-block-navigation__submenu-container
  .wp-block-navigation__submenu-container {
  left: -1px;
  right: -1px;
}

@media (min-width: 782px) {
  .wp-block-navigation.items-justified-right
    .wp-block-navigation__container
    .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container,
  .wp-block-navigation.items-justified-right
    .wp-block-page-list
    > .has-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container,
  .wp-block-navigation.items-justified-space-between
    .wp-block-page-list
    > .has-child:last-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container,
  .wp-block-navigation.items-justified-space-between
    > .wp-block-navigation__container
    > .has-child:last-child
    .wp-block-navigation__submenu-container
    .wp-block-navigation__submenu-container {
    left: auto;
    right: 100%;
  }
}

.wp-block-navigation:not(.has-background)
  .wp-block-navigation__submenu-container {
  background-color: #fff;
  border: 1px solid #00000026;
}

.wp-block-navigation.has-background .wp-block-navigation__submenu-container {
  background-color: inherit;
}

.wp-block-navigation:not(.has-text-color)
  .wp-block-navigation__submenu-container {
  color: #000;
}

.wp-block-navigation__container {
  align-items: var(--navigation-layout-align, initial);
  display: flex;
  flex-direction: var(--navigation-layout-direction, initial);
  flex-wrap: var(--navigation-layout-wrap, wrap);
  justify-content: var(--navigation-layout-justify, initial);
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.wp-block-navigation__container .is-responsive {
  display: none;
}

.wp-block-navigation__container:only-child,
.wp-block-page-list:only-child {
  flex-grow: 1;
}

@keyframes overlay-menu__fade-in-animation {
  0% {
    opacity: 0;
    transform: translateY(0.5em);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.wp-block-navigation__responsive-container {
  bottom: 0;
  display: none;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.wp-block-navigation__responsive-container :where(.wp-block-navigation-item a) {
  color: inherit;
}

.wp-block-navigation__responsive-container
  .wp-block-navigation__responsive-container-content {
  align-items: var(--navigation-layout-align, initial);
  display: flex;
  flex-direction: var(--navigation-layout-direction, initial);
  flex-wrap: var(--navigation-layout-wrap, wrap);
  justify-content: var(--navigation-layout-justify, initial);
}

.wp-block-navigation__responsive-container:not(.is-menu-open.is-menu-open) {
  background-color: inherit !important;
  color: inherit !important;
}

.wp-block-navigation__responsive-container.is-menu-open {
  animation: overlay-menu__fade-in-animation 0.1s ease-out;
  animation-fill-mode: forwards;
  background-color: inherit;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: clamp(1rem, var(--wp--style--root--padding-top), 20rem)
    clamp(1rem, var(--wp--style--root--padding-right), 20rem)
    clamp(1rem, var(--wp--style--root--padding-bottom), 20rem)
    clamp(1rem, var(--wp--style--root--padding-left), 20em);
  z-index: 100000;
}

@media (prefers-reduced-motion: reduce) {
  .wp-block-navigation__responsive-container.is-menu-open {
    animation-delay: 0s;
    animation-duration: 1ms;
  }
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content {
  align-items: var(--navigation-layout-justification-setting, inherit);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: visible;
  padding-top: calc(2rem + 24px);
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__container,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-page-list {
  justify-content: flex-start;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__submenu-icon {
  display: none;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .has-child
  .wp-block-navigation__submenu-container {
  border: none;
  height: auto;
  min-width: 200px;
  opacity: 1;
  overflow: initial;
  padding-left: 2rem;
  padding-right: 2rem;
  position: static;
  visibility: visible;
  width: auto;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__container,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__submenu-container {
  gap: inherit;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__submenu-container {
  padding-top: var(--wp--style--block-gap, 2em);
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation-item__content {
  padding: 0;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation-item,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-navigation__container,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__responsive-container-content
  .wp-block-page-list {
  align-items: var(--navigation-layout-justification-setting, initial);
  display: flex;
  flex-direction: column;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation-item,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation-item
  .wp-block-navigation__submenu-container,
.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__container,
.wp-block-navigation__responsive-container.is-menu-open .wp-block-page-list {
  background: #0000 !important;
  color: inherit !important;
}

.wp-block-navigation__responsive-container.is-menu-open
  .wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container {
  left: auto;
  right: auto;
}

@media (min-width: 600px) {
  .wp-block-navigation__responsive-container:not(.hidden-by-default):not(
      .is-menu-open
    ) {
    background-color: inherit;
    display: block;
    position: relative;
    width: 100%;
    z-index: auto;
  }

  .wp-block-navigation__responsive-container:not(.hidden-by-default):not(
      .is-menu-open
    )
    .wp-block-navigation__responsive-container-close {
    display: none;
  }

  .wp-block-navigation__responsive-container.is-menu-open
    .wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container {
    left: 0;
  }
}

.wp-block-navigation:not(.has-background)
  .wp-block-navigation__responsive-container.is-menu-open {
  background-color: #fff;
}

.wp-block-navigation:not(.has-text-color)
  .wp-block-navigation__responsive-container.is-menu-open {
  color: #000;
}

.wp-block-navigation__toggle_button_label {
  font-size: 1rem;
  font-weight: 700;
}

.wp-block-navigation__responsive-container-close,
.wp-block-navigation__responsive-container-open {
  background: #0000;
  border: none;
  color: currentColor;
  cursor: pointer;
  margin: 0;
  padding: 0;
  text-transform: inherit;
  vertical-align: middle;
}

.wp-block-navigation__responsive-container-close svg,
.wp-block-navigation__responsive-container-open svg {
  fill: currentColor;
  display: block;
  height: 24px;
  pointer-events: none;
  width: 24px;
}

.wp-block-navigation__responsive-container-open {
  display: flex;
}

.wp-block-navigation__responsive-container-open.wp-block-navigation__responsive-container-open.wp-block-navigation__responsive-container-open {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
}

@media (min-width: 600px) {
  .wp-block-navigation__responsive-container-open:not(.always-shown) {
    display: none;
  }
}

.wp-block-navigation__responsive-container-close {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.wp-block-navigation__responsive-container-close.wp-block-navigation__responsive-container-close.wp-block-navigation__responsive-container-close {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
}

.wp-block-navigation__responsive-close {
  width: 100%;
}

.has-modal-open .wp-block-navigation__responsive-close {
  margin-left: auto;
  margin-right: auto;
  max-width: var(--wp--style--global--wide-size, 100%);
}

.wp-block-navigation__responsive-close:focus {
  outline: none;
}

.is-menu-open .wp-block-navigation__responsive-close,
.is-menu-open .wp-block-navigation__responsive-container-content,
.is-menu-open .wp-block-navigation__responsive-dialog {
  box-sizing: border-box;
}

.wp-block-navigation__responsive-dialog {
  position: relative;
}

.has-modal-open
  .admin-bar
  .is-menu-open
  .wp-block-navigation__responsive-dialog {
  margin-top: 46px;
}

@media (min-width: 782px) {
  .has-modal-open
    .admin-bar
    .is-menu-open
    .wp-block-navigation__responsive-dialog {
    margin-top: 32px;
  }
}

html.has-modal-open {
  overflow: hidden;
}

.wp-block-navigation .wp-block-navigation-item__label {
  overflow-wrap: break-word;
}

.wp-block-navigation .wp-block-navigation-item__description {
  display: none;
}

.link-ui-tools {
  border-top: 1px solid #f0f0f0;
  padding: 8px;
}

.link-ui-block-inserter {
  padding-top: 8px;
}

.link-ui-block-inserter__back {
  margin-left: 8px;
  text-transform: uppercase;
}

.components-popover-pointer-events-trap {
  background-color: initial;
  cursor: pointer;
  inset: 0;
  position: fixed;
  z-index: 1000000;
}

.wp-block-navigation .wp-block-page-list {
  align-items: var(--navigation-layout-align, initial);
  background-color: inherit;
  display: flex;
  flex-direction: var(--navigation-layout-direction, initial);
  flex-wrap: var(--navigation-layout-wrap, wrap);
  justify-content: var(--navigation-layout-justify, initial);
}

.wp-block-navigation .wp-block-navigation-item {
  background-color: inherit;
}

.is-small-text {
  font-size: 0.875em;
}

.is-regular-text {
  font-size: 1em;
}

.is-large-text {
  font-size: 2.25em;
}

.is-larger-text {
  font-size: 3em;
}

.has-drop-cap:not(:focus):first-letter {
  float: left;
  font-size: 8.4em;
  font-style: normal;
  font-weight: 100;
  line-height: 0.68;
  margin: 0.05em 0.1em 0 0;
  text-transform: uppercase;
}

body.rtl .has-drop-cap:not(:focus):first-letter {
  float: none;
  margin-left: 0.1em;
}

p.has-drop-cap.has-background {
  overflow: hidden;
}

p.has-background {
  padding: 1.25em 2.375em;
}

:where(p.has-text-color:not(.has-link-color)) a {
  color: inherit;
}

p.has-text-align-left[style*="writing-mode:vertical-lr"],
p.has-text-align-right[style*="writing-mode:vertical-rl"] {
  rotate: 180deg;
}

.wp-block-post-author {
  display: flex;
  flex-wrap: wrap;
}

.wp-block-post-author__byline {
  font-size: 0.5em;
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}

.wp-block-post-author__avatar {
  margin-right: 1em;
}

.wp-block-post-author__bio {
  font-size: 0.7em;
  margin-bottom: 0.7em;
}

.wp-block-post-author__content {
  flex-basis: 0;
  flex-grow: 1;
}

.wp-block-post-author__name {
  margin: 0;
}

.wp-block-post-comments-form {
  box-sizing: border-box;
}

.wp-block-post-comments-form[style*="font-weight"]
  :where(.comment-reply-title) {
  font-weight: inherit;
}

.wp-block-post-comments-form[style*="font-family"]
  :where(.comment-reply-title) {
  font-family: inherit;
}

.wp-block-post-comments-form[class*="-font-size"] :where(.comment-reply-title),
.wp-block-post-comments-form[style*="font-size"] :where(.comment-reply-title) {
  font-size: inherit;
}

.wp-block-post-comments-form[style*="line-height"]
  :where(.comment-reply-title) {
  line-height: inherit;
}

.wp-block-post-comments-form[style*="font-style"] :where(.comment-reply-title) {
  font-style: inherit;
}

.wp-block-post-comments-form[style*="letter-spacing"]
  :where(.comment-reply-title) {
  letter-spacing: inherit;
}

.wp-block-post-comments-form input[type="submit"] {
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  overflow-wrap: break-word;
  text-align: center;
}

.wp-block-post-comments-form input:not([type="submit"]),
.wp-block-post-comments-form textarea {
  border: 1px solid #949494;
  font-family: inherit;
  font-size: 1em;
}

.wp-block-post-comments-form input:not([type="submit"]):not([type="checkbox"]),
.wp-block-post-comments-form textarea {
  padding: calc(0.667em + 2px);
}

.wp-block-post-comments-form
  .comment-form
  input:not([type="submit"]):not([type="checkbox"]):not([type="hidden"]),
.wp-block-post-comments-form .comment-form textarea {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

.wp-block-post-comments-form .comment-form-author label,
.wp-block-post-comments-form .comment-form-email label,
.wp-block-post-comments-form .comment-form-url label {
  display: block;
  margin-bottom: 0.25em;
}

.wp-block-post-comments-form .comment-form-cookies-consent {
  display: flex;
  gap: 0.25em;
}

.wp-block-post-comments-form
  .comment-form-cookies-consent
  #wp-comment-cookies-consent {
  margin-top: 0.35em;
}

.wp-block-post-comments-form .comment-reply-title {
  margin-bottom: 0;
}

.wp-block-post-comments-form .comment-reply-title :where(small) {
  font-size: var(--wp--preset--font-size--medium, smaller);
  margin-left: 0.5em;
}

.wp-block-post-date {
  box-sizing: border-box;
}

:where(.wp-block-post-excerpt) {
  margin-bottom: var(--wp--style--block-gap);
  margin-top: var(--wp--style--block-gap);
}

.wp-block-post-excerpt__excerpt {
  margin-bottom: 0;
  margin-top: 0;
}

.wp-block-post-excerpt__more-text {
  margin-bottom: 0;
  margin-top: var(--wp--style--block-gap);
}

.wp-block-post-excerpt__more-link {
  display: inline-block;
}

.wp-block-post-featured-image {
  margin-left: 0;
  margin-right: 0;
}

.wp-block-post-featured-image a {
  display: block;
  height: 100%;
}

.wp-block-post-featured-image img {
  box-sizing: border-box;
  height: auto;
  max-width: 100%;
  vertical-align: bottom;
  width: 100%;
}

.wp-block-post-featured-image.alignfull img,
.wp-block-post-featured-image.alignwide img {
  width: 100%;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim {
  background-color: #000;
  inset: 0;
  position: absolute;
}

.wp-block-post-featured-image {
  position: relative;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-gradient {
  background-color: initial;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-0 {
  opacity: 0;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-10 {
  opacity: 0.1;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-20 {
  opacity: 0.2;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-30 {
  opacity: 0.3;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-40 {
  opacity: 0.4;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-50 {
  opacity: 0.5;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-60 {
  opacity: 0.6;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-70 {
  opacity: 0.7;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-80 {
  opacity: 0.8;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-90 {
  opacity: 0.9;
}

.wp-block-post-featured-image
  .wp-block-post-featured-image__overlay.has-background-dim-100 {
  opacity: 1;
}

.wp-block-post-featured-image:where(.alignleft, .alignright) {
  width: 100%;
}

.wp-block-post-navigation-link .wp-block-post-navigation-link__arrow-previous {
  display: inline-block;
  margin-right: 1ch;
}

.wp-block-post-navigation-link
  .wp-block-post-navigation-link__arrow-previous:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-post-navigation-link .wp-block-post-navigation-link__arrow-next {
  display: inline-block;
  margin-left: 1ch;
}

.wp-block-post-navigation-link
  .wp-block-post-navigation-link__arrow-next:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-post-navigation-link.has-text-align-left[style*="writing-mode: vertical-lr"],
.wp-block-post-navigation-link.has-text-align-right[style*="writing-mode: vertical-rl"] {
  rotate: 180deg;
}

.wp-block-post-terms {
  box-sizing: border-box;
}

.wp-block-post-terms .wp-block-post-terms__separator {
  white-space: pre-wrap;
}

.wp-block-post-time-to-read,
.wp-block-post-title {
  box-sizing: border-box;
}

.wp-block-post-title {
  word-break: break-word;
}

.wp-block-post-title a {
  display: inline-block;
}

.wp-block-preformatted {
  box-sizing: border-box;
  white-space: pre-wrap;
}

:where(.wp-block-preformatted.has-background) {
  padding: 1.25em 2.375em;
}

.wp-block-pullquote {
  box-sizing: border-box;
  overflow-wrap: break-word;
  padding: 4em 0;
  text-align: center;
}

.wp-block-pullquote blockquote,
.wp-block-pullquote cite,
.wp-block-pullquote p {
  color: inherit;
}

.wp-block-pullquote blockquote {
  margin: 0;
}

.wp-block-pullquote p {
  margin-top: 0;
}

.wp-block-pullquote p:last-child {
  margin-bottom: 0;
}

.wp-block-pullquote.alignleft,
.wp-block-pullquote.alignright {
  max-width: 420px;
}

.wp-block-pullquote cite,
.wp-block-pullquote footer {
  position: relative;
}

.wp-block-pullquote .has-text-color a {
  color: inherit;
}

:where(.wp-block-pullquote) {
  margin: 0 0 1em;
}

.wp-block-pullquote.has-text-align-left blockquote {
  text-align: left;
}

.wp-block-pullquote.has-text-align-right blockquote {
  text-align: right;
}

.wp-block-pullquote.is-style-solid-color {
  border: none;
}

.wp-block-pullquote.is-style-solid-color blockquote {
  margin-left: auto;
  margin-right: auto;
  max-width: 60%;
}

.wp-block-pullquote.is-style-solid-color blockquote p {
  font-size: 2em;
  margin-bottom: 0;
  margin-top: 0;
}

.wp-block-pullquote.is-style-solid-color blockquote cite {
  font-style: normal;
  text-transform: none;
}

.wp-block-pullquote cite {
  color: inherit;
}

.wp-block-post-template {
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  max-width: 100%;
  padding: 0;
}

.wp-block-post-template.wp-block-post-template {
  background: none;
}

.wp-block-post-template.is-flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.25em;
}

.wp-block-post-template.is-flex-container > li {
  margin: 0;
  width: 100%;
}

@media (min-width: 600px) {
  .wp-block-post-template.is-flex-container.is-flex-container.columns-2 > li {
    width: calc(50% - 0.625em);
  }

  .wp-block-post-template.is-flex-container.is-flex-container.columns-3 > li {
    width: calc(33.33333% - 0.83333em);
  }

  .wp-block-post-template.is-flex-container.is-flex-container.columns-4 > li {
    width: calc(25% - 0.9375em);
  }

  .wp-block-post-template.is-flex-container.is-flex-container.columns-5 > li {
    width: calc(20% - 1em);
  }

  .wp-block-post-template.is-flex-container.is-flex-container.columns-6 > li {
    width: calc(16.66667% - 1.04167em);
  }
}

@media (max-width: 600px) {
  .wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid {
    grid-template-columns: 1fr;
  }
}

.wp-block-post-template-is-layout-constrained > li > .alignright,
.wp-block-post-template-is-layout-flow > li > .alignright {
  float: right;
  margin-inline-end: 0;
  margin-inline-start: 2em;
}

.wp-block-post-template-is-layout-constrained > li > .alignleft,
.wp-block-post-template-is-layout-flow > li > .alignleft {
  float: left;
  margin-inline-end: 2em;
  margin-inline-start: 0;
}

.wp-block-post-template-is-layout-constrained > li > .aligncenter,
.wp-block-post-template-is-layout-flow > li > .aligncenter {
  margin-inline-end: auto;
  margin-inline-start: auto;
}

.wp-block-query-pagination > .wp-block-query-pagination-next,
.wp-block-query-pagination > .wp-block-query-pagination-numbers,
.wp-block-query-pagination > .wp-block-query-pagination-previous {
  margin-bottom: 0.5em;
  margin-right: 0.5em;
}

.wp-block-query-pagination > .wp-block-query-pagination-next:last-child,
.wp-block-query-pagination > .wp-block-query-pagination-numbers:last-child,
.wp-block-query-pagination > .wp-block-query-pagination-previous:last-child {
  margin-right: 0;
}

.wp-block-query-pagination.is-content-justification-space-between
  > .wp-block-query-pagination-next:last-of-type {
  margin-inline-start: auto;
}

.wp-block-query-pagination.is-content-justification-space-between
  > .wp-block-query-pagination-previous:first-child {
  margin-inline-end: auto;
}

.wp-block-query-pagination .wp-block-query-pagination-previous-arrow {
  display: inline-block;
  margin-right: 1ch;
}

.wp-block-query-pagination
  .wp-block-query-pagination-previous-arrow:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-query-pagination .wp-block-query-pagination-next-arrow {
  display: inline-block;
  margin-left: 1ch;
}

.wp-block-query-pagination
  .wp-block-query-pagination-next-arrow:not(.is-arrow-chevron) {
  transform: scaleX(1);
}

.wp-block-query-pagination.aligncenter {
  justify-content: center;
}

.wp-block-query-title,
.wp-block-quote {
  box-sizing: border-box;
}

.wp-block-quote {
  overflow-wrap: break-word;
}

.wp-block-quote.is-large:where(:not(.is-style-plain)),
.wp-block-quote.is-style-large:where(:not(.is-style-plain)) {
  margin-bottom: 1em;
  padding: 0 1em;
}

.wp-block-quote.is-large:where(:not(.is-style-plain)) p,
.wp-block-quote.is-style-large:where(:not(.is-style-plain)) p {
  font-size: 1.5em;
  font-style: italic;
  line-height: 1.6;
}

.wp-block-quote.is-large:where(:not(.is-style-plain)) cite,
.wp-block-quote.is-large:where(:not(.is-style-plain)) footer,
.wp-block-quote.is-style-large:where(:not(.is-style-plain)) cite,
.wp-block-quote.is-style-large:where(:not(.is-style-plain)) footer {
  font-size: 1.125em;
  text-align: right;
}

.wp-block-quote > cite {
  display: block;
}

.wp-block-read-more {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
}

.wp-block-read-more:where(:not([style*="text-decoration"])) {
  text-decoration: none;
}

.wp-block-read-more:where(:not([style*="text-decoration"])):active,
.wp-block-read-more:where(:not([style*="text-decoration"])):focus {
  text-decoration: none;
}

ul.wp-block-rss {
  list-style: none;
  padding: 0;
}

ul.wp-block-rss.wp-block-rss {
  box-sizing: border-box;
}

ul.wp-block-rss.alignleft {
  margin-right: 2em;
}

ul.wp-block-rss.alignright {
  margin-left: 2em;
}

ul.wp-block-rss.is-grid {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}

ul.wp-block-rss.is-grid li {
  margin: 0 1em 1em 0;
  width: 100%;
}

@media (min-width: 600px) {
  ul.wp-block-rss.columns-2 li {
    width: calc(50% - 1em);
  }

  ul.wp-block-rss.columns-3 li {
    width: calc(33.33333% - 1em);
  }

  ul.wp-block-rss.columns-4 li {
    width: calc(25% - 1em);
  }

  ul.wp-block-rss.columns-5 li {
    width: calc(20% - 1em);
  }

  ul.wp-block-rss.columns-6 li {
    width: calc(16.66667% - 1em);
  }
}

.wp-block-rss__item-author,
.wp-block-rss__item-publish-date {
  display: block;
  font-size: 0.8125em;
}

.wp-block-search__button {
  margin-left: 10px;
  word-break: normal;
}

.wp-block-search__button.has-icon {
  line-height: 0;
}

.wp-block-search__button svg {
  height: 1.25em;
  min-height: 24px;
  min-width: 24px;
  width: 1.25em;
  fill: currentColor;
  vertical-align: text-bottom;
}

:where(.wp-block-search__button) {
  border: 1px solid #ccc;
  padding: 6px 10px;
}

.wp-block-search__inside-wrapper {
  display: flex;
  flex: auto;
  flex-wrap: nowrap;
  max-width: 100%;
}

.wp-block-search__label {
  width: 100%;
}

.wp-block-search__input {
  -webkit-appearance: initial;
  appearance: none;
  border: 1px solid #949494;
  flex-grow: 1;
  margin-left: 0;
  margin-right: 0;
  min-width: 3rem;
  padding: 8px;
  text-decoration: unset !important;
}

.wp-block-search.wp-block-search__button-only .wp-block-search__button {
  flex-shrink: 0;
  margin-left: 0;
  max-width: 100%;
}

.wp-block-search.wp-block-search__button-only
  .wp-block-search__button[aria-expanded="true"] {
  max-width: calc(100% - 100px);
}

.wp-block-search.wp-block-search__button-only .wp-block-search__inside-wrapper {
  min-width: 0 !important;
  transition-property: width;
}

.wp-block-search.wp-block-search__button-only .wp-block-search__input {
  flex-basis: 100%;
  transition-duration: 0.3s;
}

.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden,
.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden
  .wp-block-search__inside-wrapper {
  overflow: hidden;
}

.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden
  .wp-block-search__input {
  border-left-width: 0 !important;
  border-right-width: 0 !important;
  flex-basis: 0;
  flex-grow: 0;
  margin: 0;
  min-width: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 0 !important;
}

:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper) {
  border: 1px solid #949494;
  box-sizing: border-box;
  padding: 4px;
}

:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)
  .wp-block-search__input {
  border: none;
  border-radius: 0;
  padding: 0 4px;
}

:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)
  .wp-block-search__input:focus {
  outline: none;
}

:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)
  :where(.wp-block-search__button) {
  padding: 4px 8px;
}

.wp-block-search.aligncenter .wp-block-search__inside-wrapper {
  margin: auto;
}

.wp-block[data-align="right"]
  .wp-block-search.wp-block-search__button-only
  .wp-block-search__inside-wrapper {
  float: right;
}

.wp-block-separator {
  border: none;
  border-top: 2px solid;
}

.wp-block-separator.is-style-dots {
  background: none !important;
  border: none;
  height: auto;
  line-height: 1;
  text-align: center;
}

.wp-block-separator.is-style-dots:before {
  color: currentColor;
  content: "···";
  font-family: serif;
  font-size: 1.5em;
  letter-spacing: 2em;
  padding-left: 2em;
}

.wp-block-site-logo {
  box-sizing: border-box;
  line-height: 0;
}

.wp-block-site-logo a {
  display: inline-block;
  line-height: 0;
}

.wp-block-site-logo.is-default-size img {
  height: auto;
  width: 120px;
}

.wp-block-site-logo img {
  height: auto;
  max-width: 100%;
}

.wp-block-site-logo a,
.wp-block-site-logo img {
  border-radius: inherit;
}

.wp-block-site-logo.aligncenter {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.wp-block-site-logo.is-style-rounded {
  border-radius: 9999px;
}

.wp-block-site-title a {
  color: inherit;
}

.wp-block-social-links {
  background: none;
  box-sizing: border-box;
  margin-left: 0;
  padding-left: 0;
  padding-right: 0;
  text-indent: 0;
}

.wp-block-social-links .wp-social-link a,
.wp-block-social-links .wp-social-link a:hover {
  border-bottom: 0;
  box-shadow: none;
  text-decoration: none;
}

.wp-block-social-links .wp-social-link a {
  padding: 0.25em;
}

.wp-block-social-links .wp-social-link svg {
  height: 1em;
  width: 1em;
}

.wp-block-social-links .wp-social-link span:not(.screen-reader-text) {
  font-size: 0.65em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.wp-block-social-links.has-small-icon-size {
  font-size: 16px;
}

.wp-block-social-links,
.wp-block-social-links.has-normal-icon-size {
  font-size: 24px;
}

.wp-block-social-links.has-large-icon-size {
  font-size: 36px;
}

.wp-block-social-links.has-huge-icon-size {
  font-size: 48px;
}

.wp-block-social-links.aligncenter {
  display: flex;
  justify-content: center;
}

.wp-block-social-links.alignright {
  justify-content: flex-end;
}

.wp-block-social-link {
  border-radius: 9999px;
  display: block;
  height: auto;
  transition: transform 0.1s ease;
}

@media (prefers-reduced-motion: reduce) {
  .wp-block-social-link {
    transition-delay: 0s;
    transition-duration: 0s;
  }
}

.wp-block-social-link a {
  align-items: center;
  display: flex;
  line-height: 0;
  transition: transform 0.1s ease;
}

.wp-block-social-link:hover {
  transform: scale(1.1);
}

.wp-block-social-links .wp-block-social-link.wp-social-link {
  display: inline-block;
  margin: 0;
  padding: 0;
}

.wp-block-social-links
  .wp-block-social-link.wp-social-link
  .wp-block-social-link-anchor,
.wp-block-social-links
  .wp-block-social-link.wp-social-link
  .wp-block-social-link-anchor
  svg,
.wp-block-social-links
  .wp-block-social-link.wp-social-link
  .wp-block-social-link-anchor:active,
.wp-block-social-links
  .wp-block-social-link.wp-social-link
  .wp-block-social-link-anchor:hover,
.wp-block-social-links
  .wp-block-social-link.wp-social-link
  .wp-block-social-link-anchor:visited {
  color: currentColor;
  fill: currentColor;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link {
  background-color: #f0f0f0;
  color: #444;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-amazon {
  background-color: #f90;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-bandcamp {
  background-color: #1ea0c3;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-behance {
  background-color: #0757fe;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-codepen {
  background-color: #1e1f26;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-deviantart {
  background-color: #02e49b;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-dribbble {
  background-color: #e94c89;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-dropbox {
  background-color: #4280ff;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-etsy {
  background-color: #f45800;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-facebook {
  background-color: #1778f2;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-fivehundredpx {
  background-color: #000;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-flickr {
  background-color: #0461dd;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-foursquare {
  background-color: #e65678;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-github {
  background-color: #24292d;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-goodreads {
  background-color: #eceadd;
  color: #382110;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-google {
  background-color: #ea4434;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-gravatar {
  background-color: #1d4fc4;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-instagram {
  background-color: #f00075;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-lastfm {
  background-color: #e21b24;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-linkedin {
  background-color: #0d66c2;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-mastodon {
  background-color: #3288d4;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-medium {
  background-color: #02ab6c;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-meetup {
  background-color: #f6405f;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-patreon {
  background-color: #000;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-pinterest {
  background-color: #e60122;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-pocket {
  background-color: #ef4155;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-reddit {
  background-color: #ff4500;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-skype {
  background-color: #0478d7;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-snapchat {
  background-color: #fefc00;
  color: #fff;
  stroke: #000;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-soundcloud {
  background-color: #ff5600;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-spotify {
  background-color: #1bd760;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-telegram {
  background-color: #2aabee;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-threads,
.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-tiktok {
  background-color: #000;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-tumblr {
  background-color: #011835;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-twitch {
  background-color: #6440a4;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-twitter {
  background-color: #1da1f2;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-vimeo {
  background-color: #1eb7ea;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-vk {
  background-color: #4680c2;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-wordpress {
  background-color: #3499cd;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-whatsapp {
  background-color: #25d366;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-x {
  background-color: #000;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-yelp {
  background-color: #d32422;
  color: #fff;
}

.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-youtube {
  background-color: red;
  color: #fff;
}

.wp-block-social-links.is-style-logos-only .wp-social-link {
  background: none;
}

.wp-block-social-links.is-style-logos-only .wp-social-link a {
  padding: 0;
}

.wp-block-social-links.is-style-logos-only .wp-social-link svg {
  height: 1.25em;
  width: 1.25em;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-amazon {
  color: #f90;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-bandcamp {
  color: #1ea0c3;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-behance {
  color: #0757fe;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-codepen {
  color: #1e1f26;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-deviantart {
  color: #02e49b;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-dribbble {
  color: #e94c89;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-dropbox {
  color: #4280ff;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-etsy {
  color: #f45800;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-facebook {
  color: #1778f2;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-fivehundredpx {
  color: #000;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-flickr {
  color: #0461dd;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-foursquare {
  color: #e65678;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-github {
  color: #24292d;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-goodreads {
  color: #382110;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-google {
  color: #ea4434;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-gravatar {
  color: #1d4fc4;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-instagram {
  color: #f00075;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-lastfm {
  color: #e21b24;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-linkedin {
  color: #0d66c2;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-mastodon {
  color: #3288d4;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-medium {
  color: #02ab6c;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-meetup {
  color: #f6405f;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-patreon {
  color: #000;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-pinterest {
  color: #e60122;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-pocket {
  color: #ef4155;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-reddit {
  color: #ff4500;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-skype {
  color: #0478d7;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-snapchat {
  color: #fff;
  stroke: #000;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-soundcloud {
  color: #ff5600;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-spotify {
  color: #1bd760;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-telegram {
  color: #2aabee;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-threads,
.wp-block-social-links.is-style-logos-only .wp-social-link-tiktok {
  color: #000;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-tumblr {
  color: #011835;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-twitch {
  color: #6440a4;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-twitter {
  color: #1da1f2;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-vimeo {
  color: #1eb7ea;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-vk {
  color: #4680c2;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-whatsapp {
  color: #25d366;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-wordpress {
  color: #3499cd;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-x {
  color: #000;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-yelp {
  color: #d32422;
}

.wp-block-social-links.is-style-logos-only .wp-social-link-youtube {
  color: red;
}

.wp-block-social-links.is-style-pill-shape .wp-social-link {
  width: auto;
}

.wp-block-social-links.is-style-pill-shape .wp-social-link a {
  padding-left: 0.66667em;
  padding-right: 0.66667em;
}

.wp-block-social-links:not(.has-icon-color):not(.has-icon-background-color)
  .wp-social-link-snapchat
  .wp-block-social-link-label {
  color: #000;
}

.wp-block-spacer {
  clear: both;
}

.wp-block-tag-cloud {
  box-sizing: border-box;
}

.wp-block-tag-cloud.aligncenter {
  justify-content: center;
  text-align: center;
}

.wp-block-tag-cloud.alignfull {
  padding-left: 1em;
  padding-right: 1em;
}

.wp-block-tag-cloud a {
  display: inline-block;
  margin-right: 5px;
}

.wp-block-tag-cloud span {
  display: inline-block;
  margin-left: 5px;
  text-decoration: none;
}

.wp-block-tag-cloud.is-style-outline {
  display: flex;
  flex-wrap: wrap;
  gap: 1ch;
}

.wp-block-tag-cloud.is-style-outline a {
  border: 1px solid;
  font-size: unset !important;
  margin-right: 0;
  padding: 1ch 2ch;
  text-decoration: none !important;
}

.wp-block-table {
  overflow-x: auto;
}

.wp-block-table table {
  border-collapse: collapse;
  width: 100%;
}

.wp-block-table thead {
  border-bottom: 3px solid;
}

.wp-block-table tfoot {
  border-top: 3px solid;
}

.wp-block-table td,
.wp-block-table th {
  border: 1px solid;
  padding: 0.5em;
}

.wp-block-table .has-fixed-layout {
  table-layout: fixed;
  width: 100%;
}

.wp-block-table .has-fixed-layout td,
.wp-block-table .has-fixed-layout th {
  word-break: break-word;
}

.wp-block-table.aligncenter,
.wp-block-table.alignleft,
.wp-block-table.alignright {
  display: table;
  width: auto;
}

.wp-block-table.aligncenter td,
.wp-block-table.aligncenter th,
.wp-block-table.alignleft td,
.wp-block-table.alignleft th,
.wp-block-table.alignright td,
.wp-block-table.alignright th {
  word-break: break-word;
}

.wp-block-table .has-subtle-light-gray-background-color {
  background-color: #f3f4f5;
}

.wp-block-table .has-subtle-pale-green-background-color {
  background-color: #e9fbe5;
}

.wp-block-table .has-subtle-pale-blue-background-color {
  background-color: #e7f5fe;
}

.wp-block-table .has-subtle-pale-pink-background-color {
  background-color: #fcf0ef;
}

.wp-block-table.is-style-stripes {
  background-color: initial;
  border-bottom: 1px solid #f0f0f0;
  border-collapse: inherit;
  border-spacing: 0;
}

.wp-block-table.is-style-stripes tbody tr:nth-child(odd) {
  background-color: #f0f0f0;
}

.wp-block-table.is-style-stripes.has-subtle-light-gray-background-color
  tbody
  tr:nth-child(odd) {
  background-color: #f3f4f5;
}

.wp-block-table.is-style-stripes.has-subtle-pale-green-background-color
  tbody
  tr:nth-child(odd) {
  background-color: #e9fbe5;
}

.wp-block-table.is-style-stripes.has-subtle-pale-blue-background-color
  tbody
  tr:nth-child(odd) {
  background-color: #e7f5fe;
}

.wp-block-table.is-style-stripes.has-subtle-pale-pink-background-color
  tbody
  tr:nth-child(odd) {
  background-color: #fcf0ef;
}

.wp-block-table.is-style-stripes td,
.wp-block-table.is-style-stripes th {
  border-color: #0000;
}

.wp-block-table .has-border-color td,
.wp-block-table .has-border-color th,
.wp-block-table .has-border-color tr,
.wp-block-table .has-border-color > * {
  border-color: inherit;
}

.wp-block-table table[style*="border-top-color"] tr:first-child,
.wp-block-table table[style*="border-top-color"] tr:first-child td,
.wp-block-table table[style*="border-top-color"] tr:first-child th,
.wp-block-table table[style*="border-top-color"] > *,
.wp-block-table table[style*="border-top-color"] > * td,
.wp-block-table table[style*="border-top-color"] > * th {
  border-top-color: inherit;
}

.wp-block-table table[style*="border-top-color"] tr:not(:first-child) {
  border-top-color: initial;
}

.wp-block-table table[style*="border-right-color"] td:last-child,
.wp-block-table table[style*="border-right-color"] th,
.wp-block-table table[style*="border-right-color"] tr,
.wp-block-table table[style*="border-right-color"] > * {
  border-right-color: inherit;
}

.wp-block-table table[style*="border-bottom-color"] tr:last-child,
.wp-block-table table[style*="border-bottom-color"] tr:last-child td,
.wp-block-table table[style*="border-bottom-color"] tr:last-child th,
.wp-block-table table[style*="border-bottom-color"] > *,
.wp-block-table table[style*="border-bottom-color"] > * td,
.wp-block-table table[style*="border-bottom-color"] > * th {
  border-bottom-color: inherit;
}

.wp-block-table table[style*="border-bottom-color"] tr:not(:last-child) {
  border-bottom-color: initial;
}

.wp-block-table table[style*="border-left-color"] td:first-child,
.wp-block-table table[style*="border-left-color"] th,
.wp-block-table table[style*="border-left-color"] tr,
.wp-block-table table[style*="border-left-color"] > * {
  border-left-color: inherit;
}

.wp-block-table table[style*="border-style"] td,
.wp-block-table table[style*="border-style"] th,
.wp-block-table table[style*="border-style"] tr,
.wp-block-table table[style*="border-style"] > * {
  border-style: inherit;
}

.wp-block-table table[style*="border-width"] td,
.wp-block-table table[style*="border-width"] th,
.wp-block-table table[style*="border-width"] tr,
.wp-block-table table[style*="border-width"] > * {
  border-style: inherit;
  border-width: inherit;
}

:where(.wp-block-term-description) {
  margin-bottom: var(--wp--style--block-gap);
  margin-top: var(--wp--style--block-gap);
}

.wp-block-term-description p {
  margin-bottom: 0;
  margin-top: 0;
}

.wp-block-text-columns,
.wp-block-text-columns.aligncenter {
  display: flex;
}

.wp-block-text-columns .wp-block-column {
  margin: 0 1em;
  padding: 0;
}

.wp-block-text-columns .wp-block-column:first-child {
  margin-left: 0;
}

.wp-block-text-columns .wp-block-column:last-child {
  margin-right: 0;
}

.wp-block-text-columns.columns-2 .wp-block-column {
  width: 50%;
}

.wp-block-text-columns.columns-3 .wp-block-column {
  width: 33.33333%;
}

.wp-block-text-columns.columns-4 .wp-block-column {
  width: 25%;
}

pre.wp-block-verse {
  overflow: auto;
  white-space: pre-wrap;
}

:where(pre.wp-block-verse) {
  font-family: inherit;
}

.wp-block-video {
  box-sizing: border-box;
}

.wp-block-video video {
  vertical-align: middle;
  width: 100%;
}

@supports (position: sticky) {
  .wp-block-video [poster] {
    object-fit: cover;
  }
}

.wp-block-video.aligncenter {
  text-align: center;
}

.wp-block-video figcaption {
  margin-bottom: 1em;
  margin-top: 0.5em;
}

.editor-styles-wrapper,
.entry-content {
  counter-reset: footnotes;
}

a[data-fn].fn {
  counter-increment: footnotes;
  display: inline-flex;
  font-size: smaller;
  text-decoration: none;
  text-indent: -9999999px;
  vertical-align: super;
}

a[data-fn].fn:after {
  content: "[" counter(footnotes) "]";
  float: left;
  text-indent: 0;
}

.wp-element-button {
  cursor: pointer;
}

:root {
  --wp--preset--font-size--normal: 16px;
  --wp--preset--font-size--huge: 42px;
}

:root .has-very-light-gray-background-color {
  background-color: #eee;
}

:root .has-very-dark-gray-background-color {
  background-color: #313131;
}

:root .has-very-light-gray-color {
  color: #eee;
}

:root .has-very-dark-gray-color {
  color: #313131;
}

:root .has-vivid-green-cyan-to-vivid-cyan-blue-gradient-background {
  background: linear-gradient(135deg, #00d084, #0693e3);
}

:root .has-purple-crush-gradient-background {
  background: linear-gradient(135deg, #34e2e4, #4721fb 50%, #ab1dfe);
}

:root .has-hazy-dawn-gradient-background {
  background: linear-gradient(135deg, #faaca8, #dad0ec);
}

:root .has-subdued-olive-gradient-background {
  background: linear-gradient(135deg, #fafae1, #67a671);
}

:root .has-atomic-cream-gradient-background {
  background: linear-gradient(135deg, #fdd79a, #004a59);
}

:root .has-nightshade-gradient-background {
  background: linear-gradient(135deg, #330968, #31cdcf);
}

:root .has-midnight-gradient-background {
  background: linear-gradient(135deg, #020381, #2874fc);
}

.has-regular-font-size {
  font-size: 1em;
}

.has-larger-font-size {
  font-size: 2.625em;
}

.has-normal-font-size {
  font-size: var(--wp--preset--font-size--normal);
}

.has-huge-font-size {
  font-size: var(--wp--preset--font-size--huge);
}

.has-text-align-center {
  text-align: center;
}

.has-text-align-left {
  text-align: left;
}

.has-text-align-right {
  text-align: right;
}

#end-resizable-editor-section {
  display: none;
}

.aligncenter {
  clear: both;
}

.items-justified-left {
  justify-content: flex-start;
}

.items-justified-center {
  justify-content: center;
}

.items-justified-right {
  justify-content: flex-end;
}

.items-justified-space-between {
  justify-content: space-between;
}

.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  word-wrap: normal !important;
}

.screen-reader-text:focus {
  background-color: #ddd;
  clip: auto !important;
  -webkit-clip-path: none;
  clip-path: none;
  color: #444;
  display: block;
  font-size: 1em;
  height: auto;
  left: 5px;
  line-height: normal;
  padding: 15px 23px 14px;
  text-decoration: none;
  top: 5px;
  width: auto;
  z-index: 100000;
}

html :where(.has-border-color) {
  border-style: solid;
}

html :where([style*="border-top-color"]) {
  border-top-style: solid;
}

html :where([style*="border-right-color"]) {
  border-right-style: solid;
}

html :where([style*="border-bottom-color"]) {
  border-bottom-style: solid;
}

html :where([style*="border-left-color"]) {
  border-left-style: solid;
}

html :where([style*="border-width"]) {
  border-style: solid;
}

html :where([style*="border-top-width"]) {
  border-top-style: solid;
}

html :where([style*="border-right-width"]) {
  border-right-style: solid;
}

html :where([style*="border-bottom-width"]) {
  border-bottom-style: solid;
}

html :where([style*="border-left-width"]) {
  border-left-style: solid;
}

html :where(img[class*="wp-image-"]) {
  height: auto;
  max-width: 100%;
}

:where(figure) {
  margin: 0 0 1em;
}

html :where(.is-position-sticky) {
  --wp-admin--admin-bar--position-offset: var(
    --wp-admin--admin-bar--height,
    0px
  );
}

@media screen and (max-width: 600px) {
  html :where(.is-position-sticky) {
    --wp-admin--admin-bar--position-offset: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Blog/wordpress-style.min.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;EAME,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,YAAY;AACd;;AAEA;;;;;;;;;;;;;;EAcE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;;;;;;;;EAQE,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,SAAS;EACT,WAAW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;;;EAIE,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE;;;;IAIE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;;;IAIE,6BAA6B;EAC/B;AACF;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;EAeE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;EAaE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;;;;EAIE,kEAAkE;EAClE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;;;;;EAUE,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;EAIE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;;;;IAIE,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;;;;IAIE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;;;;IAIE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;;;;IAIE,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;;;;IAIE,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;;;;IAIE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAgEE,eAAe;EACjB;AACF;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kEAAkE;EAClE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE;;IAEE;;KAEC;EACH;;EAEA;;IAEE,sEAAsE;EACxE;;EAEA;;IAEE,qEAAqE;EACvE;;EAEA;;IAEE;;KAEC;EACH;;EAEA;;IAEE;;KAEC;EACH;;EAEA;;IAEE,yEAAyE;EAC3E;;EAEA;;IAEE;;KAEC;EACH;;EAEA;;;;;IAKE,qEAAqE;EACvE;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE;IACE,gBAAgB;IAChB,2DAAuJ;IACvJ,mDAA+I;IAC/I,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,0CAA0C;EAC1C,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,8CAA8C;EAC9C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,eAAe;IACf,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE;;;;;;;sCAOkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;;;;;;;sCAOkC;IAClC,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW,EAAE,kBAAkB;AACjC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW,EAAE,kBAAkB;AACjC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,kCAAkC;EAClC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;EACxD,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;EACb,YAAY;AACd;;AAEA;;;;;;EAME,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE;;;;IAIE,UAAU;IACV,SAAS;EACX;;EAEA;;;;IAIE,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;;;;IAIE,oBAAoB;EACtB;;EAEA;;;;;IAKE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;EAUE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,OAAO;EACP,SAAS;AACX;;AAEA;EACE;;;;IAIE,UAAU;IACV,MAAM;EACR;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;EAgBE,UAAU;EACV,QAAQ;AACV;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;IAoBE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;;EAEE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oDAAoD;EACpD,aAAa;EACb,2DAA2D;EAC3D,8CAA8C;EAC9C,0DAA0D;EAC1D,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oDAAoD;EACpD,aAAa;EACb,2DAA2D;EAC3D,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,wDAAwD;EACxD,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd;;;2DAGyD;EACzD,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;;EAEE,oEAAoE;EACpE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;;;;;;EASE,oEAAoE;EACpE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;;;IAGE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;;IAEE,OAAO;EACT;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,aAAa;EACb,2DAA2D;EAC3D,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;EAIE,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE;IACE,oBAAoB;IACpB,uBAAuB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;EAgBE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;EACd,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF","sourcesContent":["@charset \"UTF-8\";\n.wp-block-archives {\n  box-sizing: border-box;\n}\n\n.wp-block-archives-dropdown label {\n  display: block;\n}\n\n.wp-block-avatar {\n  line-height: 0;\n}\n\n.wp-block-avatar,\n.wp-block-avatar img {\n  box-sizing: border-box;\n}\n\n.wp-block-avatar.aligncenter {\n  text-align: center;\n}\n\n.wp-block-audio {\n  box-sizing: border-box;\n}\n\n.wp-block-audio figcaption {\n  margin-bottom: 1em;\n  margin-top: 0.5em;\n}\n\n.wp-block-audio audio {\n  min-width: 300px;\n  width: 100%;\n}\n\n.wp-block-button__link {\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  text-align: center;\n  word-break: break-word;\n}\n\n.wp-block-button__link.aligncenter {\n  text-align: center;\n}\n\n.wp-block-button__link.alignright {\n  text-align: right;\n}\n\n:where(.wp-block-button__link) {\n  border-radius: 9999px;\n  box-shadow: none;\n  padding: calc(0.667em + 2px) calc(1.333em + 2px);\n  text-decoration: none;\n}\n\n.wp-block-button[style*=\"text-decoration\"] .wp-block-button__link {\n  text-decoration: inherit;\n}\n\n.wp-block-buttons > .wp-block-button.has-custom-width {\n  max-width: none;\n}\n\n.wp-block-buttons > .wp-block-button.has-custom-width .wp-block-button__link {\n  width: 100%;\n}\n\n.wp-block-buttons\n  > .wp-block-button.has-custom-font-size\n  .wp-block-button__link {\n  font-size: inherit;\n}\n\n.wp-block-buttons > .wp-block-button.wp-block-button__width-25 {\n  width: calc(25% - var(--wp--style--block-gap, 0.5em) * 0.75);\n}\n\n.wp-block-buttons > .wp-block-button.wp-block-button__width-50 {\n  width: calc(50% - var(--wp--style--block-gap, 0.5em) * 0.5);\n}\n\n.wp-block-buttons > .wp-block-button.wp-block-button__width-75 {\n  width: calc(75% - var(--wp--style--block-gap, 0.5em) * 0.25);\n}\n\n.wp-block-buttons > .wp-block-button.wp-block-button__width-100 {\n  flex-basis: 100%;\n  width: 100%;\n}\n\n.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-25 {\n  width: 25%;\n}\n\n.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-50 {\n  width: 50%;\n}\n\n.wp-block-buttons.is-vertical > .wp-block-button.wp-block-button__width-75 {\n  width: 75%;\n}\n\n.wp-block-button.is-style-squared,\n.wp-block-button__link.wp-block-button.is-style-squared {\n  border-radius: 0;\n}\n\n.wp-block-button.no-border-radius,\n.wp-block-button__link.no-border-radius {\n  border-radius: 0 !important;\n}\n\n.wp-block-button .wp-block-button__link:where(.is-style-outline),\n.wp-block-button:where(.is-style-outline) > .wp-block-button__link {\n  border: 2px solid;\n  padding: 0.667em 1.333em;\n}\n\n.wp-block-button\n  .wp-block-button__link:where(.is-style-outline):not(.has-text-color),\n.wp-block-button:where(.is-style-outline)\n  > .wp-block-button__link:not(.has-text-color) {\n  color: currentColor;\n}\n\n.wp-block-button\n  .wp-block-button__link:where(.is-style-outline):not(.has-background),\n.wp-block-button:where(.is-style-outline)\n  > .wp-block-button__link:not(.has-background) {\n  background-color: initial;\n  background-image: none;\n}\n\n.wp-block-button .wp-block-button__link:where(.has-border-color) {\n  border-width: initial;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-top-color\"]) {\n  border-top-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-right-color\"]) {\n  border-right-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-bottom-color\"]) {\n  border-bottom-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-left-color\"]) {\n  border-left-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-style\"]) {\n  border-width: initial;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-top-style\"]) {\n  border-top-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-right-style\"]) {\n  border-right-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-bottom-style\"]) {\n  border-bottom-width: medium;\n}\n\n.wp-block-button .wp-block-button__link:where([style*=\"border-left-style\"]) {\n  border-left-width: medium;\n}\n\n.wp-block-buttons.is-vertical {\n  flex-direction: column;\n}\n\n.wp-block-buttons.is-vertical > .wp-block-button:last-child {\n  margin-bottom: 0;\n}\n\n.wp-block-buttons > .wp-block-button {\n  display: inline-block;\n  margin: 0;\n}\n\n.wp-block-buttons.is-content-justification-left {\n  justify-content: flex-start;\n}\n\n.wp-block-buttons.is-content-justification-left.is-vertical {\n  align-items: flex-start;\n}\n\n.wp-block-buttons.is-content-justification-center {\n  justify-content: center;\n}\n\n.wp-block-buttons.is-content-justification-center.is-vertical {\n  align-items: center;\n}\n\n.wp-block-buttons.is-content-justification-right {\n  justify-content: flex-end;\n}\n\n.wp-block-buttons.is-content-justification-right.is-vertical {\n  align-items: flex-end;\n}\n\n.wp-block-buttons.is-content-justification-space-between {\n  justify-content: space-between;\n}\n\n.wp-block-buttons.aligncenter {\n  text-align: center;\n}\n\n.wp-block-buttons:not(\n    .is-content-justification-space-between,\n    .is-content-justification-right,\n    .is-content-justification-left,\n    .is-content-justification-center\n  )\n  .wp-block-button.aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.wp-block-buttons[style*=\"text-decoration\"] .wp-block-button,\n.wp-block-buttons[style*=\"text-decoration\"] .wp-block-button__link {\n  text-decoration: inherit;\n}\n\n.wp-block-buttons.has-custom-font-size .wp-block-button__link {\n  font-size: inherit;\n}\n\n.wp-block-button.aligncenter,\n.wp-block-calendar {\n  text-align: center;\n}\n\n.wp-block-calendar td,\n.wp-block-calendar th {\n  border: 1px solid;\n  padding: 0.25em;\n}\n\n.wp-block-calendar th {\n  font-weight: 400;\n}\n\n.wp-block-calendar caption {\n  background-color: inherit;\n}\n\n.wp-block-calendar table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.wp-block-calendar table:where(:not(.has-text-color)) {\n  color: #40464d;\n}\n\n.wp-block-calendar table:where(:not(.has-text-color)) td,\n.wp-block-calendar table:where(:not(.has-text-color)) th {\n  border-color: #ddd;\n}\n\n.wp-block-calendar table.has-background th {\n  background-color: inherit;\n}\n\n.wp-block-calendar table.has-text-color th {\n  color: inherit;\n}\n\n:where(.wp-block-calendar table:not(.has-background) th) {\n  background: #ddd;\n}\n\n.wp-block-categories {\n  box-sizing: border-box;\n}\n\n.wp-block-categories.alignleft {\n  margin-right: 2em;\n}\n\n.wp-block-categories.alignright {\n  margin-left: 2em;\n}\n\n.wp-block-categories.wp-block-categories-dropdown.aligncenter {\n  text-align: center;\n}\n\n.wp-block-code {\n  box-sizing: border-box;\n}\n\n.wp-block-code code {\n  display: block;\n  font-family: inherit;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.wp-block-columns {\n  align-items: normal !important;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap !important;\n}\n\n@media (min-width: 782px) {\n  .wp-block-columns {\n    flex-wrap: nowrap !important;\n  }\n}\n\n.wp-block-columns.are-vertically-aligned-top {\n  align-items: flex-start;\n}\n\n.wp-block-columns.are-vertically-aligned-center {\n  align-items: center;\n}\n\n.wp-block-columns.are-vertically-aligned-bottom {\n  align-items: flex-end;\n}\n\n@media (max-width: 781px) {\n  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {\n    flex-basis: 100% !important;\n  }\n}\n\n@media (min-width: 782px) {\n  .wp-block-columns:not(.is-not-stacked-on-mobile) > .wp-block-column {\n    flex-basis: 0;\n    flex-grow: 1;\n  }\n\n  .wp-block-columns:not(.is-not-stacked-on-mobile)\n    > .wp-block-column[style*=\"flex-basis\"] {\n    flex-grow: 0;\n  }\n}\n\n.wp-block-columns.is-not-stacked-on-mobile {\n  flex-wrap: nowrap !important;\n}\n\n.wp-block-columns.is-not-stacked-on-mobile > .wp-block-column {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n\n.wp-block-columns.is-not-stacked-on-mobile\n  > .wp-block-column[style*=\"flex-basis\"] {\n  flex-grow: 0;\n}\n\n:where(.wp-block-columns) {\n  margin-bottom: 1.75em;\n}\n\n:where(.wp-block-columns.has-background) {\n  padding: 1.25em 2.375em;\n}\n\n.wp-block-column {\n  flex-grow: 1;\n  min-width: 0;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.wp-block-column.is-vertically-aligned-top {\n  align-self: flex-start;\n}\n\n.wp-block-column.is-vertically-aligned-center {\n  align-self: center;\n}\n\n.wp-block-column.is-vertically-aligned-bottom {\n  align-self: flex-end;\n}\n\n.wp-block-column.is-vertically-aligned-stretch {\n  align-self: stretch;\n}\n\n.wp-block-column.is-vertically-aligned-bottom,\n.wp-block-column.is-vertically-aligned-center,\n.wp-block-column.is-vertically-aligned-top {\n  width: 100%;\n}\n\n.wp-block-post-comments {\n  box-sizing: border-box;\n}\n\n.wp-block-post-comments .alignleft {\n  float: left;\n}\n\n.wp-block-post-comments .alignright {\n  float: right;\n}\n\n.wp-block-post-comments .navigation:after {\n  clear: both;\n  content: \"\";\n  display: table;\n}\n\n.wp-block-post-comments .commentlist {\n  clear: both;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.wp-block-post-comments .commentlist .comment {\n  min-height: 2.25em;\n  padding-left: 3.25em;\n}\n\n.wp-block-post-comments .commentlist .comment p {\n  font-size: 1em;\n  line-height: 1.8;\n  margin: 1em 0;\n}\n\n.wp-block-post-comments .commentlist .children {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.wp-block-post-comments .comment-author {\n  line-height: 1.5;\n}\n\n.wp-block-post-comments .comment-author .avatar {\n  border-radius: 1.5em;\n  display: block;\n  float: left;\n  height: 2.5em;\n  margin-right: 0.75em;\n  margin-top: 0.5em;\n  width: 2.5em;\n}\n\n.wp-block-post-comments .comment-author cite {\n  font-style: normal;\n}\n\n.wp-block-post-comments .comment-meta {\n  font-size: 0.875em;\n  line-height: 1.5;\n}\n\n.wp-block-post-comments .comment-meta b {\n  font-weight: 400;\n}\n\n.wp-block-post-comments .comment-meta .comment-awaiting-moderation {\n  display: block;\n  margin-bottom: 1em;\n  margin-top: 1em;\n}\n\n.wp-block-post-comments .comment-body .commentmetadata {\n  font-size: 0.875em;\n}\n\n.wp-block-post-comments .comment-form-author label,\n.wp-block-post-comments .comment-form-comment label,\n.wp-block-post-comments .comment-form-email label,\n.wp-block-post-comments .comment-form-url label {\n  display: block;\n  margin-bottom: 0.25em;\n}\n\n.wp-block-post-comments\n  .comment-form\n  input:not([type=\"submit\"]):not([type=\"checkbox\"]),\n.wp-block-post-comments .comment-form textarea {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n}\n\n.wp-block-post-comments .comment-form-cookies-consent {\n  display: flex;\n  gap: 0.25em;\n}\n\n.wp-block-post-comments\n  .comment-form-cookies-consent\n  #wp-comment-cookies-consent {\n  margin-top: 0.35em;\n}\n\n.wp-block-post-comments .comment-reply-title {\n  margin-bottom: 0;\n}\n\n.wp-block-post-comments .comment-reply-title :where(small) {\n  font-size: var(--wp--preset--font-size--medium, smaller);\n  margin-left: 0.5em;\n}\n\n.wp-block-post-comments .reply {\n  font-size: 0.875em;\n  margin-bottom: 1.4em;\n}\n\n.wp-block-post-comments input:not([type=\"submit\"]),\n.wp-block-post-comments textarea {\n  border: 1px solid #949494;\n  font-family: inherit;\n  font-size: 1em;\n}\n\n.wp-block-post-comments input:not([type=\"submit\"]):not([type=\"checkbox\"]),\n.wp-block-post-comments textarea {\n  padding: calc(0.667em + 2px);\n}\n\n:where(.wp-block-post-comments input[type=\"submit\"]) {\n  border: none;\n}\n\n.wp-block-comments-pagination > .wp-block-comments-pagination-next,\n.wp-block-comments-pagination > .wp-block-comments-pagination-numbers,\n.wp-block-comments-pagination > .wp-block-comments-pagination-previous {\n  margin-bottom: 0.5em;\n  margin-right: 0.5em;\n}\n\n.wp-block-comments-pagination > .wp-block-comments-pagination-next:last-child,\n.wp-block-comments-pagination\n  > .wp-block-comments-pagination-numbers:last-child,\n.wp-block-comments-pagination\n  > .wp-block-comments-pagination-previous:last-child {\n  margin-right: 0;\n}\n\n.wp-block-comments-pagination .wp-block-comments-pagination-previous-arrow {\n  display: inline-block;\n  margin-right: 1ch;\n}\n\n.wp-block-comments-pagination\n  .wp-block-comments-pagination-previous-arrow:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-comments-pagination .wp-block-comments-pagination-next-arrow {\n  display: inline-block;\n  margin-left: 1ch;\n}\n\n.wp-block-comments-pagination\n  .wp-block-comments-pagination-next-arrow:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-comments-pagination.aligncenter {\n  justify-content: center;\n}\n\n.wp-block-comment-template {\n  box-sizing: border-box;\n  list-style: none;\n  margin-bottom: 0;\n  max-width: 100%;\n  padding: 0;\n}\n\n.wp-block-comment-template li {\n  clear: both;\n}\n\n.wp-block-comment-template ol {\n  list-style: none;\n  margin-bottom: 0;\n  max-width: 100%;\n  padding-left: 2rem;\n}\n\n.wp-block-comment-template.alignleft {\n  float: left;\n}\n\n.wp-block-comment-template.aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.wp-block-comment-template.alignright {\n  float: right;\n}\n\n.wp-block-cover,\n.wp-block-cover-image {\n  align-items: center;\n  background-position: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  min-height: 430px;\n  overflow: hidden;\n  overflow: clip;\n  padding: 1em;\n  position: relative;\n}\n\n.wp-block-cover .has-background-dim:not([class*=\"-background-color\"]),\n.wp-block-cover-image .has-background-dim:not([class*=\"-background-color\"]),\n.wp-block-cover-image.has-background-dim:not([class*=\"-background-color\"]),\n.wp-block-cover.has-background-dim:not([class*=\"-background-color\"]) {\n  background-color: #000;\n}\n\n.wp-block-cover .has-background-dim.has-background-gradient,\n.wp-block-cover-image .has-background-dim.has-background-gradient {\n  background-color: initial;\n}\n\n.wp-block-cover-image.has-background-dim:before,\n.wp-block-cover.has-background-dim:before {\n  background-color: inherit;\n  content: \"\";\n}\n\n.wp-block-cover .wp-block-cover__background,\n.wp-block-cover .wp-block-cover__gradient-background,\n.wp-block-cover-image .wp-block-cover__background,\n.wp-block-cover-image .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim:not(.has-background-gradient):before,\n.wp-block-cover.has-background-dim:not(.has-background-gradient):before {\n  bottom: 0;\n  left: 0;\n  opacity: 0.5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-10\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-10\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-10:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-10\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-10\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-10:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.1;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-20\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-20\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-20:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-20\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-20\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-20:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.2;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-30\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-30\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-30:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-30\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-30\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-30:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.3;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-40\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-40\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-40:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-40\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-40\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-40:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.4;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-50\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-50\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-50:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-50\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-50\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-50:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.5;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-60\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-60\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-60:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-60\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-60\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-60:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.6;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-70\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-70\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-70:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-70\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-70\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-70:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.7;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-80\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-80\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-80:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-80\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-80\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-80:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.8;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-90\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-90\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-90:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-90\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-90\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-90:not(\n    .has-background-gradient\n  ):before {\n  opacity: 0.9;\n}\n\n.wp-block-cover-image.has-background-dim.has-background-dim-100\n  .wp-block-cover__background,\n.wp-block-cover-image.has-background-dim.has-background-dim-100\n  .wp-block-cover__gradient-background,\n.wp-block-cover-image.has-background-dim.has-background-dim-100:not(\n    .has-background-gradient\n  ):before,\n.wp-block-cover.has-background-dim.has-background-dim-100\n  .wp-block-cover__background,\n.wp-block-cover.has-background-dim.has-background-dim-100\n  .wp-block-cover__gradient-background,\n.wp-block-cover.has-background-dim.has-background-dim-100:not(\n    .has-background-gradient\n  ):before {\n  opacity: 1;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-0,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-0,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-0,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-0 {\n  opacity: 0;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-10,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-10,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-10,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-10 {\n  opacity: 0.1;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-20,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-20,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-20,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-20 {\n  opacity: 0.2;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-30,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-30,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-30,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-30 {\n  opacity: 0.3;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-40,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-40,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-40,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-40 {\n  opacity: 0.4;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-50,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-50,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-50,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-50 {\n  opacity: 0.5;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-60,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-60,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-60,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-60 {\n  opacity: 0.6;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-70,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-70,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-70,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-70 {\n  opacity: 0.7;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-80,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-80,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-80,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-80 {\n  opacity: 0.8;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-90,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-90,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-90,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-90 {\n  opacity: 0.9;\n}\n\n.wp-block-cover\n  .wp-block-cover__background.has-background-dim.has-background-dim-100,\n.wp-block-cover\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-100,\n.wp-block-cover-image\n  .wp-block-cover__background.has-background-dim.has-background-dim-100,\n.wp-block-cover-image\n  .wp-block-cover__gradient-background.has-background-dim.has-background-dim-100 {\n  opacity: 1;\n}\n\n.wp-block-cover-image.alignleft,\n.wp-block-cover-image.alignright,\n.wp-block-cover.alignleft,\n.wp-block-cover.alignright {\n  max-width: 420px;\n  width: 100%;\n}\n\n.wp-block-cover-image:after,\n.wp-block-cover:after {\n  content: \"\";\n  display: block;\n  font-size: 0;\n  min-height: inherit;\n}\n\n@supports (position: sticky) {\n  .wp-block-cover-image:after,\n  .wp-block-cover:after {\n    content: none;\n  }\n}\n\n.wp-block-cover-image.aligncenter,\n.wp-block-cover-image.alignleft,\n.wp-block-cover-image.alignright,\n.wp-block-cover.aligncenter,\n.wp-block-cover.alignleft,\n.wp-block-cover.alignright {\n  display: flex;\n}\n\n.wp-block-cover .wp-block-cover__inner-container,\n.wp-block-cover-image .wp-block-cover__inner-container {\n  color: inherit;\n  width: 100%;\n  z-index: 1;\n}\n\n.wp-block-cover h1:where(:not(.has-text-color)),\n.wp-block-cover h2:where(:not(.has-text-color)),\n.wp-block-cover h3:where(:not(.has-text-color)),\n.wp-block-cover h4:where(:not(.has-text-color)),\n.wp-block-cover h5:where(:not(.has-text-color)),\n.wp-block-cover h6:where(:not(.has-text-color)),\n.wp-block-cover p:where(:not(.has-text-color)),\n.wp-block-cover-image h1:where(:not(.has-text-color)),\n.wp-block-cover-image h2:where(:not(.has-text-color)),\n.wp-block-cover-image h3:where(:not(.has-text-color)),\n.wp-block-cover-image h4:where(:not(.has-text-color)),\n.wp-block-cover-image h5:where(:not(.has-text-color)),\n.wp-block-cover-image h6:where(:not(.has-text-color)),\n.wp-block-cover-image p:where(:not(.has-text-color)) {\n  color: inherit;\n}\n\n.wp-block-cover-image.is-position-top-left,\n.wp-block-cover.is-position-top-left {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.wp-block-cover-image.is-position-top-center,\n.wp-block-cover.is-position-top-center {\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.wp-block-cover-image.is-position-top-right,\n.wp-block-cover.is-position-top-right {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n\n.wp-block-cover-image.is-position-center-left,\n.wp-block-cover.is-position-center-left {\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.wp-block-cover-image.is-position-center-center,\n.wp-block-cover.is-position-center-center {\n  align-items: center;\n  justify-content: center;\n}\n\n.wp-block-cover-image.is-position-center-right,\n.wp-block-cover.is-position-center-right {\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.wp-block-cover-image.is-position-bottom-left,\n.wp-block-cover.is-position-bottom-left {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n.wp-block-cover-image.is-position-bottom-center,\n.wp-block-cover.is-position-bottom-center {\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.wp-block-cover-image.is-position-bottom-right,\n.wp-block-cover.is-position-bottom-right {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position\n  .wp-block-cover__inner-container {\n  margin: 0;\n}\n\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-bottom-left\n  .wp-block-cover__inner-container,\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-bottom-right\n  .wp-block-cover__inner-container,\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-center-left\n  .wp-block-cover__inner-container,\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-center-right\n  .wp-block-cover__inner-container,\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-top-left\n  .wp-block-cover__inner-container,\n.wp-block-cover-image.has-custom-content-position.has-custom-content-position.is-position-top-right\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-bottom-left\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-bottom-right\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-center-left\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-center-right\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-top-left\n  .wp-block-cover__inner-container,\n.wp-block-cover.has-custom-content-position.has-custom-content-position.is-position-top-right\n  .wp-block-cover__inner-container {\n  margin: 0;\n  width: auto;\n}\n\n.wp-block-cover .wp-block-cover__image-background,\n.wp-block-cover video.wp-block-cover__video-background,\n.wp-block-cover-image .wp-block-cover__image-background,\n.wp-block-cover-image video.wp-block-cover__video-background {\n  border: none;\n  bottom: 0;\n  box-shadow: none;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  max-height: none;\n  max-width: none;\n  object-fit: cover;\n  outline: none;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\n.wp-block-cover-image.has-parallax,\n.wp-block-cover.has-parallax,\n.wp-block-cover__image-background.has-parallax,\nvideo.wp-block-cover__video-background.has-parallax {\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n@supports (-webkit-touch-callout: inherit) {\n  .wp-block-cover-image.has-parallax,\n  .wp-block-cover.has-parallax,\n  .wp-block-cover__image-background.has-parallax,\n  video.wp-block-cover__video-background.has-parallax {\n    background-attachment: scroll;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wp-block-cover-image.has-parallax,\n  .wp-block-cover.has-parallax,\n  .wp-block-cover__image-background.has-parallax,\n  video.wp-block-cover__video-background.has-parallax {\n    background-attachment: scroll;\n  }\n}\n\n.wp-block-cover-image.is-repeated,\n.wp-block-cover.is-repeated,\n.wp-block-cover__image-background.is-repeated,\nvideo.wp-block-cover__video-background.is-repeated {\n  background-repeat: repeat;\n  background-size: auto;\n}\n\n.wp-block-cover__image-background,\n.wp-block-cover__video-background {\n  z-index: 0;\n}\n\n.wp-block-cover-image-text,\n.wp-block-cover-image-text a,\n.wp-block-cover-image-text a:active,\n.wp-block-cover-image-text a:focus,\n.wp-block-cover-image-text a:hover,\n.wp-block-cover-text,\n.wp-block-cover-text a,\n.wp-block-cover-text a:active,\n.wp-block-cover-text a:focus,\n.wp-block-cover-text a:hover,\nsection.wp-block-cover-image h2,\nsection.wp-block-cover-image h2 a,\nsection.wp-block-cover-image h2 a:active,\nsection.wp-block-cover-image h2 a:focus,\nsection.wp-block-cover-image h2 a:hover {\n  color: #fff;\n}\n\n.wp-block-cover-image .wp-block-cover.has-left-content {\n  justify-content: flex-start;\n}\n\n.wp-block-cover-image .wp-block-cover.has-right-content {\n  justify-content: flex-end;\n}\n\n.wp-block-cover-image.has-left-content .wp-block-cover-image-text,\n.wp-block-cover.has-left-content .wp-block-cover-text,\nsection.wp-block-cover-image.has-left-content > h2 {\n  margin-left: 0;\n  text-align: left;\n}\n\n.wp-block-cover-image.has-right-content .wp-block-cover-image-text,\n.wp-block-cover.has-right-content .wp-block-cover-text,\nsection.wp-block-cover-image.has-right-content > h2 {\n  margin-right: 0;\n  text-align: right;\n}\n\n.wp-block-cover .wp-block-cover-text,\n.wp-block-cover-image .wp-block-cover-image-text,\nsection.wp-block-cover-image > h2 {\n  font-size: 2em;\n  line-height: 1.25;\n  margin-bottom: 0;\n  max-width: 840px;\n  padding: 0.44em;\n  text-align: center;\n  z-index: 1;\n}\n\n:where(.wp-block-cover-image:not(.has-text-color)),\n:where(.wp-block-cover:not(.has-text-color)) {\n  color: #fff;\n}\n\n:where(.wp-block-cover-image.is-light:not(.has-text-color)),\n:where(.wp-block-cover.is-light:not(.has-text-color)) {\n  color: #000;\n}\n\n.wp-block-details {\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.wp-block-details summary {\n  cursor: pointer;\n}\n\n.wp-block-embed.alignleft,\n.wp-block-embed.alignright,\n.wp-block[data-align=\"left\"] > [data-type=\"core/embed\"],\n.wp-block[data-align=\"right\"] > [data-type=\"core/embed\"] {\n  max-width: 360px;\n  width: 100%;\n}\n\n.wp-block-embed.alignleft .wp-block-embed__wrapper,\n.wp-block-embed.alignright .wp-block-embed__wrapper,\n.wp-block[data-align=\"left\"]\n  > [data-type=\"core/embed\"]\n  .wp-block-embed__wrapper,\n.wp-block[data-align=\"right\"]\n  > [data-type=\"core/embed\"]\n  .wp-block-embed__wrapper {\n  min-width: 280px;\n}\n\n.wp-block-cover .wp-block-embed {\n  min-height: 240px;\n  min-width: 320px;\n}\n\n.wp-block-embed {\n  overflow-wrap: break-word;\n}\n\n.wp-block-embed figcaption {\n  margin-bottom: 1em;\n  margin-top: 0.5em;\n}\n\n.wp-block-embed iframe {\n  max-width: 100%;\n}\n\n.wp-block-embed__wrapper {\n  position: relative;\n}\n\n.wp-embed-responsive .wp-has-aspect-ratio .wp-block-embed__wrapper:before {\n  content: \"\";\n  display: block;\n  padding-top: 50%;\n}\n\n.wp-embed-responsive .wp-has-aspect-ratio iframe {\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-21-9 .wp-block-embed__wrapper:before {\n  padding-top: 42.85%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-18-9 .wp-block-embed__wrapper:before {\n  padding-top: 50%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-16-9 .wp-block-embed__wrapper:before {\n  padding-top: 56.25%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-4-3 .wp-block-embed__wrapper:before {\n  padding-top: 75%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-1-1 .wp-block-embed__wrapper:before {\n  padding-top: 100%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-9-16 .wp-block-embed__wrapper:before {\n  padding-top: 177.77%;\n}\n\n.wp-embed-responsive .wp-embed-aspect-1-2 .wp-block-embed__wrapper:before {\n  padding-top: 200%;\n}\n\n.wp-block-file {\n  box-sizing: border-box;\n}\n\n.wp-block-file:not(.wp-element-button) {\n  font-size: 0.8em;\n}\n\n.wp-block-file.aligncenter {\n  text-align: center;\n}\n\n.wp-block-file.alignright {\n  text-align: right;\n}\n\n.wp-block-file * + .wp-block-file__button {\n  margin-left: 0.75em;\n}\n\n:where(.wp-block-file) {\n  margin-bottom: 1.5em;\n}\n\n.wp-block-file__embed {\n  margin-bottom: 1em;\n}\n\n:where(.wp-block-file__button) {\n  border-radius: 2em;\n  display: inline-block;\n  padding: 0.5em 1em;\n}\n\n:where(.wp-block-file__button):is(a):active,\n:where(.wp-block-file__button):is(a):focus,\n:where(.wp-block-file__button):is(a):hover,\n:where(.wp-block-file__button):is(a):visited {\n  box-shadow: none;\n  color: #fff;\n  opacity: 0.85;\n  text-decoration: none;\n}\n\n.wp-block-form-input__label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25em;\n  margin-bottom: 0.5em;\n  width: 100%;\n}\n\n.wp-block-form-input__label.is-label-inline {\n  align-items: center;\n  flex-direction: row;\n  gap: 0.5em;\n}\n\n.wp-block-form-input__label.is-label-inline\n  .wp-block-form-input__label-content {\n  margin-bottom: 0.5em;\n}\n\n.wp-block-form-input__label:has(input[type=\"checkbox\"]) {\n  flex-direction: row-reverse;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.wp-block-form-input__label-content {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.wp-block-form-input__input {\n  font-size: 1em;\n  margin-bottom: 0.5em;\n  padding: 0 0.5em;\n}\n\n.wp-block-form-input__input[type=\"date\"],\n.wp-block-form-input__input[type=\"datetime-local\"],\n.wp-block-form-input__input[type=\"datetime\"],\n.wp-block-form-input__input[type=\"email\"],\n.wp-block-form-input__input[type=\"month\"],\n.wp-block-form-input__input[type=\"number\"],\n.wp-block-form-input__input[type=\"password\"],\n.wp-block-form-input__input[type=\"search\"],\n.wp-block-form-input__input[type=\"tel\"],\n.wp-block-form-input__input[type=\"text\"],\n.wp-block-form-input__input[type=\"time\"],\n.wp-block-form-input__input[type=\"url\"],\n.wp-block-form-input__input[type=\"week\"] {\n  border: 1px solid;\n  line-height: 2;\n  min-height: 2em;\n}\n\ntextarea.wp-block-form-input__input {\n  min-height: 10em;\n}\n\n.blocks-gallery-grid:not(.has-nested-images),\n.wp-block-gallery:not(.has-nested-images) {\n  display: flex;\n  flex-wrap: wrap;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image,\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  margin: 0 1em 1em 0;\n  position: relative;\n  width: calc(50% - 1em);\n}\n\n.blocks-gallery-grid:not(.has-nested-images)\n  .blocks-gallery-image:nth-of-type(2n),\n.blocks-gallery-grid:not(.has-nested-images)\n  .blocks-gallery-item:nth-of-type(2n),\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image:nth-of-type(2n),\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item:nth-of-type(2n) {\n  margin-right: 0;\n}\n\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image figure,\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item figure,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figure,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figure {\n  align-items: flex-end;\n  display: flex;\n  height: 100%;\n  justify-content: flex-start;\n  margin: 0;\n}\n\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image img,\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item img,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image img,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item img {\n  display: block;\n  height: auto;\n  max-width: 100%;\n  width: auto;\n}\n\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image figcaption,\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item figcaption,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figcaption,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figcaption {\n  background: linear-gradient(0deg, #000000b3, #0000004d 70%, #0000);\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  font-size: 0.8em;\n  margin: 0;\n  max-height: 100%;\n  overflow: auto;\n  padding: 3em 0.77em 0.7em;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: 2;\n}\n\n.blocks-gallery-grid:not(.has-nested-images)\n  .blocks-gallery-image\n  figcaption\n  img,\n.blocks-gallery-grid:not(.has-nested-images)\n  .blocks-gallery-item\n  figcaption\n  img,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image figcaption img,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item figcaption img {\n  display: inline;\n}\n\n.blocks-gallery-grid:not(.has-nested-images) figcaption,\n.wp-block-gallery:not(.has-nested-images) figcaption {\n  flex-grow: 1;\n}\n\n.blocks-gallery-grid:not(.has-nested-images).is-cropped .blocks-gallery-image a,\n.blocks-gallery-grid:not(.has-nested-images).is-cropped\n  .blocks-gallery-image\n  img,\n.blocks-gallery-grid:not(.has-nested-images).is-cropped .blocks-gallery-item a,\n.blocks-gallery-grid:not(.has-nested-images).is-cropped\n  .blocks-gallery-item\n  img,\n.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-image a,\n.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-image img,\n.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-item a,\n.wp-block-gallery:not(.has-nested-images).is-cropped .blocks-gallery-item img {\n  flex: 1;\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.blocks-gallery-grid:not(.has-nested-images).columns-1 .blocks-gallery-image,\n.blocks-gallery-grid:not(.has-nested-images).columns-1 .blocks-gallery-item,\n.wp-block-gallery:not(.has-nested-images).columns-1 .blocks-gallery-image,\n.wp-block-gallery:not(.has-nested-images).columns-1 .blocks-gallery-item {\n  margin-right: 0;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .blocks-gallery-grid:not(.has-nested-images).columns-3 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-3 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-3 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-3 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(33.33333% - 0.66667em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-4 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-4 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-4 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-4 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(25% - 0.75em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-5 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-5 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-5 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-5 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(20% - 0.8em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-6 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-6 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-6 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-6 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(16.66667% - 0.83333em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-7 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-7 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-7 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-7 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(14.28571% - 0.85714em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-8 .blocks-gallery-image,\n  .blocks-gallery-grid:not(.has-nested-images).columns-8 .blocks-gallery-item,\n  .wp-block-gallery:not(.has-nested-images).columns-8 .blocks-gallery-image,\n  .wp-block-gallery:not(.has-nested-images).columns-8 .blocks-gallery-item {\n    margin-right: 1em;\n    width: calc(12.5% - 0.875em);\n  }\n\n  .blocks-gallery-grid:not(.has-nested-images).columns-1\n    .blocks-gallery-image:nth-of-type(1n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-1\n    .blocks-gallery-item:nth-of-type(1n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-2\n    .blocks-gallery-image:nth-of-type(2n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-2\n    .blocks-gallery-item:nth-of-type(2n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-3\n    .blocks-gallery-image:nth-of-type(3n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-3\n    .blocks-gallery-item:nth-of-type(3n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-4\n    .blocks-gallery-image:nth-of-type(4n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-4\n    .blocks-gallery-item:nth-of-type(4n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-5\n    .blocks-gallery-image:nth-of-type(5n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-5\n    .blocks-gallery-item:nth-of-type(5n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-6\n    .blocks-gallery-image:nth-of-type(6n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-6\n    .blocks-gallery-item:nth-of-type(6n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-7\n    .blocks-gallery-image:nth-of-type(7n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-7\n    .blocks-gallery-item:nth-of-type(7n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-8\n    .blocks-gallery-image:nth-of-type(8n),\n  .blocks-gallery-grid:not(.has-nested-images).columns-8\n    .blocks-gallery-item:nth-of-type(8n),\n  .wp-block-gallery:not(.has-nested-images).columns-1\n    .blocks-gallery-image:nth-of-type(1n),\n  .wp-block-gallery:not(.has-nested-images).columns-1\n    .blocks-gallery-item:nth-of-type(1n),\n  .wp-block-gallery:not(.has-nested-images).columns-2\n    .blocks-gallery-image:nth-of-type(2n),\n  .wp-block-gallery:not(.has-nested-images).columns-2\n    .blocks-gallery-item:nth-of-type(2n),\n  .wp-block-gallery:not(.has-nested-images).columns-3\n    .blocks-gallery-image:nth-of-type(3n),\n  .wp-block-gallery:not(.has-nested-images).columns-3\n    .blocks-gallery-item:nth-of-type(3n),\n  .wp-block-gallery:not(.has-nested-images).columns-4\n    .blocks-gallery-image:nth-of-type(4n),\n  .wp-block-gallery:not(.has-nested-images).columns-4\n    .blocks-gallery-item:nth-of-type(4n),\n  .wp-block-gallery:not(.has-nested-images).columns-5\n    .blocks-gallery-image:nth-of-type(5n),\n  .wp-block-gallery:not(.has-nested-images).columns-5\n    .blocks-gallery-item:nth-of-type(5n),\n  .wp-block-gallery:not(.has-nested-images).columns-6\n    .blocks-gallery-image:nth-of-type(6n),\n  .wp-block-gallery:not(.has-nested-images).columns-6\n    .blocks-gallery-item:nth-of-type(6n),\n  .wp-block-gallery:not(.has-nested-images).columns-7\n    .blocks-gallery-image:nth-of-type(7n),\n  .wp-block-gallery:not(.has-nested-images).columns-7\n    .blocks-gallery-item:nth-of-type(7n),\n  .wp-block-gallery:not(.has-nested-images).columns-8\n    .blocks-gallery-image:nth-of-type(8n),\n  .wp-block-gallery:not(.has-nested-images).columns-8\n    .blocks-gallery-item:nth-of-type(8n) {\n    margin-right: 0;\n  }\n}\n\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-image:last-child,\n.blocks-gallery-grid:not(.has-nested-images) .blocks-gallery-item:last-child,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-image:last-child,\n.wp-block-gallery:not(.has-nested-images) .blocks-gallery-item:last-child {\n  margin-right: 0;\n}\n\n.blocks-gallery-grid:not(.has-nested-images).alignleft,\n.blocks-gallery-grid:not(.has-nested-images).alignright,\n.wp-block-gallery:not(.has-nested-images).alignleft,\n.wp-block-gallery:not(.has-nested-images).alignright {\n  max-width: 420px;\n  width: 100%;\n}\n\n.blocks-gallery-grid:not(.has-nested-images).aligncenter\n  .blocks-gallery-item\n  figure,\n.wp-block-gallery:not(.has-nested-images).aligncenter\n  .blocks-gallery-item\n  figure {\n  justify-content: center;\n}\n\n.wp-block-gallery:not(.is-cropped) .blocks-gallery-item {\n  align-self: flex-start;\n}\n\nfigure.wp-block-gallery.has-nested-images {\n  align-items: normal;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image:not(#individual-image) {\n  margin: 0;\n  width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) / 2);\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  max-width: 100%;\n  position: relative;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image > a,\n.wp-block-gallery.has-nested-images figure.wp-block-image > div {\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image img {\n  display: block;\n  height: auto;\n  max-width: 100% !important;\n  width: auto;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image figcaption {\n  background: linear-gradient(0deg, #000000b3, #0000004d 70%, #0000);\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  font-size: 13px;\n  left: 0;\n  margin-bottom: 0;\n  max-height: 60%;\n  overflow: auto;\n  padding: 0 8px 8px;\n  position: absolute;\n  scrollbar-color: #0000 #0000;\n  scrollbar-gutter: stable both-edges;\n  scrollbar-width: thin;\n  text-align: center;\n  width: 100%;\n  will-change: transform;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption::-webkit-scrollbar {\n  height: 12px;\n  width: 12px;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption::-webkit-scrollbar-track {\n  background-color: initial;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption::-webkit-scrollbar-thumb {\n  background-clip: padding-box;\n  background-color: initial;\n  border: 3px solid #0000;\n  border-radius: 8px;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption:focus-within::-webkit-scrollbar-thumb,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption:focus::-webkit-scrollbar-thumb,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption:hover::-webkit-scrollbar-thumb {\n  background-color: #fffc;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image figcaption:focus,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image\n  figcaption:focus-within,\n.wp-block-gallery.has-nested-images figure.wp-block-image figcaption:hover {\n  scrollbar-color: #fffc #0000;\n}\n\n@media (hover: none) {\n  .wp-block-gallery.has-nested-images figure.wp-block-image figcaption {\n    scrollbar-color: #fffc #0000;\n  }\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image figcaption img {\n  display: inline;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image figcaption a {\n  color: inherit;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image.has-custom-border\n  img {\n  box-sizing: border-box;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image.has-custom-border > a,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image.has-custom-border\n  > div,\n.wp-block-gallery.has-nested-images figure.wp-block-image.is-style-rounded > a,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image.is-style-rounded\n  > div {\n  flex: 1 1 auto;\n}\n\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image.has-custom-border\n  figcaption,\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image.is-style-rounded\n  figcaption {\n  background: none;\n  color: inherit;\n  flex: initial;\n  margin: 0;\n  padding: 10px 10px 9px;\n  position: relative;\n}\n\n.wp-block-gallery.has-nested-images figcaption {\n  flex-basis: 100%;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.wp-block-gallery.has-nested-images:not(.is-cropped)\n  figure.wp-block-image:not(#individual-image) {\n  margin-bottom: auto;\n  margin-top: 0;\n}\n\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image) {\n  align-self: inherit;\n}\n\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  > a,\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  > div:not(.components-drop-zone) {\n  display: flex;\n}\n\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  a,\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  img {\n  flex: 1 0 0%;\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.wp-block-gallery.has-nested-images.columns-1\n  figure.wp-block-image:not(#individual-image) {\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .wp-block-gallery.has-nested-images.columns-3\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(\n      33.33333% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667\n    );\n  }\n\n  .wp-block-gallery.has-nested-images.columns-4\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(25% - var(--wp--style--unstable-gallery-gap, 16px) * 0.75);\n  }\n\n  .wp-block-gallery.has-nested-images.columns-5\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(20% - var(--wp--style--unstable-gallery-gap, 16px) * 0.8);\n  }\n\n  .wp-block-gallery.has-nested-images.columns-6\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(\n      16.66667% - var(--wp--style--unstable-gallery-gap, 16px) * 0.83333\n    );\n  }\n\n  .wp-block-gallery.has-nested-images.columns-7\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(\n      14.28571% - var(--wp--style--unstable-gallery-gap, 16px) * 0.85714\n    );\n  }\n\n  .wp-block-gallery.has-nested-images.columns-8\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(12.5% - var(--wp--style--unstable-gallery-gap, 16px) * 0.875);\n  }\n\n  .wp-block-gallery.has-nested-images.columns-default\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(\n      33.33% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667\n    );\n  }\n\n  .wp-block-gallery.has-nested-images.columns-default\n    figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2),\n  .wp-block-gallery.has-nested-images.columns-default\n    figure.wp-block-image:not(#individual-image):first-child:nth-last-child(2)\n    ~ figure.wp-block-image:not(#individual-image) {\n    width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) * 0.5);\n  }\n\n  .wp-block-gallery.has-nested-images.columns-default\n    figure.wp-block-image:not(#individual-image):first-child:last-child {\n    width: 100%;\n  }\n}\n\n.wp-block-gallery.has-nested-images.alignleft,\n.wp-block-gallery.has-nested-images.alignright {\n  max-width: 420px;\n  width: 100%;\n}\n\n.wp-block-gallery.has-nested-images.aligncenter {\n  justify-content: center;\n}\n\n.wp-block-group {\n  box-sizing: border-box;\n}\n\nh1.has-background,\nh2.has-background,\nh3.has-background,\nh4.has-background,\nh5.has-background,\nh6.has-background {\n  padding: 1.25em 2.375em;\n}\n\nh1.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh1.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]),\nh2.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh2.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]),\nh3.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh3.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]),\nh4.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh4.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]),\nh5.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh5.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]),\nh6.has-text-align-left[style*=\"writing-mode\"]:where([style*=\"vertical-lr\"]),\nh6.has-text-align-right[style*=\"writing-mode\"]:where([style*=\"vertical-rl\"]) {\n  rotate: 180deg;\n}\n\n.wp-block-image img {\n  box-sizing: border-box;\n  height: auto;\n  max-width: 100%;\n  vertical-align: bottom;\n}\n\n.wp-block-image[style*=\"border-radius\"] img,\n.wp-block-image[style*=\"border-radius\"] > a {\n  border-radius: inherit;\n}\n\n.wp-block-image.has-custom-border img {\n  box-sizing: border-box;\n}\n\n.wp-block-image.aligncenter {\n  text-align: center;\n}\n\n.wp-block-image.alignfull img,\n.wp-block-image.alignwide img {\n  height: auto;\n  width: 100%;\n}\n\n.wp-block-image .aligncenter,\n.wp-block-image .alignleft,\n.wp-block-image .alignright,\n.wp-block-image.aligncenter,\n.wp-block-image.alignleft,\n.wp-block-image.alignright {\n  display: table;\n}\n\n.wp-block-image .aligncenter > figcaption,\n.wp-block-image .alignleft > figcaption,\n.wp-block-image .alignright > figcaption,\n.wp-block-image.aligncenter > figcaption,\n.wp-block-image.alignleft > figcaption,\n.wp-block-image.alignright > figcaption {\n  caption-side: bottom;\n  display: table-caption;\n}\n\n.wp-block-image .alignleft {\n  float: left;\n  margin: 0.5em 1em 0.5em 0;\n}\n\n.wp-block-image .alignright {\n  float: right;\n  margin: 0.5em 0 0.5em 1em;\n}\n\n.wp-block-image .aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.wp-block-image figcaption {\n  margin-bottom: 1em;\n  margin-top: 0.5em;\n}\n\n.wp-block-image .is-style-rounded img,\n.wp-block-image.is-style-circle-mask img,\n.wp-block-image.is-style-rounded img {\n  border-radius: 9999px;\n}\n\n@supports ((-webkit-mask-image: none) or (mask-image: none)) or\n  (-webkit-mask-image: none) {\n  .wp-block-image.is-style-circle-mask img {\n    border-radius: 0;\n    -webkit-mask-image: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"50\"/></svg>');\n    mask-image: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"50\"/></svg>');\n    mask-mode: alpha;\n    -webkit-mask-position: center;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: contain;\n    mask-size: contain;\n  }\n}\n\n.wp-block-image :where(.has-border-color) {\n  border-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-top-color\"]) {\n  border-top-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-right-color\"]) {\n  border-right-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-bottom-color\"]) {\n  border-bottom-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-left-color\"]) {\n  border-left-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-width\"]) {\n  border-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-top-width\"]) {\n  border-top-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-right-width\"]) {\n  border-right-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-bottom-width\"]) {\n  border-bottom-style: solid;\n}\n\n.wp-block-image :where([style*=\"border-left-width\"]) {\n  border-left-style: solid;\n}\n\n.wp-block-image figure {\n  margin: 0;\n}\n\n.wp-lightbox-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.wp-lightbox-container img {\n  cursor: zoom-in;\n}\n\n.wp-lightbox-container img:hover + button {\n  opacity: 1;\n}\n\n.wp-lightbox-container button {\n  align-items: center;\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n  backdrop-filter: blur(16px) saturate(180%);\n  background-color: #5a5a5a40;\n  border: none;\n  border-radius: 4px;\n  cursor: zoom-in;\n  display: flex;\n  height: 20px;\n  justify-content: center;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  right: 16px;\n  text-align: center;\n  top: 16px;\n  transition: opacity 0.2s ease;\n  width: 20px;\n  z-index: 100;\n}\n\n.wp-lightbox-container button:focus-visible {\n  outline: 3px auto #5a5a5a40;\n  outline: 3px auto -webkit-focus-ring-color;\n  outline-offset: 3px;\n}\n\n.wp-lightbox-container button:hover {\n  cursor: pointer;\n  opacity: 1;\n}\n\n.wp-lightbox-container button:focus {\n  opacity: 1;\n}\n\n.wp-lightbox-container button:focus,\n.wp-lightbox-container button:hover,\n.wp-lightbox-container button:not(:hover):not(:active):not(.has-background) {\n  background-color: #5a5a5a40;\n  border: none;\n}\n\n.wp-lightbox-overlay {\n  box-sizing: border-box;\n  cursor: zoom-out;\n  height: 100vh;\n  left: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  visibility: hidden;\n  width: 100%;\n  z-index: 100000;\n}\n\n.wp-lightbox-overlay .close-button {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  min-height: 40px;\n  min-width: 40px;\n  padding: 0;\n  position: absolute;\n  right: calc(env(safe-area-inset-right) + 16px);\n  top: calc(env(safe-area-inset-top) + 16px);\n  z-index: 5000000;\n}\n\n.wp-lightbox-overlay .close-button:focus,\n.wp-lightbox-overlay .close-button:hover,\n.wp-lightbox-overlay\n  .close-button:not(:hover):not(:active):not(.has-background) {\n  background: none;\n  border: none;\n}\n\n.wp-lightbox-overlay .lightbox-image-container {\n  height: var(--wp--lightbox-container-height);\n  left: 50%;\n  overflow: hidden;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: top left;\n  width: var(--wp--lightbox-container-width);\n  z-index: 9999999999;\n}\n\n.wp-lightbox-overlay .wp-block-image {\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  margin: 0;\n  position: relative;\n  transform-origin: 0 0;\n  width: 100%;\n  z-index: 3000000;\n}\n\n.wp-lightbox-overlay .wp-block-image img {\n  height: var(--wp--lightbox-image-height);\n  min-height: var(--wp--lightbox-image-height);\n  min-width: var(--wp--lightbox-image-width);\n  width: var(--wp--lightbox-image-width);\n}\n\n.wp-lightbox-overlay .wp-block-image figcaption {\n  display: none;\n}\n\n.wp-lightbox-overlay button {\n  background: none;\n  border: none;\n}\n\n.wp-lightbox-overlay .scrim {\n  background-color: #fff;\n  height: 100%;\n  opacity: 0.9;\n  position: absolute;\n  width: 100%;\n  z-index: 2000000;\n}\n\n.wp-lightbox-overlay.active {\n  animation: turn-on-visibility 0.25s both;\n  visibility: visible;\n}\n\n.wp-lightbox-overlay.active img {\n  animation: turn-on-visibility 0.35s both;\n}\n\n.wp-lightbox-overlay.show-closing-animation:not(.active) {\n  animation: turn-off-visibility 0.35s both;\n}\n\n.wp-lightbox-overlay.show-closing-animation:not(.active) img {\n  animation: turn-off-visibility 0.25s both;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .wp-lightbox-overlay.zoom.active {\n    animation: none;\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .wp-lightbox-overlay.zoom.active .lightbox-image-container {\n    animation: lightbox-zoom-in 0.4s;\n  }\n\n  .wp-lightbox-overlay.zoom.active .lightbox-image-container img {\n    animation: none;\n  }\n\n  .wp-lightbox-overlay.zoom.active .scrim {\n    animation: turn-on-visibility 0.4s forwards;\n  }\n\n  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active) {\n    animation: none;\n  }\n\n  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active)\n    .lightbox-image-container {\n    animation: lightbox-zoom-out 0.4s;\n  }\n\n  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active)\n    .lightbox-image-container\n    img {\n    animation: none;\n  }\n\n  .wp-lightbox-overlay.zoom.show-closing-animation:not(.active) .scrim {\n    animation: turn-off-visibility 0.4s forwards;\n  }\n}\n\n@keyframes turn-on-visibility {\n  0% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes turn-off-visibility {\n  0% {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  99% {\n    opacity: 0;\n    visibility: visible;\n  }\n\n  to {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n@keyframes lightbox-zoom-in {\n  0% {\n    transform: translate(\n        calc(\n          (-100vw + var(--wp--lightbox-scrollbar-width)) / 2 +\n            var(--wp--lightbox-initial-left-position)\n        ),\n        calc(-50vh + var(--wp--lightbox-initial-top-position))\n      )\n      scale(var(--wp--lightbox-scale));\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes lightbox-zoom-out {\n  0% {\n    transform: translate(-50%, -50%) scale(1);\n    visibility: visible;\n  }\n\n  99% {\n    visibility: visible;\n  }\n\n  to {\n    transform: translate(\n        calc(\n          (-100vw + var(--wp--lightbox-scrollbar-width)) / 2 +\n            var(--wp--lightbox-initial-left-position)\n        ),\n        calc(-50vh + var(--wp--lightbox-initial-top-position))\n      )\n      scale(var(--wp--lightbox-scale));\n    visibility: hidden;\n  }\n}\n\nol.wp-block-latest-comments {\n  box-sizing: border-box;\n  margin-left: 0;\n}\n\n:where(\n    .wp-block-latest-comments:not(\n        [style*=\"line-height\"] .wp-block-latest-comments__comment\n      )\n  ) {\n  line-height: 1.1;\n}\n\n:where(\n    .wp-block-latest-comments:not(\n        [style*=\"line-height\"] .wp-block-latest-comments__comment-excerpt p\n      )\n  ) {\n  line-height: 1.8;\n}\n\n.has-dates :where(.wp-block-latest-comments:not([style*=\"line-height\"])),\n.has-excerpts :where(.wp-block-latest-comments:not([style*=\"line-height\"])) {\n  line-height: 1.5;\n}\n\n.wp-block-latest-comments .wp-block-latest-comments {\n  padding-left: 0;\n}\n\n.wp-block-latest-comments__comment {\n  list-style: none;\n  margin-bottom: 1em;\n}\n\n.has-avatars .wp-block-latest-comments__comment {\n  list-style: none;\n  min-height: 2.25em;\n}\n\n.has-avatars\n  .wp-block-latest-comments__comment\n  .wp-block-latest-comments__comment-excerpt,\n.has-avatars\n  .wp-block-latest-comments__comment\n  .wp-block-latest-comments__comment-meta {\n  margin-left: 3.25em;\n}\n\n.wp-block-latest-comments__comment-excerpt p {\n  font-size: 0.875em;\n  margin: 0.36em 0 1.4em;\n}\n\n.wp-block-latest-comments__comment-date {\n  display: block;\n  font-size: 0.75em;\n}\n\n.wp-block-latest-comments .avatar,\n.wp-block-latest-comments__comment-avatar {\n  border-radius: 1.5em;\n  display: block;\n  float: left;\n  height: 2.5em;\n  margin-right: 0.75em;\n  width: 2.5em;\n}\n\n.wp-block-latest-comments[class*=\"-font-size\"] a,\n.wp-block-latest-comments[style*=\"font-size\"] a {\n  font-size: inherit;\n}\n\n.wp-block-latest-posts {\n  box-sizing: border-box;\n}\n\n.wp-block-latest-posts.alignleft {\n  margin-right: 2em;\n}\n\n.wp-block-latest-posts.alignright {\n  margin-left: 2em;\n}\n\n.wp-block-latest-posts.wp-block-latest-posts__list {\n  list-style: none;\n  padding-left: 0;\n}\n\n.wp-block-latest-posts.wp-block-latest-posts__list li {\n  clear: both;\n}\n\n.wp-block-latest-posts.is-grid {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n}\n\n.wp-block-latest-posts.is-grid li {\n  margin: 0 1.25em 1.25em 0;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .wp-block-latest-posts.columns-2 li {\n    width: calc(50% - 0.625em);\n  }\n\n  .wp-block-latest-posts.columns-2 li:nth-child(2n) {\n    margin-right: 0;\n  }\n\n  .wp-block-latest-posts.columns-3 li {\n    width: calc(33.33333% - 0.83333em);\n  }\n\n  .wp-block-latest-posts.columns-3 li:nth-child(3n) {\n    margin-right: 0;\n  }\n\n  .wp-block-latest-posts.columns-4 li {\n    width: calc(25% - 0.9375em);\n  }\n\n  .wp-block-latest-posts.columns-4 li:nth-child(4n) {\n    margin-right: 0;\n  }\n\n  .wp-block-latest-posts.columns-5 li {\n    width: calc(20% - 1em);\n  }\n\n  .wp-block-latest-posts.columns-5 li:nth-child(5n) {\n    margin-right: 0;\n  }\n\n  .wp-block-latest-posts.columns-6 li {\n    width: calc(16.66667% - 1.04167em);\n  }\n\n  .wp-block-latest-posts.columns-6 li:nth-child(6n) {\n    margin-right: 0;\n  }\n}\n\n.wp-block-latest-posts__post-author,\n.wp-block-latest-posts__post-date {\n  display: block;\n  font-size: 0.8125em;\n}\n\n.wp-block-latest-posts__post-excerpt {\n  margin-bottom: 1em;\n  margin-top: 0.5em;\n}\n\n.wp-block-latest-posts__featured-image a {\n  display: inline-block;\n}\n\n.wp-block-latest-posts__featured-image img {\n  height: auto;\n  max-width: 100%;\n  width: auto;\n}\n\n.wp-block-latest-posts__featured-image.alignleft {\n  float: left;\n  margin-right: 1em;\n}\n\n.wp-block-latest-posts__featured-image.alignright {\n  float: right;\n  margin-left: 1em;\n}\n\n.wp-block-latest-posts__featured-image.aligncenter {\n  margin-bottom: 1em;\n  text-align: center;\n}\n\nol,\nul {\n  box-sizing: border-box;\n}\n\nol.has-background,\nul.has-background {\n  padding: 1.25em 2.375em;\n}\n\n.wp-block-media-text {\n  box-sizing: border-box;\n  /*!rtl:begin:ignore*/\n  direction: ltr;\n  /*!rtl:end:ignore*/\n  display: grid;\n  grid-template-columns: 50% 1fr;\n  grid-template-rows: auto;\n}\n\n.wp-block-media-text.has-media-on-the-right {\n  grid-template-columns: 1fr 50%;\n}\n\n.wp-block-media-text.is-vertically-aligned-top .wp-block-media-text__content,\n.wp-block-media-text.is-vertically-aligned-top .wp-block-media-text__media {\n  align-self: start;\n}\n\n.wp-block-media-text .wp-block-media-text__content,\n.wp-block-media-text .wp-block-media-text__media,\n.wp-block-media-text.is-vertically-aligned-center .wp-block-media-text__content,\n.wp-block-media-text.is-vertically-aligned-center .wp-block-media-text__media {\n  align-self: center;\n}\n\n.wp-block-media-text.is-vertically-aligned-bottom .wp-block-media-text__content,\n.wp-block-media-text.is-vertically-aligned-bottom .wp-block-media-text__media {\n  align-self: end;\n}\n\n.wp-block-media-text .wp-block-media-text__media {\n  /*!rtl:begin:ignore*/\n  grid-column: 1;\n  grid-row: 1;\n  /*!rtl:end:ignore*/\n  margin: 0;\n}\n\n.wp-block-media-text .wp-block-media-text__content {\n  direction: ltr;\n  /*!rtl:begin:ignore*/\n  grid-column: 2;\n  grid-row: 1;\n  /*!rtl:end:ignore*/\n  padding: 0 8%;\n  word-break: break-word;\n}\n\n.wp-block-media-text.has-media-on-the-right .wp-block-media-text__media {\n  /*!rtl:begin:ignore*/\n  grid-column: 2;\n  grid-row: 1; /*!rtl:end:ignore*/\n}\n\n.wp-block-media-text.has-media-on-the-right .wp-block-media-text__content {\n  /*!rtl:begin:ignore*/\n  grid-column: 1;\n  grid-row: 1; /*!rtl:end:ignore*/\n}\n\n.wp-block-media-text__media img,\n.wp-block-media-text__media video {\n  height: auto;\n  max-width: unset;\n  vertical-align: middle;\n  width: 100%;\n}\n\n.wp-block-media-text.is-image-fill .wp-block-media-text__media {\n  background-size: cover;\n  height: 100%;\n  min-height: 250px;\n}\n\n.wp-block-media-text.is-image-fill .wp-block-media-text__media > a {\n  display: block;\n  height: 100%;\n}\n\n.wp-block-media-text.is-image-fill .wp-block-media-text__media img {\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n@media (max-width: 600px) {\n  .wp-block-media-text.is-stacked-on-mobile {\n    grid-template-columns: 100% !important;\n  }\n\n  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__media {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  .wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content {\n    grid-column: 1;\n    grid-row: 2;\n  }\n}\n\n.wp-block-navigation {\n  position: relative;\n  --navigation-layout-justification-setting: flex-start;\n  --navigation-layout-direction: row;\n  --navigation-layout-wrap: wrap;\n  --navigation-layout-justify: flex-start;\n  --navigation-layout-align: center;\n}\n\n.wp-block-navigation ul {\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-top: 0;\n  padding-left: 0;\n}\n\n.wp-block-navigation ul,\n.wp-block-navigation ul li {\n  list-style: none;\n  padding: 0;\n}\n\n.wp-block-navigation .wp-block-navigation-item {\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n\n.wp-block-navigation\n  .wp-block-navigation-item\n  .wp-block-navigation__submenu-container:empty {\n  display: none;\n}\n\n.wp-block-navigation .wp-block-navigation-item__content {\n  display: block;\n}\n\n.wp-block-navigation\n  .wp-block-navigation-item__content.wp-block-navigation-item__content {\n  color: inherit;\n}\n\n.wp-block-navigation.has-text-decoration-underline\n  .wp-block-navigation-item__content,\n.wp-block-navigation.has-text-decoration-underline\n  .wp-block-navigation-item__content:active,\n.wp-block-navigation.has-text-decoration-underline\n  .wp-block-navigation-item__content:focus {\n  text-decoration: underline;\n}\n\n.wp-block-navigation.has-text-decoration-line-through\n  .wp-block-navigation-item__content,\n.wp-block-navigation.has-text-decoration-line-through\n  .wp-block-navigation-item__content:active,\n.wp-block-navigation.has-text-decoration-line-through\n  .wp-block-navigation-item__content:focus {\n  text-decoration: line-through;\n}\n\n.wp-block-navigation:where(:not([class*=\"has-text-decoration\"])) a {\n  text-decoration: none;\n}\n\n.wp-block-navigation:where(:not([class*=\"has-text-decoration\"])) a:active,\n.wp-block-navigation:where(:not([class*=\"has-text-decoration\"])) a:focus {\n  text-decoration: none;\n}\n\n.wp-block-navigation .wp-block-navigation__submenu-icon {\n  align-self: center;\n  background-color: inherit;\n  border: none;\n  color: currentColor;\n  display: inline-block;\n  font-size: inherit;\n  height: 0.6em;\n  line-height: 0;\n  margin-left: 0.25em;\n  padding: 0;\n  width: 0.6em;\n}\n\n.wp-block-navigation .wp-block-navigation__submenu-icon svg {\n  display: inline-block;\n  stroke: currentColor;\n  height: inherit;\n  margin-top: 0.075em;\n  width: inherit;\n}\n\n.wp-block-navigation.is-vertical {\n  --navigation-layout-direction: column;\n  --navigation-layout-justify: initial;\n  --navigation-layout-align: flex-start;\n}\n\n.wp-block-navigation.no-wrap {\n  --navigation-layout-wrap: nowrap;\n}\n\n.wp-block-navigation.items-justified-center {\n  --navigation-layout-justification-setting: center;\n  --navigation-layout-justify: center;\n}\n\n.wp-block-navigation.items-justified-center.is-vertical {\n  --navigation-layout-align: center;\n}\n\n.wp-block-navigation.items-justified-right {\n  --navigation-layout-justification-setting: flex-end;\n  --navigation-layout-justify: flex-end;\n}\n\n.wp-block-navigation.items-justified-right.is-vertical {\n  --navigation-layout-align: flex-end;\n}\n\n.wp-block-navigation.items-justified-space-between {\n  --navigation-layout-justification-setting: space-between;\n  --navigation-layout-justify: space-between;\n}\n\n.wp-block-navigation .has-child .wp-block-navigation__submenu-container {\n  align-items: normal;\n  background-color: inherit;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  height: 0;\n  left: -1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 100%;\n  transition: opacity 0.1s linear;\n  visibility: hidden;\n  width: 0;\n  z-index: 2;\n}\n\n.wp-block-navigation\n  .has-child\n  .wp-block-navigation__submenu-container\n  > .wp-block-navigation-item\n  > .wp-block-navigation-item__content {\n  display: flex;\n  flex-grow: 1;\n}\n\n.wp-block-navigation\n  .has-child\n  .wp-block-navigation__submenu-container\n  > .wp-block-navigation-item\n  > .wp-block-navigation-item__content\n  .wp-block-navigation__submenu-icon {\n  margin-left: auto;\n  margin-right: 0;\n}\n\n.wp-block-navigation\n  .has-child\n  .wp-block-navigation__submenu-container\n  .wp-block-navigation-item__content {\n  margin: 0;\n}\n\n@media (min-width: 782px) {\n  .wp-block-navigation\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container {\n    left: 100%;\n    top: -1px;\n  }\n\n  .wp-block-navigation\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container:before {\n    background: #0000;\n    content: \"\";\n    display: block;\n    height: 100%;\n    position: absolute;\n    right: 100%;\n    width: 0.5em;\n  }\n\n  .wp-block-navigation\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-icon {\n    margin-right: 0.25em;\n  }\n\n  .wp-block-navigation\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-icon\n    svg {\n    transform: rotate(-90deg);\n  }\n}\n\n.wp-block-navigation\n  .has-child\n  .wp-block-navigation-submenu__toggle[aria-expanded=\"true\"]\n  ~ .wp-block-navigation__submenu-container,\n.wp-block-navigation\n  .has-child:not(.open-on-click):hover\n  > .wp-block-navigation__submenu-container,\n.wp-block-navigation\n  .has-child:not(.open-on-click):not(.open-on-hover-click):focus-within\n  > .wp-block-navigation__submenu-container {\n  height: auto;\n  min-width: 200px;\n  opacity: 1;\n  overflow: visible;\n  visibility: visible;\n  width: auto;\n}\n\n.wp-block-navigation.has-background\n  .has-child\n  .wp-block-navigation__submenu-container {\n  left: 0;\n  top: 100%;\n}\n\n@media (min-width: 782px) {\n  .wp-block-navigation.has-background\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container {\n    left: 100%;\n    top: 0;\n  }\n}\n\n.wp-block-navigation-submenu {\n  display: flex;\n  position: relative;\n}\n\n.wp-block-navigation-submenu .wp-block-navigation__submenu-icon svg {\n  stroke: currentColor;\n}\n\nbutton.wp-block-navigation-item__content {\n  background-color: initial;\n  border: none;\n  color: currentColor;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  text-align: left;\n  text-transform: inherit;\n}\n\n.wp-block-navigation-submenu__toggle {\n  cursor: pointer;\n}\n\n.wp-block-navigation-item.open-on-click .wp-block-navigation-submenu__toggle {\n  padding-left: 0;\n  padding-right: 0.85em;\n}\n\n.wp-block-navigation-item.open-on-click\n  .wp-block-navigation-submenu__toggle\n  + .wp-block-navigation__submenu-icon {\n  margin-left: -0.6em;\n  pointer-events: none;\n}\n\n.wp-block-navigation-item.open-on-click\n  button.wp-block-navigation-item__content:not(\n    .wp-block-navigation-submenu__toggle\n  ) {\n  padding: 0;\n}\n\n.wp-block-navigation .wp-block-page-list,\n.wp-block-navigation__container,\n.wp-block-navigation__responsive-close,\n.wp-block-navigation__responsive-container,\n.wp-block-navigation__responsive-container-content,\n.wp-block-navigation__responsive-dialog {\n  gap: inherit;\n}\n\n:where(\n    .wp-block-navigation.has-background\n      .wp-block-navigation-item\n      a:not(.wp-element-button)\n  ),\n:where(\n    .wp-block-navigation.has-background\n      .wp-block-navigation-submenu\n      a:not(.wp-element-button)\n  ) {\n  padding: 0.5em 1em;\n}\n\n:where(\n    .wp-block-navigation\n      .wp-block-navigation__submenu-container\n      .wp-block-navigation-item\n      a:not(.wp-element-button)\n  ),\n:where(\n    .wp-block-navigation\n      .wp-block-navigation__submenu-container\n      .wp-block-navigation-submenu\n      a:not(.wp-element-button)\n  ),\n:where(\n    .wp-block-navigation\n      .wp-block-navigation__submenu-container\n      .wp-block-navigation-submenu\n      button.wp-block-navigation-item__content\n  ),\n:where(\n    .wp-block-navigation\n      .wp-block-navigation__submenu-container\n      .wp-block-pages-list__item\n      button.wp-block-navigation-item__content\n  ) {\n  padding: 0.5em 1em;\n}\n\n.wp-block-navigation.items-justified-right\n  .wp-block-navigation__container\n  .has-child\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-right\n  .wp-block-page-list\n  > .has-child\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-space-between\n  .wp-block-page-list\n  > .has-child:last-child\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-space-between\n  > .wp-block-navigation__container\n  > .has-child:last-child\n  .wp-block-navigation__submenu-container {\n  left: auto;\n  right: 0;\n}\n\n.wp-block-navigation.items-justified-right\n  .wp-block-navigation__container\n  .has-child\n  .wp-block-navigation__submenu-container\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-right\n  .wp-block-page-list\n  > .has-child\n  .wp-block-navigation__submenu-container\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-space-between\n  .wp-block-page-list\n  > .has-child:last-child\n  .wp-block-navigation__submenu-container\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation.items-justified-space-between\n  > .wp-block-navigation__container\n  > .has-child:last-child\n  .wp-block-navigation__submenu-container\n  .wp-block-navigation__submenu-container {\n  left: -1px;\n  right: -1px;\n}\n\n@media (min-width: 782px) {\n  .wp-block-navigation.items-justified-right\n    .wp-block-navigation__container\n    .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container,\n  .wp-block-navigation.items-justified-right\n    .wp-block-page-list\n    > .has-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container,\n  .wp-block-navigation.items-justified-space-between\n    .wp-block-page-list\n    > .has-child:last-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container,\n  .wp-block-navigation.items-justified-space-between\n    > .wp-block-navigation__container\n    > .has-child:last-child\n    .wp-block-navigation__submenu-container\n    .wp-block-navigation__submenu-container {\n    left: auto;\n    right: 100%;\n  }\n}\n\n.wp-block-navigation:not(.has-background)\n  .wp-block-navigation__submenu-container {\n  background-color: #fff;\n  border: 1px solid #00000026;\n}\n\n.wp-block-navigation.has-background .wp-block-navigation__submenu-container {\n  background-color: inherit;\n}\n\n.wp-block-navigation:not(.has-text-color)\n  .wp-block-navigation__submenu-container {\n  color: #000;\n}\n\n.wp-block-navigation__container {\n  align-items: var(--navigation-layout-align, initial);\n  display: flex;\n  flex-direction: var(--navigation-layout-direction, initial);\n  flex-wrap: var(--navigation-layout-wrap, wrap);\n  justify-content: var(--navigation-layout-justify, initial);\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n}\n\n.wp-block-navigation__container .is-responsive {\n  display: none;\n}\n\n.wp-block-navigation__container:only-child,\n.wp-block-page-list:only-child {\n  flex-grow: 1;\n}\n\n@keyframes overlay-menu__fade-in-animation {\n  0% {\n    opacity: 0;\n    transform: translateY(0.5em);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.wp-block-navigation__responsive-container {\n  bottom: 0;\n  display: none;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n\n.wp-block-navigation__responsive-container :where(.wp-block-navigation-item a) {\n  color: inherit;\n}\n\n.wp-block-navigation__responsive-container\n  .wp-block-navigation__responsive-container-content {\n  align-items: var(--navigation-layout-align, initial);\n  display: flex;\n  flex-direction: var(--navigation-layout-direction, initial);\n  flex-wrap: var(--navigation-layout-wrap, wrap);\n  justify-content: var(--navigation-layout-justify, initial);\n}\n\n.wp-block-navigation__responsive-container:not(.is-menu-open.is-menu-open) {\n  background-color: inherit !important;\n  color: inherit !important;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open {\n  animation: overlay-menu__fade-in-animation 0.1s ease-out;\n  animation-fill-mode: forwards;\n  background-color: inherit;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  padding: clamp(1rem, var(--wp--style--root--padding-top), 20rem)\n    clamp(1rem, var(--wp--style--root--padding-right), 20rem)\n    clamp(1rem, var(--wp--style--root--padding-bottom), 20rem)\n    clamp(1rem, var(--wp--style--root--padding-left), 20em);\n  z-index: 100000;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wp-block-navigation__responsive-container.is-menu-open {\n    animation-delay: 0s;\n    animation-duration: 1ms;\n  }\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content {\n  align-items: var(--navigation-layout-justification-setting, inherit);\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  overflow: visible;\n  padding-top: calc(2rem + 24px);\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__container,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-page-list {\n  justify-content: flex-start;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__submenu-icon {\n  display: none;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .has-child\n  .wp-block-navigation__submenu-container {\n  border: none;\n  height: auto;\n  min-width: 200px;\n  opacity: 1;\n  overflow: initial;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  position: static;\n  visibility: visible;\n  width: auto;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__container,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__submenu-container {\n  gap: inherit;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__submenu-container {\n  padding-top: var(--wp--style--block-gap, 2em);\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation-item__content {\n  padding: 0;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation-item,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-navigation__container,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__responsive-container-content\n  .wp-block-page-list {\n  align-items: var(--navigation-layout-justification-setting, initial);\n  display: flex;\n  flex-direction: column;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation-item,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation-item\n  .wp-block-navigation__submenu-container,\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__container,\n.wp-block-navigation__responsive-container.is-menu-open .wp-block-page-list {\n  background: #0000 !important;\n  color: inherit !important;\n}\n\n.wp-block-navigation__responsive-container.is-menu-open\n  .wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container {\n  left: auto;\n  right: auto;\n}\n\n@media (min-width: 600px) {\n  .wp-block-navigation__responsive-container:not(.hidden-by-default):not(\n      .is-menu-open\n    ) {\n    background-color: inherit;\n    display: block;\n    position: relative;\n    width: 100%;\n    z-index: auto;\n  }\n\n  .wp-block-navigation__responsive-container:not(.hidden-by-default):not(\n      .is-menu-open\n    )\n    .wp-block-navigation__responsive-container-close {\n    display: none;\n  }\n\n  .wp-block-navigation__responsive-container.is-menu-open\n    .wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container.wp-block-navigation__submenu-container {\n    left: 0;\n  }\n}\n\n.wp-block-navigation:not(.has-background)\n  .wp-block-navigation__responsive-container.is-menu-open {\n  background-color: #fff;\n}\n\n.wp-block-navigation:not(.has-text-color)\n  .wp-block-navigation__responsive-container.is-menu-open {\n  color: #000;\n}\n\n.wp-block-navigation__toggle_button_label {\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.wp-block-navigation__responsive-container-close,\n.wp-block-navigation__responsive-container-open {\n  background: #0000;\n  border: none;\n  color: currentColor;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  text-transform: inherit;\n  vertical-align: middle;\n}\n\n.wp-block-navigation__responsive-container-close svg,\n.wp-block-navigation__responsive-container-open svg {\n  fill: currentColor;\n  display: block;\n  height: 24px;\n  pointer-events: none;\n  width: 24px;\n}\n\n.wp-block-navigation__responsive-container-open {\n  display: flex;\n}\n\n.wp-block-navigation__responsive-container-open.wp-block-navigation__responsive-container-open.wp-block-navigation__responsive-container-open {\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n@media (min-width: 600px) {\n  .wp-block-navigation__responsive-container-open:not(.always-shown) {\n    display: none;\n  }\n}\n\n.wp-block-navigation__responsive-container-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n}\n\n.wp-block-navigation__responsive-container-close.wp-block-navigation__responsive-container-close.wp-block-navigation__responsive-container-close {\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n.wp-block-navigation__responsive-close {\n  width: 100%;\n}\n\n.has-modal-open .wp-block-navigation__responsive-close {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: var(--wp--style--global--wide-size, 100%);\n}\n\n.wp-block-navigation__responsive-close:focus {\n  outline: none;\n}\n\n.is-menu-open .wp-block-navigation__responsive-close,\n.is-menu-open .wp-block-navigation__responsive-container-content,\n.is-menu-open .wp-block-navigation__responsive-dialog {\n  box-sizing: border-box;\n}\n\n.wp-block-navigation__responsive-dialog {\n  position: relative;\n}\n\n.has-modal-open\n  .admin-bar\n  .is-menu-open\n  .wp-block-navigation__responsive-dialog {\n  margin-top: 46px;\n}\n\n@media (min-width: 782px) {\n  .has-modal-open\n    .admin-bar\n    .is-menu-open\n    .wp-block-navigation__responsive-dialog {\n    margin-top: 32px;\n  }\n}\n\nhtml.has-modal-open {\n  overflow: hidden;\n}\n\n.wp-block-navigation .wp-block-navigation-item__label {\n  overflow-wrap: break-word;\n}\n\n.wp-block-navigation .wp-block-navigation-item__description {\n  display: none;\n}\n\n.link-ui-tools {\n  border-top: 1px solid #f0f0f0;\n  padding: 8px;\n}\n\n.link-ui-block-inserter {\n  padding-top: 8px;\n}\n\n.link-ui-block-inserter__back {\n  margin-left: 8px;\n  text-transform: uppercase;\n}\n\n.components-popover-pointer-events-trap {\n  background-color: initial;\n  cursor: pointer;\n  inset: 0;\n  position: fixed;\n  z-index: 1000000;\n}\n\n.wp-block-navigation .wp-block-page-list {\n  align-items: var(--navigation-layout-align, initial);\n  background-color: inherit;\n  display: flex;\n  flex-direction: var(--navigation-layout-direction, initial);\n  flex-wrap: var(--navigation-layout-wrap, wrap);\n  justify-content: var(--navigation-layout-justify, initial);\n}\n\n.wp-block-navigation .wp-block-navigation-item {\n  background-color: inherit;\n}\n\n.is-small-text {\n  font-size: 0.875em;\n}\n\n.is-regular-text {\n  font-size: 1em;\n}\n\n.is-large-text {\n  font-size: 2.25em;\n}\n\n.is-larger-text {\n  font-size: 3em;\n}\n\n.has-drop-cap:not(:focus):first-letter {\n  float: left;\n  font-size: 8.4em;\n  font-style: normal;\n  font-weight: 100;\n  line-height: 0.68;\n  margin: 0.05em 0.1em 0 0;\n  text-transform: uppercase;\n}\n\nbody.rtl .has-drop-cap:not(:focus):first-letter {\n  float: none;\n  margin-left: 0.1em;\n}\n\np.has-drop-cap.has-background {\n  overflow: hidden;\n}\n\np.has-background {\n  padding: 1.25em 2.375em;\n}\n\n:where(p.has-text-color:not(.has-link-color)) a {\n  color: inherit;\n}\n\np.has-text-align-left[style*=\"writing-mode:vertical-lr\"],\np.has-text-align-right[style*=\"writing-mode:vertical-rl\"] {\n  rotate: 180deg;\n}\n\n.wp-block-post-author {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.wp-block-post-author__byline {\n  font-size: 0.5em;\n  margin-bottom: 0;\n  margin-top: 0;\n  width: 100%;\n}\n\n.wp-block-post-author__avatar {\n  margin-right: 1em;\n}\n\n.wp-block-post-author__bio {\n  font-size: 0.7em;\n  margin-bottom: 0.7em;\n}\n\n.wp-block-post-author__content {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n\n.wp-block-post-author__name {\n  margin: 0;\n}\n\n.wp-block-post-comments-form {\n  box-sizing: border-box;\n}\n\n.wp-block-post-comments-form[style*=\"font-weight\"]\n  :where(.comment-reply-title) {\n  font-weight: inherit;\n}\n\n.wp-block-post-comments-form[style*=\"font-family\"]\n  :where(.comment-reply-title) {\n  font-family: inherit;\n}\n\n.wp-block-post-comments-form[class*=\"-font-size\"] :where(.comment-reply-title),\n.wp-block-post-comments-form[style*=\"font-size\"] :where(.comment-reply-title) {\n  font-size: inherit;\n}\n\n.wp-block-post-comments-form[style*=\"line-height\"]\n  :where(.comment-reply-title) {\n  line-height: inherit;\n}\n\n.wp-block-post-comments-form[style*=\"font-style\"] :where(.comment-reply-title) {\n  font-style: inherit;\n}\n\n.wp-block-post-comments-form[style*=\"letter-spacing\"]\n  :where(.comment-reply-title) {\n  letter-spacing: inherit;\n}\n\n.wp-block-post-comments-form input[type=\"submit\"] {\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  overflow-wrap: break-word;\n  text-align: center;\n}\n\n.wp-block-post-comments-form input:not([type=\"submit\"]),\n.wp-block-post-comments-form textarea {\n  border: 1px solid #949494;\n  font-family: inherit;\n  font-size: 1em;\n}\n\n.wp-block-post-comments-form input:not([type=\"submit\"]):not([type=\"checkbox\"]),\n.wp-block-post-comments-form textarea {\n  padding: calc(0.667em + 2px);\n}\n\n.wp-block-post-comments-form\n  .comment-form\n  input:not([type=\"submit\"]):not([type=\"checkbox\"]):not([type=\"hidden\"]),\n.wp-block-post-comments-form .comment-form textarea {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n}\n\n.wp-block-post-comments-form .comment-form-author label,\n.wp-block-post-comments-form .comment-form-email label,\n.wp-block-post-comments-form .comment-form-url label {\n  display: block;\n  margin-bottom: 0.25em;\n}\n\n.wp-block-post-comments-form .comment-form-cookies-consent {\n  display: flex;\n  gap: 0.25em;\n}\n\n.wp-block-post-comments-form\n  .comment-form-cookies-consent\n  #wp-comment-cookies-consent {\n  margin-top: 0.35em;\n}\n\n.wp-block-post-comments-form .comment-reply-title {\n  margin-bottom: 0;\n}\n\n.wp-block-post-comments-form .comment-reply-title :where(small) {\n  font-size: var(--wp--preset--font-size--medium, smaller);\n  margin-left: 0.5em;\n}\n\n.wp-block-post-date {\n  box-sizing: border-box;\n}\n\n:where(.wp-block-post-excerpt) {\n  margin-bottom: var(--wp--style--block-gap);\n  margin-top: var(--wp--style--block-gap);\n}\n\n.wp-block-post-excerpt__excerpt {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.wp-block-post-excerpt__more-text {\n  margin-bottom: 0;\n  margin-top: var(--wp--style--block-gap);\n}\n\n.wp-block-post-excerpt__more-link {\n  display: inline-block;\n}\n\n.wp-block-post-featured-image {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.wp-block-post-featured-image a {\n  display: block;\n  height: 100%;\n}\n\n.wp-block-post-featured-image img {\n  box-sizing: border-box;\n  height: auto;\n  max-width: 100%;\n  vertical-align: bottom;\n  width: 100%;\n}\n\n.wp-block-post-featured-image.alignfull img,\n.wp-block-post-featured-image.alignwide img {\n  width: 100%;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim {\n  background-color: #000;\n  inset: 0;\n  position: absolute;\n}\n\n.wp-block-post-featured-image {\n  position: relative;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-gradient {\n  background-color: initial;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-0 {\n  opacity: 0;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-10 {\n  opacity: 0.1;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-20 {\n  opacity: 0.2;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-30 {\n  opacity: 0.3;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-40 {\n  opacity: 0.4;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-50 {\n  opacity: 0.5;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-60 {\n  opacity: 0.6;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-70 {\n  opacity: 0.7;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-80 {\n  opacity: 0.8;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-90 {\n  opacity: 0.9;\n}\n\n.wp-block-post-featured-image\n  .wp-block-post-featured-image__overlay.has-background-dim-100 {\n  opacity: 1;\n}\n\n.wp-block-post-featured-image:where(.alignleft, .alignright) {\n  width: 100%;\n}\n\n.wp-block-post-navigation-link .wp-block-post-navigation-link__arrow-previous {\n  display: inline-block;\n  margin-right: 1ch;\n}\n\n.wp-block-post-navigation-link\n  .wp-block-post-navigation-link__arrow-previous:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-post-navigation-link .wp-block-post-navigation-link__arrow-next {\n  display: inline-block;\n  margin-left: 1ch;\n}\n\n.wp-block-post-navigation-link\n  .wp-block-post-navigation-link__arrow-next:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-post-navigation-link.has-text-align-left[style*=\"writing-mode: vertical-lr\"],\n.wp-block-post-navigation-link.has-text-align-right[style*=\"writing-mode: vertical-rl\"] {\n  rotate: 180deg;\n}\n\n.wp-block-post-terms {\n  box-sizing: border-box;\n}\n\n.wp-block-post-terms .wp-block-post-terms__separator {\n  white-space: pre-wrap;\n}\n\n.wp-block-post-time-to-read,\n.wp-block-post-title {\n  box-sizing: border-box;\n}\n\n.wp-block-post-title {\n  word-break: break-word;\n}\n\n.wp-block-post-title a {\n  display: inline-block;\n}\n\n.wp-block-preformatted {\n  box-sizing: border-box;\n  white-space: pre-wrap;\n}\n\n:where(.wp-block-preformatted.has-background) {\n  padding: 1.25em 2.375em;\n}\n\n.wp-block-pullquote {\n  box-sizing: border-box;\n  overflow-wrap: break-word;\n  padding: 4em 0;\n  text-align: center;\n}\n\n.wp-block-pullquote blockquote,\n.wp-block-pullquote cite,\n.wp-block-pullquote p {\n  color: inherit;\n}\n\n.wp-block-pullquote blockquote {\n  margin: 0;\n}\n\n.wp-block-pullquote p {\n  margin-top: 0;\n}\n\n.wp-block-pullquote p:last-child {\n  margin-bottom: 0;\n}\n\n.wp-block-pullquote.alignleft,\n.wp-block-pullquote.alignright {\n  max-width: 420px;\n}\n\n.wp-block-pullquote cite,\n.wp-block-pullquote footer {\n  position: relative;\n}\n\n.wp-block-pullquote .has-text-color a {\n  color: inherit;\n}\n\n:where(.wp-block-pullquote) {\n  margin: 0 0 1em;\n}\n\n.wp-block-pullquote.has-text-align-left blockquote {\n  text-align: left;\n}\n\n.wp-block-pullquote.has-text-align-right blockquote {\n  text-align: right;\n}\n\n.wp-block-pullquote.is-style-solid-color {\n  border: none;\n}\n\n.wp-block-pullquote.is-style-solid-color blockquote {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 60%;\n}\n\n.wp-block-pullquote.is-style-solid-color blockquote p {\n  font-size: 2em;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.wp-block-pullquote.is-style-solid-color blockquote cite {\n  font-style: normal;\n  text-transform: none;\n}\n\n.wp-block-pullquote cite {\n  color: inherit;\n}\n\n.wp-block-post-template {\n  list-style: none;\n  margin-bottom: 0;\n  margin-top: 0;\n  max-width: 100%;\n  padding: 0;\n}\n\n.wp-block-post-template.wp-block-post-template {\n  background: none;\n}\n\n.wp-block-post-template.is-flex-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 1.25em;\n}\n\n.wp-block-post-template.is-flex-container > li {\n  margin: 0;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .wp-block-post-template.is-flex-container.is-flex-container.columns-2 > li {\n    width: calc(50% - 0.625em);\n  }\n\n  .wp-block-post-template.is-flex-container.is-flex-container.columns-3 > li {\n    width: calc(33.33333% - 0.83333em);\n  }\n\n  .wp-block-post-template.is-flex-container.is-flex-container.columns-4 > li {\n    width: calc(25% - 0.9375em);\n  }\n\n  .wp-block-post-template.is-flex-container.is-flex-container.columns-5 > li {\n    width: calc(20% - 1em);\n  }\n\n  .wp-block-post-template.is-flex-container.is-flex-container.columns-6 > li {\n    width: calc(16.66667% - 1.04167em);\n  }\n}\n\n@media (max-width: 600px) {\n  .wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid.wp-block-post-template-is-layout-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.wp-block-post-template-is-layout-constrained > li > .alignright,\n.wp-block-post-template-is-layout-flow > li > .alignright {\n  float: right;\n  margin-inline-end: 0;\n  margin-inline-start: 2em;\n}\n\n.wp-block-post-template-is-layout-constrained > li > .alignleft,\n.wp-block-post-template-is-layout-flow > li > .alignleft {\n  float: left;\n  margin-inline-end: 2em;\n  margin-inline-start: 0;\n}\n\n.wp-block-post-template-is-layout-constrained > li > .aligncenter,\n.wp-block-post-template-is-layout-flow > li > .aligncenter {\n  margin-inline-end: auto;\n  margin-inline-start: auto;\n}\n\n.wp-block-query-pagination > .wp-block-query-pagination-next,\n.wp-block-query-pagination > .wp-block-query-pagination-numbers,\n.wp-block-query-pagination > .wp-block-query-pagination-previous {\n  margin-bottom: 0.5em;\n  margin-right: 0.5em;\n}\n\n.wp-block-query-pagination > .wp-block-query-pagination-next:last-child,\n.wp-block-query-pagination > .wp-block-query-pagination-numbers:last-child,\n.wp-block-query-pagination > .wp-block-query-pagination-previous:last-child {\n  margin-right: 0;\n}\n\n.wp-block-query-pagination.is-content-justification-space-between\n  > .wp-block-query-pagination-next:last-of-type {\n  margin-inline-start: auto;\n}\n\n.wp-block-query-pagination.is-content-justification-space-between\n  > .wp-block-query-pagination-previous:first-child {\n  margin-inline-end: auto;\n}\n\n.wp-block-query-pagination .wp-block-query-pagination-previous-arrow {\n  display: inline-block;\n  margin-right: 1ch;\n}\n\n.wp-block-query-pagination\n  .wp-block-query-pagination-previous-arrow:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-query-pagination .wp-block-query-pagination-next-arrow {\n  display: inline-block;\n  margin-left: 1ch;\n}\n\n.wp-block-query-pagination\n  .wp-block-query-pagination-next-arrow:not(.is-arrow-chevron) {\n  transform: scaleX(1);\n}\n\n.wp-block-query-pagination.aligncenter {\n  justify-content: center;\n}\n\n.wp-block-query-title,\n.wp-block-quote {\n  box-sizing: border-box;\n}\n\n.wp-block-quote {\n  overflow-wrap: break-word;\n}\n\n.wp-block-quote.is-large:where(:not(.is-style-plain)),\n.wp-block-quote.is-style-large:where(:not(.is-style-plain)) {\n  margin-bottom: 1em;\n  padding: 0 1em;\n}\n\n.wp-block-quote.is-large:where(:not(.is-style-plain)) p,\n.wp-block-quote.is-style-large:where(:not(.is-style-plain)) p {\n  font-size: 1.5em;\n  font-style: italic;\n  line-height: 1.6;\n}\n\n.wp-block-quote.is-large:where(:not(.is-style-plain)) cite,\n.wp-block-quote.is-large:where(:not(.is-style-plain)) footer,\n.wp-block-quote.is-style-large:where(:not(.is-style-plain)) cite,\n.wp-block-quote.is-style-large:where(:not(.is-style-plain)) footer {\n  font-size: 1.125em;\n  text-align: right;\n}\n\n.wp-block-quote > cite {\n  display: block;\n}\n\n.wp-block-read-more {\n  display: block;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.wp-block-read-more:where(:not([style*=\"text-decoration\"])) {\n  text-decoration: none;\n}\n\n.wp-block-read-more:where(:not([style*=\"text-decoration\"])):active,\n.wp-block-read-more:where(:not([style*=\"text-decoration\"])):focus {\n  text-decoration: none;\n}\n\nul.wp-block-rss {\n  list-style: none;\n  padding: 0;\n}\n\nul.wp-block-rss.wp-block-rss {\n  box-sizing: border-box;\n}\n\nul.wp-block-rss.alignleft {\n  margin-right: 2em;\n}\n\nul.wp-block-rss.alignright {\n  margin-left: 2em;\n}\n\nul.wp-block-rss.is-grid {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n}\n\nul.wp-block-rss.is-grid li {\n  margin: 0 1em 1em 0;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  ul.wp-block-rss.columns-2 li {\n    width: calc(50% - 1em);\n  }\n\n  ul.wp-block-rss.columns-3 li {\n    width: calc(33.33333% - 1em);\n  }\n\n  ul.wp-block-rss.columns-4 li {\n    width: calc(25% - 1em);\n  }\n\n  ul.wp-block-rss.columns-5 li {\n    width: calc(20% - 1em);\n  }\n\n  ul.wp-block-rss.columns-6 li {\n    width: calc(16.66667% - 1em);\n  }\n}\n\n.wp-block-rss__item-author,\n.wp-block-rss__item-publish-date {\n  display: block;\n  font-size: 0.8125em;\n}\n\n.wp-block-search__button {\n  margin-left: 10px;\n  word-break: normal;\n}\n\n.wp-block-search__button.has-icon {\n  line-height: 0;\n}\n\n.wp-block-search__button svg {\n  height: 1.25em;\n  min-height: 24px;\n  min-width: 24px;\n  width: 1.25em;\n  fill: currentColor;\n  vertical-align: text-bottom;\n}\n\n:where(.wp-block-search__button) {\n  border: 1px solid #ccc;\n  padding: 6px 10px;\n}\n\n.wp-block-search__inside-wrapper {\n  display: flex;\n  flex: auto;\n  flex-wrap: nowrap;\n  max-width: 100%;\n}\n\n.wp-block-search__label {\n  width: 100%;\n}\n\n.wp-block-search__input {\n  -webkit-appearance: initial;\n  appearance: none;\n  border: 1px solid #949494;\n  flex-grow: 1;\n  margin-left: 0;\n  margin-right: 0;\n  min-width: 3rem;\n  padding: 8px;\n  text-decoration: unset !important;\n}\n\n.wp-block-search.wp-block-search__button-only .wp-block-search__button {\n  flex-shrink: 0;\n  margin-left: 0;\n  max-width: 100%;\n}\n\n.wp-block-search.wp-block-search__button-only\n  .wp-block-search__button[aria-expanded=\"true\"] {\n  max-width: calc(100% - 100px);\n}\n\n.wp-block-search.wp-block-search__button-only .wp-block-search__inside-wrapper {\n  min-width: 0 !important;\n  transition-property: width;\n}\n\n.wp-block-search.wp-block-search__button-only .wp-block-search__input {\n  flex-basis: 100%;\n  transition-duration: 0.3s;\n}\n\n.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden,\n.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden\n  .wp-block-search__inside-wrapper {\n  overflow: hidden;\n}\n\n.wp-block-search.wp-block-search__button-only.wp-block-search__searchfield-hidden\n  .wp-block-search__input {\n  border-left-width: 0 !important;\n  border-right-width: 0 !important;\n  flex-basis: 0;\n  flex-grow: 0;\n  margin: 0;\n  min-width: 0 !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  width: 0 !important;\n}\n\n:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper) {\n  border: 1px solid #949494;\n  box-sizing: border-box;\n  padding: 4px;\n}\n\n:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)\n  .wp-block-search__input {\n  border: none;\n  border-radius: 0;\n  padding: 0 4px;\n}\n\n:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)\n  .wp-block-search__input:focus {\n  outline: none;\n}\n\n:where(.wp-block-search__button-inside .wp-block-search__inside-wrapper)\n  :where(.wp-block-search__button) {\n  padding: 4px 8px;\n}\n\n.wp-block-search.aligncenter .wp-block-search__inside-wrapper {\n  margin: auto;\n}\n\n.wp-block[data-align=\"right\"]\n  .wp-block-search.wp-block-search__button-only\n  .wp-block-search__inside-wrapper {\n  float: right;\n}\n\n.wp-block-separator {\n  border: none;\n  border-top: 2px solid;\n}\n\n.wp-block-separator.is-style-dots {\n  background: none !important;\n  border: none;\n  height: auto;\n  line-height: 1;\n  text-align: center;\n}\n\n.wp-block-separator.is-style-dots:before {\n  color: currentColor;\n  content: \"···\";\n  font-family: serif;\n  font-size: 1.5em;\n  letter-spacing: 2em;\n  padding-left: 2em;\n}\n\n.wp-block-site-logo {\n  box-sizing: border-box;\n  line-height: 0;\n}\n\n.wp-block-site-logo a {\n  display: inline-block;\n  line-height: 0;\n}\n\n.wp-block-site-logo.is-default-size img {\n  height: auto;\n  width: 120px;\n}\n\n.wp-block-site-logo img {\n  height: auto;\n  max-width: 100%;\n}\n\n.wp-block-site-logo a,\n.wp-block-site-logo img {\n  border-radius: inherit;\n}\n\n.wp-block-site-logo.aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.wp-block-site-logo.is-style-rounded {\n  border-radius: 9999px;\n}\n\n.wp-block-site-title a {\n  color: inherit;\n}\n\n.wp-block-social-links {\n  background: none;\n  box-sizing: border-box;\n  margin-left: 0;\n  padding-left: 0;\n  padding-right: 0;\n  text-indent: 0;\n}\n\n.wp-block-social-links .wp-social-link a,\n.wp-block-social-links .wp-social-link a:hover {\n  border-bottom: 0;\n  box-shadow: none;\n  text-decoration: none;\n}\n\n.wp-block-social-links .wp-social-link a {\n  padding: 0.25em;\n}\n\n.wp-block-social-links .wp-social-link svg {\n  height: 1em;\n  width: 1em;\n}\n\n.wp-block-social-links .wp-social-link span:not(.screen-reader-text) {\n  font-size: 0.65em;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n.wp-block-social-links.has-small-icon-size {\n  font-size: 16px;\n}\n\n.wp-block-social-links,\n.wp-block-social-links.has-normal-icon-size {\n  font-size: 24px;\n}\n\n.wp-block-social-links.has-large-icon-size {\n  font-size: 36px;\n}\n\n.wp-block-social-links.has-huge-icon-size {\n  font-size: 48px;\n}\n\n.wp-block-social-links.aligncenter {\n  display: flex;\n  justify-content: center;\n}\n\n.wp-block-social-links.alignright {\n  justify-content: flex-end;\n}\n\n.wp-block-social-link {\n  border-radius: 9999px;\n  display: block;\n  height: auto;\n  transition: transform 0.1s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wp-block-social-link {\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n.wp-block-social-link a {\n  align-items: center;\n  display: flex;\n  line-height: 0;\n  transition: transform 0.1s ease;\n}\n\n.wp-block-social-link:hover {\n  transform: scale(1.1);\n}\n\n.wp-block-social-links .wp-block-social-link.wp-social-link {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n}\n\n.wp-block-social-links\n  .wp-block-social-link.wp-social-link\n  .wp-block-social-link-anchor,\n.wp-block-social-links\n  .wp-block-social-link.wp-social-link\n  .wp-block-social-link-anchor\n  svg,\n.wp-block-social-links\n  .wp-block-social-link.wp-social-link\n  .wp-block-social-link-anchor:active,\n.wp-block-social-links\n  .wp-block-social-link.wp-social-link\n  .wp-block-social-link-anchor:hover,\n.wp-block-social-links\n  .wp-block-social-link.wp-social-link\n  .wp-block-social-link-anchor:visited {\n  color: currentColor;\n  fill: currentColor;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link {\n  background-color: #f0f0f0;\n  color: #444;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-amazon {\n  background-color: #f90;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-bandcamp {\n  background-color: #1ea0c3;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-behance {\n  background-color: #0757fe;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-codepen {\n  background-color: #1e1f26;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-deviantart {\n  background-color: #02e49b;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-dribbble {\n  background-color: #e94c89;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-dropbox {\n  background-color: #4280ff;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-etsy {\n  background-color: #f45800;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-facebook {\n  background-color: #1778f2;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-fivehundredpx {\n  background-color: #000;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-flickr {\n  background-color: #0461dd;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-foursquare {\n  background-color: #e65678;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-github {\n  background-color: #24292d;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-goodreads {\n  background-color: #eceadd;\n  color: #382110;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-google {\n  background-color: #ea4434;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-gravatar {\n  background-color: #1d4fc4;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-instagram {\n  background-color: #f00075;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-lastfm {\n  background-color: #e21b24;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-linkedin {\n  background-color: #0d66c2;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-mastodon {\n  background-color: #3288d4;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-medium {\n  background-color: #02ab6c;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-meetup {\n  background-color: #f6405f;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-patreon {\n  background-color: #000;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-pinterest {\n  background-color: #e60122;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-pocket {\n  background-color: #ef4155;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-reddit {\n  background-color: #ff4500;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-skype {\n  background-color: #0478d7;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-snapchat {\n  background-color: #fefc00;\n  color: #fff;\n  stroke: #000;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-soundcloud {\n  background-color: #ff5600;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-spotify {\n  background-color: #1bd760;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-telegram {\n  background-color: #2aabee;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-threads,\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-tiktok {\n  background-color: #000;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-tumblr {\n  background-color: #011835;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-twitch {\n  background-color: #6440a4;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-twitter {\n  background-color: #1da1f2;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-vimeo {\n  background-color: #1eb7ea;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-vk {\n  background-color: #4680c2;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-wordpress {\n  background-color: #3499cd;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-whatsapp {\n  background-color: #25d366;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-x {\n  background-color: #000;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-yelp {\n  background-color: #d32422;\n  color: #fff;\n}\n\n.wp-block-social-links:not(.is-style-logos-only) .wp-social-link-youtube {\n  background-color: red;\n  color: #fff;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link {\n  background: none;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link a {\n  padding: 0;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link svg {\n  height: 1.25em;\n  width: 1.25em;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-amazon {\n  color: #f90;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-bandcamp {\n  color: #1ea0c3;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-behance {\n  color: #0757fe;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-codepen {\n  color: #1e1f26;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-deviantart {\n  color: #02e49b;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-dribbble {\n  color: #e94c89;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-dropbox {\n  color: #4280ff;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-etsy {\n  color: #f45800;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-facebook {\n  color: #1778f2;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-fivehundredpx {\n  color: #000;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-flickr {\n  color: #0461dd;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-foursquare {\n  color: #e65678;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-github {\n  color: #24292d;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-goodreads {\n  color: #382110;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-google {\n  color: #ea4434;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-gravatar {\n  color: #1d4fc4;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-instagram {\n  color: #f00075;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-lastfm {\n  color: #e21b24;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-linkedin {\n  color: #0d66c2;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-mastodon {\n  color: #3288d4;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-medium {\n  color: #02ab6c;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-meetup {\n  color: #f6405f;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-patreon {\n  color: #000;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-pinterest {\n  color: #e60122;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-pocket {\n  color: #ef4155;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-reddit {\n  color: #ff4500;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-skype {\n  color: #0478d7;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-snapchat {\n  color: #fff;\n  stroke: #000;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-soundcloud {\n  color: #ff5600;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-spotify {\n  color: #1bd760;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-telegram {\n  color: #2aabee;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-threads,\n.wp-block-social-links.is-style-logos-only .wp-social-link-tiktok {\n  color: #000;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-tumblr {\n  color: #011835;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-twitch {\n  color: #6440a4;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-twitter {\n  color: #1da1f2;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-vimeo {\n  color: #1eb7ea;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-vk {\n  color: #4680c2;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-whatsapp {\n  color: #25d366;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-wordpress {\n  color: #3499cd;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-x {\n  color: #000;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-yelp {\n  color: #d32422;\n}\n\n.wp-block-social-links.is-style-logos-only .wp-social-link-youtube {\n  color: red;\n}\n\n.wp-block-social-links.is-style-pill-shape .wp-social-link {\n  width: auto;\n}\n\n.wp-block-social-links.is-style-pill-shape .wp-social-link a {\n  padding-left: 0.66667em;\n  padding-right: 0.66667em;\n}\n\n.wp-block-social-links:not(.has-icon-color):not(.has-icon-background-color)\n  .wp-social-link-snapchat\n  .wp-block-social-link-label {\n  color: #000;\n}\n\n.wp-block-spacer {\n  clear: both;\n}\n\n.wp-block-tag-cloud {\n  box-sizing: border-box;\n}\n\n.wp-block-tag-cloud.aligncenter {\n  justify-content: center;\n  text-align: center;\n}\n\n.wp-block-tag-cloud.alignfull {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n\n.wp-block-tag-cloud a {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.wp-block-tag-cloud span {\n  display: inline-block;\n  margin-left: 5px;\n  text-decoration: none;\n}\n\n.wp-block-tag-cloud.is-style-outline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1ch;\n}\n\n.wp-block-tag-cloud.is-style-outline a {\n  border: 1px solid;\n  font-size: unset !important;\n  margin-right: 0;\n  padding: 1ch 2ch;\n  text-decoration: none !important;\n}\n\n.wp-block-table {\n  overflow-x: auto;\n}\n\n.wp-block-table table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.wp-block-table thead {\n  border-bottom: 3px solid;\n}\n\n.wp-block-table tfoot {\n  border-top: 3px solid;\n}\n\n.wp-block-table td,\n.wp-block-table th {\n  border: 1px solid;\n  padding: 0.5em;\n}\n\n.wp-block-table .has-fixed-layout {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.wp-block-table .has-fixed-layout td,\n.wp-block-table .has-fixed-layout th {\n  word-break: break-word;\n}\n\n.wp-block-table.aligncenter,\n.wp-block-table.alignleft,\n.wp-block-table.alignright {\n  display: table;\n  width: auto;\n}\n\n.wp-block-table.aligncenter td,\n.wp-block-table.aligncenter th,\n.wp-block-table.alignleft td,\n.wp-block-table.alignleft th,\n.wp-block-table.alignright td,\n.wp-block-table.alignright th {\n  word-break: break-word;\n}\n\n.wp-block-table .has-subtle-light-gray-background-color {\n  background-color: #f3f4f5;\n}\n\n.wp-block-table .has-subtle-pale-green-background-color {\n  background-color: #e9fbe5;\n}\n\n.wp-block-table .has-subtle-pale-blue-background-color {\n  background-color: #e7f5fe;\n}\n\n.wp-block-table .has-subtle-pale-pink-background-color {\n  background-color: #fcf0ef;\n}\n\n.wp-block-table.is-style-stripes {\n  background-color: initial;\n  border-bottom: 1px solid #f0f0f0;\n  border-collapse: inherit;\n  border-spacing: 0;\n}\n\n.wp-block-table.is-style-stripes tbody tr:nth-child(odd) {\n  background-color: #f0f0f0;\n}\n\n.wp-block-table.is-style-stripes.has-subtle-light-gray-background-color\n  tbody\n  tr:nth-child(odd) {\n  background-color: #f3f4f5;\n}\n\n.wp-block-table.is-style-stripes.has-subtle-pale-green-background-color\n  tbody\n  tr:nth-child(odd) {\n  background-color: #e9fbe5;\n}\n\n.wp-block-table.is-style-stripes.has-subtle-pale-blue-background-color\n  tbody\n  tr:nth-child(odd) {\n  background-color: #e7f5fe;\n}\n\n.wp-block-table.is-style-stripes.has-subtle-pale-pink-background-color\n  tbody\n  tr:nth-child(odd) {\n  background-color: #fcf0ef;\n}\n\n.wp-block-table.is-style-stripes td,\n.wp-block-table.is-style-stripes th {\n  border-color: #0000;\n}\n\n.wp-block-table .has-border-color td,\n.wp-block-table .has-border-color th,\n.wp-block-table .has-border-color tr,\n.wp-block-table .has-border-color > * {\n  border-color: inherit;\n}\n\n.wp-block-table table[style*=\"border-top-color\"] tr:first-child,\n.wp-block-table table[style*=\"border-top-color\"] tr:first-child td,\n.wp-block-table table[style*=\"border-top-color\"] tr:first-child th,\n.wp-block-table table[style*=\"border-top-color\"] > *,\n.wp-block-table table[style*=\"border-top-color\"] > * td,\n.wp-block-table table[style*=\"border-top-color\"] > * th {\n  border-top-color: inherit;\n}\n\n.wp-block-table table[style*=\"border-top-color\"] tr:not(:first-child) {\n  border-top-color: initial;\n}\n\n.wp-block-table table[style*=\"border-right-color\"] td:last-child,\n.wp-block-table table[style*=\"border-right-color\"] th,\n.wp-block-table table[style*=\"border-right-color\"] tr,\n.wp-block-table table[style*=\"border-right-color\"] > * {\n  border-right-color: inherit;\n}\n\n.wp-block-table table[style*=\"border-bottom-color\"] tr:last-child,\n.wp-block-table table[style*=\"border-bottom-color\"] tr:last-child td,\n.wp-block-table table[style*=\"border-bottom-color\"] tr:last-child th,\n.wp-block-table table[style*=\"border-bottom-color\"] > *,\n.wp-block-table table[style*=\"border-bottom-color\"] > * td,\n.wp-block-table table[style*=\"border-bottom-color\"] > * th {\n  border-bottom-color: inherit;\n}\n\n.wp-block-table table[style*=\"border-bottom-color\"] tr:not(:last-child) {\n  border-bottom-color: initial;\n}\n\n.wp-block-table table[style*=\"border-left-color\"] td:first-child,\n.wp-block-table table[style*=\"border-left-color\"] th,\n.wp-block-table table[style*=\"border-left-color\"] tr,\n.wp-block-table table[style*=\"border-left-color\"] > * {\n  border-left-color: inherit;\n}\n\n.wp-block-table table[style*=\"border-style\"] td,\n.wp-block-table table[style*=\"border-style\"] th,\n.wp-block-table table[style*=\"border-style\"] tr,\n.wp-block-table table[style*=\"border-style\"] > * {\n  border-style: inherit;\n}\n\n.wp-block-table table[style*=\"border-width\"] td,\n.wp-block-table table[style*=\"border-width\"] th,\n.wp-block-table table[style*=\"border-width\"] tr,\n.wp-block-table table[style*=\"border-width\"] > * {\n  border-style: inherit;\n  border-width: inherit;\n}\n\n:where(.wp-block-term-description) {\n  margin-bottom: var(--wp--style--block-gap);\n  margin-top: var(--wp--style--block-gap);\n}\n\n.wp-block-term-description p {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.wp-block-text-columns,\n.wp-block-text-columns.aligncenter {\n  display: flex;\n}\n\n.wp-block-text-columns .wp-block-column {\n  margin: 0 1em;\n  padding: 0;\n}\n\n.wp-block-text-columns .wp-block-column:first-child {\n  margin-left: 0;\n}\n\n.wp-block-text-columns .wp-block-column:last-child {\n  margin-right: 0;\n}\n\n.wp-block-text-columns.columns-2 .wp-block-column {\n  width: 50%;\n}\n\n.wp-block-text-columns.columns-3 .wp-block-column {\n  width: 33.33333%;\n}\n\n.wp-block-text-columns.columns-4 .wp-block-column {\n  width: 25%;\n}\n\npre.wp-block-verse {\n  overflow: auto;\n  white-space: pre-wrap;\n}\n\n:where(pre.wp-block-verse) {\n  font-family: inherit;\n}\n\n.wp-block-video {\n  box-sizing: border-box;\n}\n\n.wp-block-video video {\n  vertical-align: middle;\n  width: 100%;\n}\n\n@supports (position: sticky) {\n  .wp-block-video [poster] {\n    object-fit: cover;\n  }\n}\n\n.wp-block-video.aligncenter {\n  text-align: center;\n}\n\n.wp-block-video figcaption {\n  margin-bottom: 1em;\n  margin-top: 0.5em;\n}\n\n.editor-styles-wrapper,\n.entry-content {\n  counter-reset: footnotes;\n}\n\na[data-fn].fn {\n  counter-increment: footnotes;\n  display: inline-flex;\n  font-size: smaller;\n  text-decoration: none;\n  text-indent: -9999999px;\n  vertical-align: super;\n}\n\na[data-fn].fn:after {\n  content: \"[\" counter(footnotes) \"]\";\n  float: left;\n  text-indent: 0;\n}\n\n.wp-element-button {\n  cursor: pointer;\n}\n\n:root {\n  --wp--preset--font-size--normal: 16px;\n  --wp--preset--font-size--huge: 42px;\n}\n\n:root .has-very-light-gray-background-color {\n  background-color: #eee;\n}\n\n:root .has-very-dark-gray-background-color {\n  background-color: #313131;\n}\n\n:root .has-very-light-gray-color {\n  color: #eee;\n}\n\n:root .has-very-dark-gray-color {\n  color: #313131;\n}\n\n:root .has-vivid-green-cyan-to-vivid-cyan-blue-gradient-background {\n  background: linear-gradient(135deg, #00d084, #0693e3);\n}\n\n:root .has-purple-crush-gradient-background {\n  background: linear-gradient(135deg, #34e2e4, #4721fb 50%, #ab1dfe);\n}\n\n:root .has-hazy-dawn-gradient-background {\n  background: linear-gradient(135deg, #faaca8, #dad0ec);\n}\n\n:root .has-subdued-olive-gradient-background {\n  background: linear-gradient(135deg, #fafae1, #67a671);\n}\n\n:root .has-atomic-cream-gradient-background {\n  background: linear-gradient(135deg, #fdd79a, #004a59);\n}\n\n:root .has-nightshade-gradient-background {\n  background: linear-gradient(135deg, #330968, #31cdcf);\n}\n\n:root .has-midnight-gradient-background {\n  background: linear-gradient(135deg, #020381, #2874fc);\n}\n\n.has-regular-font-size {\n  font-size: 1em;\n}\n\n.has-larger-font-size {\n  font-size: 2.625em;\n}\n\n.has-normal-font-size {\n  font-size: var(--wp--preset--font-size--normal);\n}\n\n.has-huge-font-size {\n  font-size: var(--wp--preset--font-size--huge);\n}\n\n.has-text-align-center {\n  text-align: center;\n}\n\n.has-text-align-left {\n  text-align: left;\n}\n\n.has-text-align-right {\n  text-align: right;\n}\n\n#end-resizable-editor-section {\n  display: none;\n}\n\n.aligncenter {\n  clear: both;\n}\n\n.items-justified-left {\n  justify-content: flex-start;\n}\n\n.items-justified-center {\n  justify-content: center;\n}\n\n.items-justified-right {\n  justify-content: flex-end;\n}\n\n.items-justified-space-between {\n  justify-content: space-between;\n}\n\n.screen-reader-text {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  word-wrap: normal !important;\n}\n\n.screen-reader-text:focus {\n  background-color: #ddd;\n  clip: auto !important;\n  -webkit-clip-path: none;\n  clip-path: none;\n  color: #444;\n  display: block;\n  font-size: 1em;\n  height: auto;\n  left: 5px;\n  line-height: normal;\n  padding: 15px 23px 14px;\n  text-decoration: none;\n  top: 5px;\n  width: auto;\n  z-index: 100000;\n}\n\nhtml :where(.has-border-color) {\n  border-style: solid;\n}\n\nhtml :where([style*=\"border-top-color\"]) {\n  border-top-style: solid;\n}\n\nhtml :where([style*=\"border-right-color\"]) {\n  border-right-style: solid;\n}\n\nhtml :where([style*=\"border-bottom-color\"]) {\n  border-bottom-style: solid;\n}\n\nhtml :where([style*=\"border-left-color\"]) {\n  border-left-style: solid;\n}\n\nhtml :where([style*=\"border-width\"]) {\n  border-style: solid;\n}\n\nhtml :where([style*=\"border-top-width\"]) {\n  border-top-style: solid;\n}\n\nhtml :where([style*=\"border-right-width\"]) {\n  border-right-style: solid;\n}\n\nhtml :where([style*=\"border-bottom-width\"]) {\n  border-bottom-style: solid;\n}\n\nhtml :where([style*=\"border-left-width\"]) {\n  border-left-style: solid;\n}\n\nhtml :where(img[class*=\"wp-image-\"]) {\n  height: auto;\n  max-width: 100%;\n}\n\n:where(figure) {\n  margin: 0 0 1em;\n}\n\nhtml :where(.is-position-sticky) {\n  --wp-admin--admin-bar--position-offset: var(\n    --wp-admin--admin-bar--height,\n    0px\n  );\n}\n\n@media screen and (max-width: 600px) {\n  html :where(.is-position-sticky) {\n    --wp-admin--admin-bar--position-offset: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
